webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* globals DEBUG */
	
	/* manually bootstrap app once translations are determined */
	(function resolveBootstrap() {
	
	    loadAppAsync()
			.then(function(resolvedLang){ bootstrapApp(resolvedLang); });
	
	    function loadAppAsync() {
			
	        var initInjector = angular.injector(['ng', 'phoenix', 'site.settings','gettext']);
	        var $http = initInjector.get('$http');
	        var pxEnvironmentService = initInjector.get('pxEnvironmentService');
	        var settingsService = initInjector.get('settingsService');
	        var gettextCatalog = initInjector.get('gettextCatalog');
	
			// determine the current locale and use angular-gettext to get the
			// correct catalog strings. Also use this info to set the proper path to the
			// terms and conditions (legalLanguage)
			return pxEnvironmentService.loadLanguages()
				.then(function(language){
					language = language.toLowerCase();
					if (language === 'en' || language === 'en-us') {
						return 'en';
					}
	
					return gettextCatalog.loadRemote('lang/' + language + '.json')
						.then(function(){
							return gettextCatalog.loadRemote('lang/sharebase/' + language + '.json');
						})
						.then(function(){
							return language;
						})
						.catch(function(){
							return 'en';
						});
				})
				.then(function(language) {
					gettextCatalog.setCurrentLanguage(language);
	
					var tosPath = '/' + language + '/terms-of-use-and-subscription/index.htm';
					return $http.head(settingsService.serverLegalPath + tosPath)
						.then(function() {
							pxEnvironmentService.legalLanguage = language;
							return {lang: gettextCatalog.currentLanguage, legalLang: language, strings: gettextCatalog.strings };
						})
						.catch(function() {
							pxEnvironmentService.legalLanguage = 'en';
							return {lang: gettextCatalog.currentLanguage, legalLang: 'en', strings: gettextCatalog.strings };
						});
				});
	
	    }
	
	    function bootstrapApp(resolvedLang) {
			/* we create a new module 
			 *		- config block to generate MD themes on app load
			 *		- run block to set the resolved language/strings
			 *		- depend on original auto bootstrap module - smb-app.app
			 */
			angular.module('asyncAppLoader',['smb-app.app'])
				.config(['$mdThemingProvider',	function ($mdThemingProvider) {						
					//seems mdThemes are not generated during manual bootstrap, so allow themes to be generated after config block
					$mdThemingProvider.generateThemesOnDemand(true);
				}])
				.run([
					'gettextCatalog',
					'pxEnvironmentService',
					function(gettextCatalog, pxEnvironmentService){					
						//set resolved language
						if(resolvedLang){
							gettextCatalog.setCurrentLanguage(resolvedLang.lang);
							gettextCatalog.strings = resolvedLang.strings;
							pxEnvironmentService.legalLanguage =  resolvedLang.legalLang;
						}
				}]);
	
			//now bootstrap app
	        angular.element(document).ready(function() {
	           angular.bootstrap(document, ['asyncAppLoader']);			
	        });
	    }
	}());
	
	(function () {
		'use strict';
		angular.module('smb-app',
			[
				'ngMaterial',
				'ui.router',
				'ngMessages',
				'site.settings',
				'phoenix',
				'phoenix.acl',
				'phoenix.appIdentifier',
				'sharebase',
				'gettext'
			])
			.config([
				'$mdThemingProvider',
				function ($mdThemingProvider) {
					//color theme declarations
					//http://www.google.com/design/spec/style/color.html#color-color-palette
					$mdThemingProvider.definePalette('sharebase', {
						'50': '00586E',
						'100': '7fdcf2',
						'200': 'ebf2f3',
						'300': '00586E',
						'400': '00586E',
						'500': '00586E',
						'600': '00586E',
						'700': '00586E',
						'800': '00586E',
						'900': '00586E',
						'A100': '00586E',
						'A200': '00cbee',
						'A400': '00cbee',
						'A700': '00cbee',
						'contrastDefaultColor': 'dark'   // whether, by default, text (contrast)
					});
	
					$mdThemingProvider.theme('sharebase')
						.primaryPalette('sharebase', {
							'default': '50',
							'hue-1': '100',
							'hue-2': '200',
							'hue-3': 'A100'
						})
						.accentPalette('blue', {
							'hue-1': '50',
							'hue-2': '100',
							'hue-3': 'A100'
						})
						.warnPalette('red', {
							'default': '500',
							'hue-1': '100',
							'hue-2': '700',
							'hue-3': 'A100'
						});
				}
			])
			.run([
				'gettextCatalog',
				function(gettextCatalog){
					if (false) {
						gettextCatalog.showTranslatedMarkers = true;
					}
					
			}])
			.controller('smbAppController', ['pxProgressService', 'smbEnvironmentService', '$mdTheming', AppController]);
	
		function AppController(pxProgressService, smbEnvironmentService, $mdTheming) {
			var vm = this;
			//generate the predefined theme named sharebase
			$mdTheming.generateTheme('sharebase');
	
			vm.environment = smbEnvironmentService;
			vm.progressUI = pxProgressService;
		}
	}());
	
	__webpack_require__(21);
	__webpack_require__(89);
	__webpack_require__(125);
	__webpack_require__(154);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	var path = 'components/userSelectorDialog/userSelectorDialog.template.html';
	var html = "<md-dialog class=smb-user-select-dialog ng-style=vm.style> <md-dialog-content class=smb-user-select-dialog__content> <smb-item-selector class=smb-app--selction-disabled multiple=vm.multiple items=vm.users></smb-item-selector> </md-dialog-content> <div class=smb-user-select-dialog__buttons layout=row layout-align=\"end center\" ng-class=\"{'hasFilter': vm.fullItems.length > 19, 'showFilter': vm.showFilter }\"> <md-input-container class=\"md-icon-float md-block filter-input smb-app-animate--slide-in smb-app-animate--fade-in\" ng-if=vm.showFilter md-no-float> <input ng-model=vm.filterPhrase ng-model-options=\"{ debounce: 600 }\" ng-change=vm.filter() type=text placeholder=Filter md-autofocus> </md-input-container> <div style=width:164px layout=row layout-align=\"end center\"> <md-button class=\"md-icon-button filter-button\" ng-if=\"vm.fullItems.length > 19\" ng-click=\"vm.showFilter = !vm.showFilter\"> <md-icon class=material-icons>filter_list</md-icon> </md-button> <md-button class=md-icon-button ng-click=vm.add()> <md-icon class=material-icons>done</md-icon> </md-button> <md-button class=md-icon-button ng-click=vm.cancel()> <md-icon class=material-icons>clear</md-icon> </md-button> </div> </div> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./assets/airbaselogo.929f20.png";

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	var path = 'services/deleteDialogService/deleteDialog.template.html';
	var html = "<md-dialog> <md-dialog-content class=md-dialog-content> <h2 class=md-title>{{vm.title}}</h2> <p>{{vm.message}}</p> <p translate ng-if=\"vm.showPurgeOption && vm.purgeText\"><strong>{{vm.purgeText}}</strong></p> <md-checkbox ng-if=vm.showPurgeOption ng-model=vm.permanentlyDelete aria-label=\"{{::'Permanently Delete' | translate}}\"> {{::'Permanently Delete' | translate}} </md-checkbox> </md-dialog-content> <md-dialog-actions> <md-button ng-click=vm.cancel()> <translate>Cancel</translate> </md-button> <md-button ng-click=vm.delete() md-autofocus> <translate>Delete</translate> </md-button> </md-dialog-actions> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
57,
/* 22 */
57,
/* 23 */
57,
/* 24 */
57,
/* 25 */
57,
/* 26 */
57,
/* 27 */
57,
/* 28 */
57,
/* 29 */
57,
/* 30 */
57,
/* 31 */
57,
/* 32 */
57,
/* 33 */
57,
/* 34 */
57,
/* 35 */
57,
/* 36 */
57,
/* 37 */
57,
/* 38 */
57,
/* 39 */
57,
/* 40 */
57,
/* 41 */
57,
/* 42 */
57,
/* 43 */
57,
/* 44 */
57,
/* 45 */
57,
/* 46 */
57,
/* 47 */
57,
/* 48 */
57,
/* 49 */
57,
/* 50 */
57,
/* 51 */
57,
/* 52 */
57,
/* 53 */
57,
/* 54 */
57,
/* 55 */
57,
/* 56 */
57,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app.app', [
				'smb-app'
			])
			.run([
				'$rootScope', 
				'$state', 
				'$injector', 
				'pxAuthService', 
				'smbPanelDetailsDataStore',
				function ($rootScope, $state, $injector, pxAuthService, smbPanelDetailsDataStore) {
				
				$rootScope.$on('$stateChangeStart', function (e, to) {
					// closes side panel for any route that does not explicitly
					// support side panel, this makes sure side panels get closed
					// on state changes
					if (!(to.data && to.data.hasSidePanel)) {
						smbPanelDetailsDataStore.reset();
					}
	
					var rule = to.data ? to.data.rule : null;
					var redirect;
	
					// If user is not authenticated, they can only reach the login and register states
					if (!pxAuthService.isAuthenticated && !(to.parent === 'loginComponent' || to.name === 'register')) {
						redirect = {
							to: 'login'
						};
					} else if (angular.isFunction(rule)) {
						redirect = rule($injector);
					}
	
					if (redirect && redirect.to !== to.name) {
						e.preventDefault();
						$state.go(redirect.to, redirect.params, { reload: redirect.to === $state.current.name });
					}
				});
			}])
			.config([
				'$urlRouterProvider',
				'$stateProvider',
				'$httpProvider',
				'pxAppIdentifierInterceptorProvider',
				function ($urlRouterProvider, $stateProvider, $httpProvider, pxAppIdentifierInterceptorProvider) {
					pxAppIdentifierInterceptorProvider.setAppId('AirBase');
	
					if (!$httpProvider.defaults.headers.get) {
						$httpProvider.defaults.headers.get = {};
					}
	
					//disable IE ajax request caching
	    			$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
	
					//http intercepetors
					$httpProvider.interceptors.push('pxAuthInterceptor');
					$httpProvider.interceptors.push('pxAppIdentifierInterceptor');
					
					// defualt state
					$urlRouterProvider.otherwise('/');
	
					//state definitions
					$stateProvider
						.state('register', {
							url: '/register/:deploymentId?auth',
							views: {
								main: {
									template: function(params) {
										return '<smb-register deployment-id="' + params.deploymentId + '" auth-token="' + params.auth + '"></smb-register>';
									}
								}
							}
						})
						.state('loginComponent', {
							abstract: true,
							url: '',
							views: {
								'main': { template: '<smb-login />' }
							}
						})
						.state('content', {
							abstract: true,
							url: '/',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							}
						})
						.state('content.home', {
							url: '',
							views: {
								'app': { template: '<smb-home></smb-home>' }
							}
						})
						.state('useradmin', {
							abstract: true,
							url: '/useradmin',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							},
							data: {
								rule: inject(['pxAuthService', function (pxAuthService) {
									// only site admins and user admins can access these pages
									if (!pxAuthService.isSiteAdmin && !pxAuthService.isUserAdmin) {
										return {
											to: 'content.home'
										};
									}
								}])
							}
						})
						.state('useradmin.home', {
							url: '',
							views: {
								'app': { template: '<smb-user-administration/>' }
							}
						})
						.state('useradmin.home.usergroups', {
							url: '/usergroups',
							views: {
								'app@useradmin': { template: '<smbadmin-user-groups layout-fill />' }
							}
						})
						.state('useradmin.home.usergroups.details', {
							url: '/:usergroupId',
							views: {
								'app@useradmin': {
									template: function (params) {
										return '<smbadmin-user-group flex user-group-id="' + params.usergroupId + '" layout-fill />';
									}
								}
							}
						})
						.state('useradmin.home.users', {
							url: '/users',
							views: {
								'app@useradmin': { template: '<smbadmin-users layout-fill />' }
							}
						})
						.state('useradmin.home.users.details', {
							url: '/:userId',
							views: {
								'app@useradmin': {
									template: function (params) {
										return '<smbadmin-user flex user-id="' + params.userId + '" layout-fill />';
									}
								}
							}
						})
						.state('contentConfig', {
							abstract: true,
							url: '/contentconfiguration',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							},
							data: {
								rule: inject(['pxAuthService', function (pxAuthService) {
									// only site admins can access content configuration
									if (!pxAuthService.isSiteAdmin) {
										return {
											to: 'content.home'
										};
									}
								}])
							}
						})
						.state('contentConfig.groups', {
							url: '/contenttypegroups',
							views: {
								'app': { template: '<smb-content-type-groups-config />' }
							}
						})
						.state('contentConfig.groups.details', {
							url: '/:groupId',
							views: {
								'app@contentConfig': { template: function (params) { return '<smb-content-type-group-config group-id="' + params.groupId + '" />'; } }
							}
						})
						.state('contentConfig.types', {
							url: '/contenttypegroups/:groupId/contenttypes',
							views: {
								'app': {
									template: function (params) { return '<smb-content-types-config content-type-group-id="' + params.groupId + '" />'; }
								}
							}
						})
						.state('contentConfig.types.details', {
							url: '/:typeId',
							views: {
								'app@contentConfig': {
									template: function (params) { return '<smb-content-type-config content-type-group-id="' + params.groupId + '" content-type-id="' + params.typeId + '" />'; }
								}
							}
						})
						.state('documentTrash', {
							abstract: true,
							url: '/trash',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							},
							data: {
								rule: inject(['pxAuthService', function (pxAuthService) {
									var privs = pxAuthService.privileges;
									var hasTrashPriv = privs.core && privs.core.trash ?
										privs.core.trash.manageTrash :
										false;
	
									// only site admins can access content configuration
									if (!pxAuthService.isSiteAdmin && !hasTrashPriv) {
										return {
											to: 'content.home'
										};
									}
								}])
							}
						})
						.state('documentTrash.home', {
							url: '',
							views: {
								'app': { template: '<smb-trash />' }
							}
						})
						.state('import', {
							abstract: true,
							url: '/import',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							}
						})
						.state('import.contentTypeGroups', {
							url: '',
							views: {
								'app': { template: '<smb-content-type-groups/>' }
							}
						})
						.state('import.contentTypeGroups.contentTypes', {
							url: '/:groupId',
							views: {
								'app@import': {
									template: function (params) {
										return '<smb-content-types group-id="' + params.groupId + '" />';
									}
								}
							}
						})
						.state('import.contentTypeGroups.contentTypes.content', {
							url: '/:typeId',
							views: {
								'app@import': {
									template: function (params) {
										return '<smb-content content-type-group-id="' + params.groupId + '" content-type-id="' + params.typeId + '" />';
									}
								}
							}
						})
						.state('search', {
							abstract: true,
							url: '/search',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							}
						})
						.state('search.contentTypeGroups', {
							url: '',
							views: {
								'app': { template: '<smb-content-type-groups-search/>' }
							}
						})
						.state('search.contentTypeGroups.contentTypes', {
							url: '/:groupId',
							views: {
								'app@search': {
									template: function (params) {
										return '<smb-content-types-search group-id="' + params.groupId + '" />';
									}
								}
							}
						})
						.state('search.contentTypeGroups.contentTypes.groupSearch', {
							url: '/all',
							views: {
								'app@search': {
									template: function (params) {
										return '<smb-content-type-group-search group-id="' + params.groupId + '" />';
									}
								}
							}
						})
						.state('search.contentTypeGroups.contentTypes.groupSearch.results', {
							url: '/results',
							views: {
								'app@search': {
									template: function (params) {
										return '<smb-content-type-group-search-results group-id="' + params.groupId + '" />';
									}
								}
							}
						})
						.state('search.contentTypeGroups.contentTypes.search', {
							url: '/:typeId',
							views: {
								'app@search': {
									template: function (params) {
										return '<smb-content-search group-id="' + params.groupId + '" type-id="' + params.typeId + '" />';
									}
								}
							}
						})
						.state('search.contentTypeGroups.contentTypes.search.results', {
							url: '/results',
							views: {
								'app@search': {
									template: function (params) {
										return '<smb-content-search-results group-id="' + params.groupId + '" type-id="' + params.typeId + '" />';
									}
								}
							}
						})
						.state('todo', {
							abstract: true,
							url: '/mytodolist',
							views: {
								'main': { template: '<smb-main></smb-main>' }
							}
						})
						.state('todo.list', {
							url: '',
							views: {
								'app': { template: '<smb-to-do-list></smb-to-do-list>'}
							}
						})
						.state('document', {
							url: '/documentgroups/:documentGroupId/documenttypes/:documentTypeId/documents/:documentId',
							abstract: true,
							views: {
								main: {
									template: '<smb-main></smb-main>'
								}
							}
						})
						.state('document.view', {
							url: '',
							views: {
								app: {
									template: function(params) {
										return '<smb-document-view previous-state="' + params.previous + '" document-group-id="' + params.documentGroupId + '" document-type-id="' + params.documentTypeId + '" document-id="' + params.documentId + '"></smb-document-view>';
									}
								}
							}
						});
	
					function inject() {
						var injectionArgs = arguments;
						return function injectableWrapper($injector) {
							$injector = $injector || angular.injector(['ng']);
	
							return $injector.invoke.apply($injector, injectionArgs);
						};
					}
				}
			])
			// This is from the demo and will eventually be removed. We will need to discuss theming items.
			// This maps a number to a color and is used in various components that list items to color them by
			// the list index.
			/* jshint maxcomplexity:12 */
			.filter('colorFilter', function () {
				return function (position) {
					position = (position % 11) + 1;
					switch (position) {
						case 1:
							return 'blue';
						case 2:
							return 'green';
						case 3:
							return 'lightBlue';
						case 4:
							return 'yellow';
						case 5:
							return 'onbaseBlue';
						case 6:
							return 'lightGreen';
						case 7:
							return 'sharebaseBlue';
						case 8:
							return 'orange';
						case 9:
							return 'gray';
						case 10:
							return 'darkGreen';
						case 11:
							return 'yellow';
						default:
							return 'green';
					}
				};
			})
			// Removes div elements and precedes the text that was previously
			// contained in the div with a br element
			.filter('lineBreak', function() {
				return function(text) {
					return text
						.split('<div><br></div>').join('<br>')
						.split('<div>').join('<br>')
						.split('</div>').join('');
				};
			})
			// Escapes html in text so it can be used with the ng-bind-html directive
			.filter('trustHTML', ['$sce', function($sce) {
				return function(htmlCode) {
					return $sce.trustAsHtml(htmlCode);
				};
			}])
			.directive('smbMain',
			[
				MainDirective
			])
			.controller('MainController',
			[
				'$window',
				'$state',
				'smbToDoListDataStore',
				'smbPanelDetailsDataStore',
				'smbToolbarService',
				'pxAuthService',
				'pxEnvironmentService',
				MainController
			]);
	
		var templateUrl = __webpack_require__(163);
		function MainDirective() {
			return {
				restrict: 'E',
				controller: MainController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function MainController($window, $state, smbToDoListDataStore, smbPanelDetailsDataStore, smbToolbarService, pxAuthService, pxEnvironmentService) {
			var vm = this;		
			vm.todoListDS = smbToDoListDataStore;
	
			// Wrap in check to make sure user is authenticated, because this controller
			// may be created before user logs in
			if (pxAuthService.isAuthenticated) {
				vm.todoListDS.loadCount();
				vm.todoListDS.init();
			}
	
			vm.logout = logout;
			vm.openLink = openLink;
			vm.isUserAdmin = isUserAdmin;
			vm.isContentAdmin = isContentAdmin;
			vm.smbToolbarService = smbToolbarService;
			vm.panelDetailsDS = smbPanelDetailsDataStore;
			vm.pxEnvironmentService = pxEnvironmentService;
			vm.userName = pxAuthService.displayName;
			vm.privileges = pxAuthService.privileges;
			vm.isSiteAdmin = pxAuthService.isSiteAdmin;
	
			// flag that determines if the mobile navigation
			// via a sidebar is open or closed
			vm.mobileNavOpen = false;
	
			vm.onClickBackArrow = onClickBackArrow;
	
			function isUserAdmin() {
				return smbToolbarService.hasUserAdminRights;
			}
	
			function isContentAdmin() {
				return smbToolbarService.hasContentAdminRights;
			}
	
			function logout() {
				pxAuthService.invalidateLogin();
				vm.todoListDS.clear();
				$state.go('login');
			}
	
			function onClickBackArrow() {
				$state.go(vm.smbToolbarService.backArrowState, vm.smbToolbarService.backArrowStateParams);
			}
	
			function openLink(url) {
				$window.open(url,'_blank');
			}
		}
	}());

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbAssignedUsers',[AssignedUsersDirective])
			.controller('AssignedUsersController', [
				AssignedUsersController
			]);
	
		var templateUrl = __webpack_require__(164);
		function AssignedUsersDirective() {
			return {
				restrict: 'E',
				controller: AssignedUsersController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					assignedUsers: '=',
					selectedUser: '=',
					isContentStatusSelected: '='
				}
			};
		}
	
		function AssignedUsersController() {
			var vm = this;
			vm.onChange = onChange;
	
			function onChange() {
				if (vm.selectedUser === '') {
					vm.selectedUser = undefined;
				}
			}
		}
	}());

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentSearch', [ContentSearchDirective])
			.controller('ContentSearchController',
			[
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbStatusDataStore',
				'smbUsersDataStore',
				'smbIndexTypesDataStore',
				'smbContentSearchDataStore',
				'smbContentTypeGroupConfigDataStore',
				'smbContentTypeConfigDataStore',
				'smbIconTypes',
				ContentSearchController
			]);
	
		var templateUrl = __webpack_require__(165);
		function ContentSearchDirective() {
			return {
				restrict: 'E',
				controller: ContentSearchController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					groupId: '@',
					typeId: '@'
				},
				scope: {}
			};
		}
	
		function ContentSearchController($state, gettextCatalog, pxProgressService, smbToolbarService, smbStatusDataStore, smbUsersDataStore, smbIndexTypesDataStore,
											smbContentSearchDataStore, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes) {
	
			smbToolbarService.set(gettextCatalog.getString('Search Document Type'), 'search.contentTypeGroups.contentTypes');
	
			var vm = this;
			var ARCHIVAL_STATUS = 'Archival Status';
			var TODO_STATUS = 'ToDo Status';
	
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
	
			vm.docDateStart = new Date();
			vm.docDateEnd = new Date();
	
			vm.search = search;
	
			vm.contentTypeDS = smbContentTypeConfigDataStore;
			vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
			vm.indexTypesDS = smbIndexTypesDataStore;
			vm.statusDS = smbStatusDataStore;
			vm.usersDS = smbUsersDataStore;
			vm.filename = null;
	
			vm.indextypes = [];
			vm.contentStatuses = [];
			vm.todoStatuses = [];
			vm.status = null;
			vm.selectedUser = null;
			vm.isContentStatusSelected = false;
			vm.onStatusChange = onStatusChange;
	
			vm.indexFileChanged = indexFileChanged;
	
			function indexFileChanged(fileInput) {
				if (fileInput.files.length === 0) {
					return;
				}
				vm.filename = fileInput.files[0].name;
			}
	
			vm.contentTypeGroupDS.getContentTypeGroup(vm.groupId)
			.then(function () {
				vm.contentTypeDS.getContentType(vm.groupId, vm.typeId);
			})
			.then(function () {
				vm.indexTypesDS.getIndexTypes(vm.typeId).then(function () {
					vm.indextypes = vm.indexTypesDS.indexTypes.map(function(it) {
						return angular.extend({}, it, {defaultValue: undefined});
					});
				});
			})
			.then(function() {
				return vm.statusDS.loadStatuses(vm.typeId);
			})
			.then(function() {
				vm.contentStatuses = [];
				if (vm.statusDS.contentStatus[0]) {
					vm.contentStatuses = vm.statusDS.contentStatus[0].Constraints.DataSetValues.map(function(s) {
						return {TagTypeId: vm.statusDS.contentStatus[0].TagTypeId, indexValue: s, type: ARCHIVAL_STATUS};
					});
				}
				vm.todoStatuses = [];
				if (vm.statusDS.todoStatus[0]) {
					vm.todoStatuses = vm.statusDS.todoStatus[0].Constraints.DataSetValues.map(function(s) {
						return {TagTypeId: vm.statusDS.todoStatus[0].TagTypeId, indexValue: s, type: TODO_STATUS};
					});
				}
			})
			.then(function() {
				return vm.usersDS.getUsers();
			});
	
			function onStatusChange() {
				if (vm.status) {
					var Status = JSON.parse(vm.status);
					if (Status.type === ARCHIVAL_STATUS) {
						vm.isContentStatusSelected = true;
					}
					else {
						vm.isContentStatusSelected = false;
					}
				}
				else {
					vm.isContentStatusSelected = false;
					vm.status = undefined;
				}
			}
	
			function search() {
				if (vm.status) {
					vm.status = JSON.parse(vm.status);
					vm.indextypes.push({TagTypeId: vm.status.TagTypeId, indexValue: vm.status.indexValue});
				}
				if (vm.selectedUser && !vm.isContentStatusSelected) {
					vm.selectedUser = JSON.parse(vm.selectedUser);
					vm.indextypes.push({TagTypeId: vm.indexTypesDS.assignedUserId, indexValue: vm.selectedUser.UserId});
				}
				smbContentSearchDataStore.setTagValues(vm.indextypes);
				$state.go('search.contentTypeGroups.contentTypes.search.results',{ groupId: vm.groupId, typeId: vm.typeId });
			}
		}
	}());


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentSearchResults', [ContentSearchResultsDirective])
			.controller('ContentSearchResultsController',
			[
				'gettextCatalog',
				'smbToolbarService',
				'smbContentTypeGroupConfigDataStore',
				'smbContentTypeConfigDataStore',
				'smbIconTypes',
				'smbContentSearchDataStore',
				'smbDocumentViewerNavigationService',
				ContentSearchResultsController
			]);
	
		var templateUrl = __webpack_require__(166);
		function ContentSearchResultsDirective() {
			return {
				restrict: 'E',
				controller: ContentSearchResultsController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					groupId: '@',
					typeId: '@'
				}
			};
		}
	
		function ContentSearchResultsController(gettextCatalog, smbToolbarService, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes, smbContentSearchDataStore, smbDocumentViewerNavigationService) {
	
			smbToolbarService.set(gettextCatalog.getString('Search Results'), 'search.contentTypeGroups.contentTypes.search');
	
			var vm = this;
			vm.contentSearchDS = smbContentSearchDataStore;
			vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
			vm.contentTypeDS = smbContentTypeConfigDataStore;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.documentNavigation = smbDocumentViewerNavigationService;
	
			(function loadSearchResults() {
				smbContentSearchDataStore.getDocuments(vm.groupId, vm.typeId);
			})();
		}
	}());


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint maxstatements: false */
	(function () {
		'use strict';
	
		/**
		 * @ngdoc directive
		 * @name smb-app.smbContentTypeConfig
		 * @module smb-app
		 * @restrict E
		 *
		 * @description
		 * Displays a form that can be used for creating new content types or editing
		 * existing content types.
		 *
		 * @usage <caption>Create a new content type</caption>
		 *
		 * <smb-content-type-config content-type-group-id="11" />
		 *
		 * @usage <caption>Edit an existing content type</caption>
		 *
		 * <smb-content-type-config content-type-group-id="11" content-type-id="21" />
		 *
		 * @element input
		 * @param {number=} contentTypeGroupId Id of the content type group the content type belongs to
		 * @element input
		 * @param {number=} contentTypeId An optional id of an existing content type. If provided, the form
		 * will be used to edit the content type. If omitted, the form will be used to create a new content type.
		 */
	
		angular.module('smb-app')
			.directive('smbContentTypeConfig', ContentTypeConfigDirective)
			.controller('smbContentTypeConfigController', [
				'$scope',
				'$q',
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'sbToastService',
				'smbToolbarService',
				'smbSortService',
				'smbStatusConfigDataStore',
				'smbContentTypeConfigDataStore',
				'smbContentTypeGroupTagTypesConfigDataStore',
				'smbContentTypeTagTypeConfigDataStore',
				ContentTypeConfigController
			]);
	
		var templateUrl = __webpack_require__(167);
		function ContentTypeConfigDirective() {
			return {
				restrict: 'E',
				controller: 'smbContentTypeConfigController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					contentTypeGroupId: '@',
					contentTypeId: '@'
				},
				scope: {}
			};
		}
	
		function ContentTypeConfigController(
			$scope,
			$q,
			$state,
			gettextCatalog,
			pxProgressService,
			sbToastService,
			smbToolbarService,
			smbSortService,
			smbStatusConfigDataStore,
			smbContentTypeConfigDataStore,
			smbContentTypeGroupTagTypesConfigDataStore,
			smbContentTypeTagTypeConfigDataStore
		) {
			var vm = this;
			vm.isLoading = false;
	
			// Set toolbar state, including the title, back arrow target state, and hide contextual toolbar and side panel
			var title = vm.contentTypeId ? gettextCatalog.getString('Edit Document Type') : gettextCatalog.getString('Create Document Type');
			smbToolbarService.set(title, 'contentConfig.types', false, false);
			smbToolbarService.backArrowStateParams = { groupId: vm.contentTypeGroupId };
	
			// Dirty flags for the various types. These are used to determine if
			// an asterisk should be displayed next to a section's label.
			vm.typeIsDirty = false;
			vm.indexTypesAreDirty = false;
			vm.statusIsDirty = false;
	
			// The different types being edited in this section.
			vm.contentType = null;
			vm.contentTypeIndexes = [];
			vm.contentTypeGroupIndexes = [];
	
			// Event handlers for the subcomponents
			vm.onSubmit = onSubmit;
			vm.onContentTypeChange = onContentTypeChange;
			vm.onAddIndexType = onAddIndexType;
			vm.onEditIndexType = onEditIndexType;
			vm.onDeleteIndexType = onDeleteIndexType;
			vm.onStatusChange = onStatusChange;
			vm.onSequence = onSequence;
	
			vm.contentStatus = null;
			vm.todoStatus = null;
			vm.assignedUserId = null;
			vm.assignedDate = null;
			vm.contentStatuses = [];
			vm.todoStatuses = [];
			vm.readOnly = false;
	
			var sortTagTypeByName = smbSortService.sortObjectByStringProperty('TagTypeName');
	
			/*** Controller initialization ***/
			(function initConentTypeConfigController() {
				vm.typeIsDirty = false;
				vm.indexTypesAreDirty = false;
				vm.statusIsDirty = false;
	
				vm.isLoading = true;
				pxProgressService.visible = true;
	
				smbContentTypeConfigDataStore
					.getContentType(vm.contentTypeGroupId, vm.contentTypeId)
						.then(function() { /* Copy object so we don't mutate the one on the data store. */
							vm.contentType = Object.assign({}, smbContentTypeConfigDataStore.contentType);
						})
						.then(function() { /* Load content type level tag types */
							return smbContentTypeTagTypeConfigDataStore.getTagTypes(vm.contentTypeId);
						})
						.then(function() { /* Copy array and objects in array so we don't mutate the ones on the data store. */
							vm.contentTypeIndexes = smbContentTypeTagTypeConfigDataStore.tagTypes
								.filter(function(tt) {
									return !(tt.TagTypeName.match(/&&_AirBase_.*/));
								})
								.map(function(tt) {
									return Object.assign({}, tt, {
										Constraints: Object.assign({}, tt.Constraints)
									});
								});
						})
						.then(function() {
							if (vm.contentTypeId) {
								vm.contentStatus = smbContentTypeTagTypeConfigDataStore.contentStatus
								.map(function(tt) {
									return Object.assign({}, tt);
								});
								vm.todoStatus = smbContentTypeTagTypeConfigDataStore.todoStatus
								.map(function(tt) {
									return Object.assign({}, tt);
								});
								vm.assignedUserId = smbContentTypeTagTypeConfigDataStore.assignedUserId
								.map(function(tt) {
									return Object.assign({}, tt);
								});
								vm.assignedDate = smbContentTypeTagTypeConfigDataStore.assignedDate
								.map(function(tt) {
									return Object.assign({}, tt);
								});
							}
							return $q.resolve([]);
						})
						.then(function() {
							vm.contentStatuses = [];
							vm.todoStatuses = [];
							if (vm.contentTypeId) {
								if (vm.contentStatus[0]) {
									vm.contentStatuses = (vm.contentStatus[0].Constraints.DataSetValues) ? vm.contentStatus[0].Constraints.DataSetValues : [];
								}
								if (vm.todoStatus[0]) {
									vm.todoStatuses = (vm.todoStatus[0].Constraints.DataSetValues) ? vm.todoStatus[0].Constraints.DataSetValues : [];
								}
								vm.readOnly = (vm.contentStatuses.length + vm.todoStatuses.length) > 0;
							}
						})
						.then(function() { /* Load content type group level tag types */
							return smbContentTypeGroupTagTypesConfigDataStore.getTagTypes(vm.contentTypeGroupId);
						})
						.then(function() { /* Copy objects, filter out those that are already assigned to the content type. */
							vm.contentTypeGroupIndexes = smbContentTypeGroupTagTypesConfigDataStore.tagTypes
								.filter(function(tt) {
									var t = vm.contentTypeIndexes.find(function(i) { return i.TagTypeId === tt.TagTypeId; });
									return t ? false : true;
								})
								.map(function(tt) {
									return Object.assign({}, tt, {
										Constraints: Object.assign({}, tt.Constraints)
									});
								});
	
							// sort alphabetically by name
							vm.contentTypeGroupIndexes.sort(sortTagTypeByName);
						})
						.finally(function() { /* done */
							vm.isLoading = false;
							pxProgressService.visible = false;
						});
			}());
	
			function onSubmit() {
				if (vm.contentType && vm.contentType.FolderName && vm.contentType.IconName) {
					vm.isLoading = true;
					pxProgressService.visible = true;
	
					saveContentType()
						.then(function() {
							vm.contentType = smbContentTypeConfigDataStore.contentType;
							vm.contentTypeId = vm.contentType.FolderId;
							vm.typeIsDirty = false;
						})
						.then(function() {
							return loadStatuses();
						})
						.then(function() { /* Create any new index types on the content type group */
							return createNewIndexTypes();
						})
						.then(function() {
							return addIndexTypes(vm.contentTypeIndexes
							.concat(vm.contentStatus)
							.concat(vm.todoStatus)
							.concat(vm.assignedUserId)
							.concat(vm.assignedDate));
						})
						.then(function() {
							return updateStatuses();
						})
						.then(function() {
							vm.indexTypesAreDirty = false;
							vm.statusIsDirty = false;
							$state.go('contentConfig.types', {groupId: vm.contentTypeGroupId});
							sbToastService.showSimple(vm.contentTypeId ? gettextCatalog.getString('Document type saved!') : gettextCatalog.getString('New document type created!'));
						})
						.catch(function(e) {
							if (e.status === 409) {
								var message = gettextCatalog.getString('{{folderName}} document type already exists', { folderName: vm.contentType.FolderName });
								sbToastService.showSimple(message);
							} else if (typeof e.data === 'string' && e.status !== 500) {
								sbToastService.showSimple(e.data);
							} else {
								sbToastService.showSimple(gettextCatalog.getString('An unknown error has occurred'));
							}
						})
						.finally(function() {
							vm.isLoading = false;
							pxProgressService.visible = false;
						});
				}
			}
	
			function loadStatuses() {
				return smbContentTypeTagTypeConfigDataStore.getTagTypes(vm.contentTypeId)
				.then(function(response) {
					vm.contentStatus = smbContentTypeTagTypeConfigDataStore.contentStatus;
					vm.todoStatus = smbContentTypeTagTypeConfigDataStore.todoStatus;
					vm.assignedUserId = smbContentTypeTagTypeConfigDataStore.assignedUserId;
					vm.assignedDate = smbContentTypeTagTypeConfigDataStore.assignedDate;
					return response;
				});
			}
			function saveContentType() {
				if (vm.typeIsDirty || vm.contentType.FolderName) {
					return smbContentTypeConfigDataStore.saveContentType(vm.contentTypeGroupId, vm.contentType);
				} else {
					return $q.resolve(vm.contentType);
				}
			}
	
			function createNewIndexTypes() {
				if (vm.indexTypesAreDirty) {
					var newIndexTypes = vm.contentTypeIndexes.filter(function(i) {
						return !i.hasOwnProperty('TagTypeId');
					});
	
					return $q.all(
						newIndexTypes.map(function(i) {
							return smbContentTypeGroupTagTypesConfigDataStore.addTagType(vm.contentTypeGroupId, i)
								.then(function(tt) {
									var index = vm.contentTypeIndexes.indexOf(i);
									if (index >= 0) {
										vm.contentTypeIndexes[index] = tt;
									}
									return tt;
								});
						})
					);
				} else {
					return $q.resolve([]);
				}
			}
	
			function updateStatuses() {
				if (vm.statusIsDirty) {
					vm.contentStatus[0].Constraints.DataSetValues = vm.contentStatuses;
					vm.todoStatus[0].Constraints.DataSetValues = vm.todoStatuses;
	
					return smbStatusConfigDataStore.saveStatuses(vm.contentTypeId, vm.contentStatus[0], vm.todoStatus[0]);
				}
				else {
					return $q.resolve([]);
				}
			}
	
			function addIndexTypes(indexTypes) {
				if (vm.indexTypesAreDirty) {
					vm.statusIsDirty = true;
					return smbContentTypeTagTypeConfigDataStore.setTagTypes(vm.contentTypeId, indexTypes);
				} else {
					return $q.resolve(indexTypes);
				}
			}
	
			function onContentTypeChange(contentType) {
				vm.typeIsDirty = true;
				vm.contentType = contentType;
			}
	
			function onAddIndexType(item) {
				vm.indexTypesAreDirty = true;
				vm.contentTypeIndexes = vm.contentTypeIndexes.concat(item);
				vm.contentTypeGroupIndexes = vm.contentTypeGroupIndexes.filter(function(i) {
					return i.TagTypeId !== item.TagTypeId;
				});
			}
	
			function onDeleteIndexType(item) {
				vm.indexTypesAreDirty = true;
				vm.contentTypeIndexes = vm.contentTypeIndexes.filter(function(tt) {
					return tt.TagTypeName !== item.TagTypeName;
				});
	
				if (item.TagTypeId) {
					// this tag type exists, need to add it back to group tag types
					vm.contentTypeGroupIndexes = vm.contentTypeGroupIndexes.concat([item]);
					vm.contentTypeGroupIndexes.sort(sortTagTypeByName);
				}
			}
	
			function onStatusChange() {
				vm.statusIsDirty = true;
			}
	
			function onSequence(index1, index2) {
				if (canSwap(index1, index2, 0, vm.contentTypeIndexes.length - 1)) {
					var tmp = vm.contentTypeIndexes[index1];
					vm.contentTypeIndexes[index1] = vm.contentTypeIndexes[index2];
					vm.contentTypeIndexes[index2] = tmp;
					vm.indexTypesAreDirty = true;
				}
			}
	
			function canSwap(index1, index2, lowerBound, upperBound) {
				// 1. cannot swap if index1 and index 2 are equal
				// 2. Cannot swap if index 1 or index 2 is below the lower bound
				// 3. cannot swap if index1 or index 2 is above the upper bound
				if (index1 === index2) {
					return false;
				} else if (index1 < lowerBound || index2 < lowerBound) {
					return false;
				} else if (index1 > upperBound || index2 > upperBound) {
					return false;
				} else {
					return true;
				}
			}
	
			function onEditIndexType(item) {
				vm.indexTypesAreDirty = true;
				vm.contentTypeIndexes = vm.contentTypeIndexes.map(function(x) {
					return x.TagTypeId === item.TagTypeId ? angular.extend({}, x, item) : x;
				});
			}
		}
	}());

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		// user selector dialog template
		var userSelectorTemplateUrl = __webpack_require__(1);
	
		angular.module('smb-app')
			.directive('smbContentTypeConfigForm', ContentTypeConfigFormDirective)
			.controller('smbContentTypeConfigFormController', [
				'$scope',
				'$mdDialog',
				'pxProgressService',
				'smbIconDataStore',
				ContentTypeConfigFormController
			]);
	
		var templateUrl = __webpack_require__(168);
		/**
		 * @ngdoc directive
		 * @name smb-app.smbContentTypeConfigForm
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * The configuration form for creating and editing content types
		 *
		 * @usage
		 *
		 * <smb-content-type-config-form />
		 */
		function ContentTypeConfigFormDirective() {
			return {
				restrict: 'E',
				controller: 'smbContentTypeConfigFormController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					contentType: '=',
					onChange: '&'
				}
			};
		}
	
		function ContentTypeConfigFormController($scope, $mdDialog, pxProgressService, smbIconDataStore) {
			var vm = this;
			vm.isLoading = false;
	
			vm.iconSearchText = '';
			vm.contentTypeIcon = null;
	
			vm.onNameChange = onNameChange;
			vm.setIcon = setIcon;
	
			var originalIconId = -1;
			// cache initial value of content type name so we can later see
			// if the value actually changed.
			var typeName = '';
			/*** Controller initialization ***/
			(function initContentTypeConfigFormController() {
				vm.isLoading = true;
				pxProgressService.visible = true;
				smbIconDataStore.loadIcons()
					.then(function() {
						$scope.$watch('vm.contentType', function() {
							if (vm.contentType) {
								vm.contentTypeIcon = smbIconDataStore.icons.find(function(i) {
									return i.IconUserFriendlyName === vm.contentType.IconName;
								});
								originalIconId = (vm.contentTypeIcon && vm.contentTypeIcon.IconId) || originalIconId;
								typeName = vm.contentType.FolderName;
							}
						});
					})
					.finally(function() {
						vm.isLoading = false;
						pxProgressService.visible = false;
					});
			}());
	
			var userSelectorTemplateUrl = __webpack_require__(1);
			function setIcon(event) {
				$mdDialog.show({
					controller: 'smbUserSelectorController',
					controllerAs: 'vm',
					templateUrl: userSelectorTemplateUrl,
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						users: smbIconDataStore.icons,
						multiSelect: false
					}
				})
				.then(function (icon) {
					if (icon.length === 1) {
						vm.contentTypeIcon = icon[0];
						vm.contentType.IconName = vm.contentTypeIcon.IconUserFriendlyName;
						vm.contentType.IconId = vm.contentTypeIcon.IconId;
						if (vm.contentTypeIcon.IconId !== originalIconId) {
							originalIconId = -1;
							emitChange();
						}
					}
				}, function () {
					//cancel
				});
			}
	
			function onNameChange() {
				if (vm.contentType.FolderName !== typeName) {
					emitChange();
				}
			}
	
			function emitChange() {
				vm.onChange({contentType: vm.contentType});
			}
		}
	}());

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypeGroupConfig', [ContentTypeGroupConfigDirective])
			.controller('ContentTypeGroupConfigController',
			[
				'$http',
				'$q',
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'sbToastService',
				'smbSortService',
				'smbContentTypeGroupConfigDataStore',
				'smbToolbarService',
				'smbIndexTypesDataTypes',
				'smbContentTypeGroupTagTypesConfigDataStore',
				ContentTypeGroupConfigController
			]);
	
		var templateUrl = __webpack_require__(169);
		function ContentTypeGroupConfigDirective() {
			return {
				restrict: 'E',
				controller: ContentTypeGroupConfigController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					groupId: '@'
				}
			};
		}
	
		function ContentTypeGroupConfigController(
			$http,
			$q,
			$state,
			gettextCatalog,
			pxProgressService,
			sbToastService,
			smbSortService,
			smbContentTypeGroupConfigDataStore,
			smbToolbarService,
			smbIndexTypesDataTypes,
			smbContentTypeGroupTagTypesConfigDataStore
		) {
			var vm = this;
			var title = vm.groupId ? gettextCatalog.getString('Edit Document Group') : gettextCatalog.getString('Create Document Group');
			smbToolbarService.set(title, 'contentConfig.groups');
	
			vm.loading = false;
			vm.onSubmit = onSubmit;
	
			/*** Group related properties ***/
			vm.group = null;
			vm.viewRightsUserGroups = [];
			vm.fullRightsUserGroups = [];
			vm.editRightsUserGroups = [];
			vm.groupIsDirty = false;
			vm.onGroupChange = onGroupChange;
	
			/*** Index type related properties ***/
			vm.indexTypes = [];
			vm.indexTypePool = [];
			var newIndexTypes = [];
			var editIndexTypes = [];
			vm.indexTypesAreDirty = false;
			vm.newIndexType = newIndexType;
			vm.editIndexType = editIndexType;
	
			var sortIndexTypesByName = smbSortService.sortObjectByStringProperty('TagTypeName');
	
			/*** Controller initialization ***/
			(function initContentTypeGroupConfigController() {
				vm.groupIsDirty = false;
				vm.indexTypesAreDirty = false;
	
				vm.loading = true;
				pxProgressService.visible = true;
				smbContentTypeGroupConfigDataStore
					.getContentTypeGroup(vm.groupId)
					.then(function() {
						vm.group = Object.assign({}, smbContentTypeGroupConfigDataStore.contentTypeGroup);
						vm.viewRightsUserGroups = smbContentTypeGroupConfigDataStore.userGroupsWithViewRights.map(function(ug) { return Object.assign({}, ug); });
						vm.fullRightsUserGroups = smbContentTypeGroupConfigDataStore.userGroupsWithFullRights.map(function(ug) { return Object.assign({}, ug); });
						vm.editRightsUserGroups = smbContentTypeGroupConfigDataStore.userGroupsWithEditRights.map(function(ug) { return Object.assign({}, ug); });
					})
					.then(function() {
						return smbContentTypeGroupTagTypesConfigDataStore.getTagTypes(vm.groupId);
					})
					.then(function() {
						vm.indexTypes = smbContentTypeGroupTagTypesConfigDataStore.tagTypes.map(function(tt) {
							return Object.assign({}, tt, {
								Constraints: Object.assign({}, tt.Constraints)
							});
						});
	
						vm.indexTypes.sort(sortIndexTypesByName);
					})
					.finally(function() {
						vm.isLoading = false;
						pxProgressService.visible = false;
					});
			}());
	
			function onSubmit() {
				vm.loading = true;
				pxProgressService.visible = true;
				if (vm.group && vm.group.LibraryName && vm.group.IconName) {
					saveGroup()
					.then(function() {
						return saveUserGroups();
					})
					.then(function() {
						return saveIndexTypes();
					})
					.then(function() {
						$state.go('contentConfig.groups');
						var message = vm.groupId ? gettextCatalog.getString('Document group saved!') : gettextCatalog.getString('Document group created!');
						sbToastService.showSimple(message);
					})
					.catch(function(e) {
						if (e.status === 409) {
							var message = gettextCatalog.getString('"{{documentGroupName}}" document group already exists!', { documentGroupName: vm.group.LibraryName });
							sbToastService.showSimple(message);
						} else if (typeof e.data === 'string' && e.status !== 500) {
							sbToastService.showSimple(e.data);
						} else {
							sbToastService.showSimple(gettextCatalog.getString('An unknown error has occurred'));
						}
					})
					.finally(function() {
						vm.loading = false;
						pxProgressService.visible = false;
					});
				}
			}
	
			function saveGroup() {
				if (vm.groupIsDirty) {
					var p;
					if (vm.groupId) {
						p = smbContentTypeGroupConfigDataStore.saveContentTypeGroup({
							id: vm.groupId,
							name: vm.group.LibraryName,
							icon: vm.group.IconId
						});
					} else {
						p = smbContentTypeGroupConfigDataStore.saveContentTypeGroup({
							name: vm.group.LibraryName,
							icon: vm.group.IconId
						});
					}
					return p;
				} else {
					return $q.resolve(vm.group);
				}
			}
	
			function saveUserGroups() {
				if (vm.groupIsDirty) {
					return smbContentTypeGroupConfigDataStore.saveUserGroups(vm.viewRightsUserGroups, vm.fullRightsUserGroups, vm.editRightsUserGroups);
				} else {
					return $q.resolve(vm.viewRightsUserGroups.concat(vm.fullRightsUserGroups).concat(vm.editRightsUserGroups));
				}
			}
	
			function saveIndexTypes() {
				if (vm.indexTypesAreDirty) {
	
					var newPromises = newIndexTypes.map(function(tt) {
						return smbContentTypeGroupTagTypesConfigDataStore.addTagType(smbContentTypeGroupConfigDataStore.contentTypeGroup.LibraryId, tt);
					});
	
					var editPromises =  editIndexTypes.map(function(tt) {
						return smbContentTypeGroupTagTypesConfigDataStore.editTagType(smbContentTypeGroupConfigDataStore.contentTypeGroup.LibraryId, tt);
					});
	
					return $q.all(newPromises.concat(editPromises));
				} else {
					return $q.resolve(vm.indexTypes);
				}
			}
	
			/*** Group Config Form component event handlers ***/
	
			/**
			 * Possible Arguments:
			 * group - The content type group object in the group form component
			 * viewUserGroups - The view rights user groups list in the group form component
			 * fullUserGroups - The full rights user groups list in the group form component
			 */
			function onGroupChange() {
				vm.groupIsDirty = true;
			}
	
			/*** Index Types Config component event handlers ***/
	
			function editIndexType(indexType) {
				vm.indexTypesAreDirty = true;
				vm.indexTypes = vm.indexTypes.map(function(x) {
					return x.TagTypeName === indexType.TagTypeName ? angular.extend({}, x, indexType) : x;
				});
				if (indexType.TagTypeId) {
					// this is an existing tag type, keep track of it via the editIndexTypes array
					editIndexTypes.push(indexType);
				}
			}
	
			function newIndexType(indexType) {
				vm.indexTypesAreDirty = true;
				vm.indexTypes = vm.indexTypes.concat([indexType]);
				vm.indexTypes.sort(sortIndexTypesByName);
				newIndexTypes.push(indexType);
			}
		}
	}());

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		// user selector template
		var userSelectorTemplateUrl = __webpack_require__(1);
	
		angular.module('smb-app')
			.directive('smbContentTypeGroupConfigForm', ContentTypeGroupConfigFormDirective)
			.controller('smbContentTypeGroupConfigFormController',[
				'$scope',
				'$mdDialog',
				'sbToastService',
				'smbIconDataStore',
				'smbUserGroupsDataStore',
				ContentTypeGroupConfigFormController
			]);
	
		var templateUrl = __webpack_require__(170);
		function ContentTypeGroupConfigFormDirective() {
			return {
				restrict: 'E',
				controller: 'smbContentTypeGroupConfigFormController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					group: '=',
					viewRightsUserGroups: '=',
					fullRightsUserGroups: '=',
					editRightsUserGroups: '=',
					onChange: '&'
				}
			};
		}
	
		function ContentTypeGroupConfigFormController($scope, $mdDialog, sbToastService, smbIconDataStore, smbUserGroupsDataStore) {
			var vm = this;
			vm.isLoading = false;
			// Icon configuration
			vm.groupIcon = null;
	
			vm.onNameBlur = onNameBlur;
			vm.addUserGroup = addUserGroup;
			vm.addUserGroups = addUserGroups;
			vm.removeUserGroup = removeUserGroup;
			vm.setIcon = setIcon;
	
			var groupName = '';
			(function initContentTypeGroupConfigFormController() {
				vm.isLoading = true;
				smbIconDataStore.loadIcons()
				.then(function() {
					$scope.$watch('vm.group', function() {
						if (vm.group) {
							vm.groupIcon = smbIconDataStore.icons.find(function(icon) { return icon.IconUserFriendlyName === vm.group.IconName; });
							groupName = vm.group.LibraryName;
						}
					});
				})
				.then(function() {
					return smbUserGroupsDataStore.getUserGroups();
				})
				.finally(function() { vm.isLoading = false; });
			}());
	
			function addUserGroups(event, target, removeTarget) {
				var groupUserGroups = target;
				var newGroups = smbUserGroupsDataStore.userGroups.filter(function (group) {
	
					for (var x = 0; x < groupUserGroups.length; x++) {
						if (groupUserGroups[x].UserGroupId === group.UserGroupId) {
							return false;
						}
					}
					return true;
				});
	
				$mdDialog.show({
					controller: 'smbUserSelectorController',
					controllerAs: 'vm',
					templateUrl: userSelectorTemplateUrl,
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						users: newGroups,
						multiSelect: true
					}
				})
				.then(function (selectedUserGroups) {
					//new user groups
					selectedUserGroups.forEach(function(group) {
						target.push(group);
						// If the user group exists in another access rights array, it should
						// only be in one, use this flag to prevent iterating over
						// subsequent arrays when we know it is not necessary to do so.
						// Doing this because I can't think of a better way that scales and
						// this is n cubed.
						var removed = false;
						removeTarget.forEach(function(target) {
							if (!removed) {
								var g = target.find(function(ug) {
									return ug.UserGroupId === group.UserGroupId;
								});
								if (g) {
									target.splice(target.indexOf(g), 1);
									removed = true;
								}
							}
						});
					});
					emitChange();
				}, function () {
					//cancel
				});
			}
	
			function removeUserGroup(group, target) {
				var index = target.indexOf(group);
				if (index === -1) { return; }
	
				target.splice(index, 1);
				emitChange();
			}
	
			function setIcon(event) {
				$mdDialog.show({
					controller: 'smbUserSelectorController',
					controllerAs: 'vm',
					templateUrl: userSelectorTemplateUrl,
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						users: smbIconDataStore.icons,
						multiSelect: false
					}
				})
				.then(function (icon) {
					if (icon.length === 1) {
						vm.group.IconName = icon[0].IconUserFriendlyName;
						vm.group.IconId = icon[0].IconId;
						if (!vm.group.Links) {
							vm.group.Links = {};
						}
						vm.group.Links.IconUri = icon[0].IconUri;
						vm.onChange({ group: vm.group, viewUserGroups: vm.viewRightsUserGroups, fullUserGroups: vm.fullRightsUserGroups });
					}
				}, function () {
					//cancel
				});
			}
	
			function addUserGroup() {
				emitChange();
			}
	
			function onNameBlur() {
				if (vm.group.LibraryName !== groupName) {
					emitChange();
				}
			}
	
			function emitChange() {
				vm.onChange({group: vm.group, viewUserGroups: vm.viewRightsUserGroups, fullUserGroups: vm.fullRightsUserGroups});
			}
		}
	
	}());

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypeGroupSearch',
			[
				ContentTypeGroupSearchDirective
			])
			.controller('ContentTypeGroupSearchController',
			[
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbIndexTypesDataStore',
				'smbContentSearchDataStore',
				'smbContentTypeGroupConfigDataStore',
				'smbContentTypeConfigDataStore',
				'smbIconTypes',
				ContentTypeGroupSearchController
			]);
	
		var templateUrl = __webpack_require__(171);
		function ContentTypeGroupSearchDirective() {
			return {
				restrict: 'E',
				controller: ContentTypeGroupSearchController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					groupId: '@'
				},
				scope: {}
			};
		}
	
		function ContentTypeGroupSearchController($state, gettextCatalog, pxProgressService, smbToolbarService, smbIndexTypesDataStore, 
											smbContentSearchDataStore, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes) {
	
			smbToolbarService.set(gettextCatalog.getString('Search Document Type Group'), 'search.contentTypeGroups.contentTypes', false, false);
	
			var vm = this;
	
			vm.search = search;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.contentTypeDS = smbContentTypeConfigDataStore;
			vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
			vm.indexTypesDS = smbIndexTypesDataStore;
			vm.filename = null;
	
			vm.indextypes = [];
	
			vm.contentTypeGroupDS.getContentTypeGroup(vm.groupId)		
			.then(function () {
				vm.indexTypesDS.getDocumentTypeGroupIndexTypes(vm.groupId).then(function () {
					vm.indextypes = vm.indexTypesDS.groupIndexTypes;
				});
			});
	
			function search() {
				smbContentSearchDataStore.setTagValues(vm.indextypes);
				$state.go('search.contentTypeGroups.contentTypes.groupSearch.results',{ groupId: vm.groupId});
			}
		}
	}());


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypeGroupSearchResults',
			[
				ContentTypeGroupSearchResultsDirective
			])
			.controller('ContentTypeGroupSearchResultsController',
			[
				'smbToolbarService',
				'gettextCatalog',
				'smbContentTypeGroupConfigDataStore',
				'smbContentTypeConfigDataStore',
				'smbIconTypes',
				'smbContentSearchDataStore',
				'smbDocumentViewerNavigationService',
				ContentTypeGroupSearchResultsController
			]);
	
		var templateUrl = __webpack_require__(172);
		function ContentTypeGroupSearchResultsDirective() {
			return {
				restrict: 'E',
				controller: ContentTypeGroupSearchResultsController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					groupId: '@'
				}
			};
		}
	
		function ContentTypeGroupSearchResultsController(smbToolbarService, gettextCatalog, smbContentTypeGroupConfigDataStore,
									smbContentTypeConfigDataStore, smbIconTypes, smbContentSearchDataStore, smbDocumentViewerNavigationService) {
	
			smbToolbarService.set(gettextCatalog.getString('Document Group Search Results'), 'search.contentTypeGroups.contentTypes.groupSearch');
	
			var vm = this;
			vm.contentSearchDS = smbContentSearchDataStore;
			vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
			vm.contentTypeDS = smbContentTypeConfigDataStore;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.documentNavigation = smbDocumentViewerNavigationService;
	
			(function loadSearchResults() {
				smbContentSearchDataStore.getContentTypeGroupSearchResults(vm.groupId);
			})();
		}
	}());


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypeGroups', [ContentTypeGroupsDirective])
			.controller('ContentTypeGroupsController',
			[
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbContentTypeGroupsDataStore',
				'smbIconTypes',
				ContentTypeGroupsController
			]);
	
		var templateUrl = __webpack_require__(173);
		function ContentTypeGroupsDirective() {
			return {
				restrict: 'E',
				controller: ContentTypeGroupsController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function ContentTypeGroupsController($state, gettextCatalog, pxProgressService, smbToolbarService, smbContentTypeGroupsDataStore, smbIconTypes) {
			smbToolbarService.set(gettextCatalog.getString('Document Groups'), 'content.home');
	
			var vm = this;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.contentTypeGroupsDataStore = smbContentTypeGroupsDataStore;
	
			pxProgressService.visible = true;
			smbContentTypeGroupsDataStore.loadFullAccessGroups()
				.then(function () {
					pxProgressService.visible = false;
				});
		}
	}());

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypeGroupsConfig', [ContentTypeGroupsConfigDirective])
			.controller('ContentTypeGroupsConfigController', [
				'$mdDialog',
				'pxAuthService',
				'sbToastService',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbIconTypes',
				'smbContentTypeGroupsConfigDataStore',
				'smbDeleteDialogService',
				ContentTypeGroupsConfigController
			]);
	
		var templateUrl = __webpack_require__(174);
		function ContentTypeGroupsConfigDirective() {
			return {
				restrict: 'E',
				controller: ContentTypeGroupsConfigController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function ContentTypeGroupsConfigController($mdDialog, pxAuthService, sbToastService, gettextCatalog, pxProgressService, smbToolbarService, smbIconTypes, smbContentTypeGroupsConfigDataStore, smbDeleteDialogService) {
			smbToolbarService.set(gettextCatalog.getString('Document Groups Configuration'), 'content.home', false, false);
	
			var vm = this;
			vm.iconType = smbIconTypes[smbIconTypes.SVG];
			vm.contentTypeGroupsDataStore = smbContentTypeGroupsConfigDataStore;
			vm.deleteContentTypeGroup = deleteContentTypeGroup;
	
			pxProgressService.visible = true;
			vm.contentTypeGroupsDataStore
				.loadGroups()
				.finally(function () { 
					pxProgressService.visible = false; 
				});
	
			function deleteContentTypeGroup(event, group) {
				var title = gettextCatalog.getString('Delete Document Type Group');
				var message = gettextCatalog.getString('Would you like to delete "{{typeName}}"? Deleting this group will permanently deleted all related types and documents, and can\'t be undone!', { 
					typeName: group.name 
				});
				
				smbDeleteDialogService
					.show(event, title, message)
					.then(function () {
						pxProgressService.visible = true;
						smbContentTypeGroupsConfigDataStore
							.deleteGroup(group.id)
							.then(function () {
								sbToastService.showSimple(gettextCatalog.getString('{{groupName}} was deleted!', { groupName: group.name }));
							})
							.catch(function () {
								sbToastService.showSimple(gettextCatalog.getString('Unable to delete group'));
							})
							.finally(function () {
								pxProgressService.visible = false;
							});
					}, angular.noop);
			}
		}
	}());

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypeGroupsSearch', [ContentTypeGroupsSearchDirective])
			.controller('ContentTypeGroupsSearchController',
			[
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbContentTypeGroupsSearchDataStore',
				'smbIconTypes',
				ContentTypeGroupsSearchController
			]);
	
		var templateUrl = __webpack_require__(175);
		function ContentTypeGroupsSearchDirective() {
			return {
				restrict: 'E',
				controller: ContentTypeGroupsSearchController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function ContentTypeGroupsSearchController($state, gettextCatalog, pxProgressService, smbToolbarService, smbContentTypeGroupsSearchDataStore, smbIconTypes) {
			smbToolbarService.set(gettextCatalog.getString('Search Document Groups'), 'content.home');
	
			var vm = this;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.contentTypeGroupsSearchDataStore = smbContentTypeGroupsSearchDataStore;
	
			pxProgressService.visible = true;
			smbContentTypeGroupsSearchDataStore.loadAllGroups()
				.then(function () {
					pxProgressService.visible = false;
				});
		}
	}());

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContentTypes', [ContentTypesDirective])
			.controller('ContentTypesController',
			[
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbContentTypesDataStore',
				'smbIconTypes',
				ContentTypesController
			]);
	
		var templateUrl = __webpack_require__(176);
		function ContentTypesDirective() {
			return {
				restrict: 'E',
				controller: ContentTypesController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					groupId: '@'
				},
				scope: {}
			};
		}
	
		function ContentTypesController(gettextCatalog, pxProgressService, smbToolbarService, smbContentTypesDataStore, smbIconTypes) {
			smbToolbarService.set(gettextCatalog.getString('Document Types'), 'import.contentTypeGroups');
	
			var vm = this;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.contentTypesDataStore = smbContentTypesDataStore;
	
			smbContentTypesDataStore.getContentTypes(vm.groupId);
		}
	}());

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(177);
	
		/**
		 * @ngdoc directive
		 * @name smb-app.smbContentTypesConfig
		 * @module smb-app
		 * @restrict E
		 * 
		 * @description
		 * Displays the configuration section for a list of content types that belong
		 * to a specific content type group.
		 * 
		 * @usage
		 * 
		 * <smb-content-types-config content-type-group-id="11" />
		 * 
		 * @element input
		 * @param {number=} contentTypeGroupId The id of the content type group whose content types are being displayed.
		 */
	
		angular
			.module('smb-app')
			.directive('smbContentTypesConfig', ContentTypesConfigDirective)
			.controller('ContentTypesConfigController', [
				'$mdDialog',
				'pxAuthService',
				'sbToastService',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbContentTypesDataStore',
				'smbIconTypes',
				'smbDeleteDialogService',
				ContentTypesConfigController
			]);
		
		function ContentTypesConfigDirective() {
			return {
				restrict: 'E',
				controller: ContentTypesConfigController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					contentTypeGroupId: '@'
				}
			};
		}
	
		function ContentTypesConfigController($mdDialog, pxAuthService, sbToastService, gettextCatalog, pxProgressService, smbToolbarService, smbContentTypesDataStore, smbIconTypes, smbDeleteDialogService) {
			var vm = this;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
			vm.deleteDocumentType = deleteDocumentType;
	
			// TODO: Add group name?
			smbToolbarService.set(gettextCatalog.getString('Document Types Configuration'), 'contentConfig.groups');
	
			vm.contentTypesDS = smbContentTypesDataStore;
	
			// TODO: Error handling
			smbContentTypesDataStore.getContentTypes(vm.contentTypeGroupId);
	
			function deleteDocumentType(event, documentType) {	
				var title = gettextCatalog.getString('Delete Document Type');
				var message = gettextCatalog.getString('Would you like to delete "{{typeName}}"?', { 
					typeName: documentType.FolderName 
				});
				var purgeText = gettextCatalog.getString('Selecting this checkbox will enable permanent deletion of this document type and all related documents that can\'t be undone!');
				
				smbDeleteDialogService
					.show(event, title, message, pxAuthService.isSiteAdmin, purgeText)
					.then(function (purge) {
						pxProgressService.visible = true;
						smbContentTypesDataStore
							.deleteContentType(documentType.FolderId, purge)
							.then(function () {
								var deleteMessage = gettextCatalog.getString('{{typeName}} was deleted!', { 
									typeName: documentType.FolderName 
								});
								sbToastService.showSimple(deleteMessage);
							})
							.catch(function () {
								var deleteIssueMessage = gettextCatalog.getString('Unable to delete group');
								sbToastService.showSimple(deleteIssueMessage);
							})
							.finally(function () {
								pxProgressService.visible = false;
							});
					}, angular.noop());
			}
		}
	}());

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		/**
		 * @ngdoc directive
		 * @name smb-app.smbContentTypesConfig
		 * @module smb-app
		 * @restrict E
		 *
		 * @description
		 * Displays the configuration section for a list of content types that belong
		 * to a specific content type group.
		 *
		 * @usage
		 *
		 * <smb-content-types-config content-type-group-id="11" />
		 *
		 * @element input
		 * @param {number=} contentTypeGroupId The id of the content type group whose content types are being displayed.
		 */
	
		angular.module('smb-app')
			.directive('smbContentTypesSearch', ContentTypesSearchDirective)
			.controller('ContentTypesSearchController',
			[
				'gettextCatalog',
				'smbToolbarService',
				'smbContentTypesSearchDataStore',
				'smbIconTypes',
				ContentTypesSearchController
			]);
	
		var templateUrl = __webpack_require__(178);
		function ContentTypesSearchDirective() {
			return {
				restrict: 'E',
				controller: ContentTypesSearchController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					groupId: '@'
				}
			};
		}
	
		function ContentTypesSearchController(gettextCatalog, smbToolbarService, smbContentTypesSearchDataStore, smbIconTypes) {
			var vm = this;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
	
			// TODO: Add group name?
			smbToolbarService.set(gettextCatalog.getString('Search Document Types'), 'search.contentTypeGroups');
			smbToolbarService.backArrowStateParams = undefined;
	
			vm.contentTypesSearchDS = smbContentTypesSearchDataStore;
	
			// TODO: Error handling
			smbContentTypesSearchDataStore.getContentTypes(vm.groupId);
		}
	}());

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbContent',[ContentDirective])
			.controller('ContentTypesController',
			[
				'$scope',
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'sbToastService',
				'smbEnvironmentService',
				'smbToolbarService',
				'smbContentUploadDataStore',
				'smbIndexTypesDataStore',
				'smbContentTypeGroupConfigDataStore',
				'smbContentTypeConfigDataStore',
				'smbIconTypes',
				'smbDocumentViewerNavigationService',
				ContentController
			]);
	
		var templateUrl = __webpack_require__(179);
		function ContentDirective() {
			return {
				restrict: 'E',
				controller: ContentController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					contentTypeGroupId: '@',
					contentTypeId: '@'
				},
				scope: {}
			};
		}
	
		function ContentController($scope, $state, gettextCatalog, pxProgressService, sbToastService, smbEnvironmentService, smbToolbarService,
			smbContentUploadDataStore, smbIndexTypesDataStore, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes,
			smbDocumentViewerNavigationService) {
	
			smbToolbarService.set(gettextCatalog.getString('Add Document'), 'import.contentTypeGroups.contentTypes');
	
			var vm = this;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
	
			vm.uploadDS = smbContentUploadDataStore;
			vm.indexTypesDS = smbIndexTypesDataStore;
			vm.contentTypeDS = smbContentTypeConfigDataStore;
			vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
			vm.filename = null;
			vm.file = null;
			vm.onFileInputClick = onFileInputClick;
	
			vm.indexFileChanged = indexFileChanged;
			vm.upload = upload;
	
			function indexFileChanged(fileInput) {
				if (fileInput.files.length === 0) {
					return;
				}
				vm.filename = fileInput.files[0].name;
				vm.file = fileInput.files[0];
				$scope.$digest(); // probably not the best way, but this seemed to fix the problem of not updating label right away
			}
	
			vm.contentTypeGroupDS.getContentTypeGroup(vm.contentTypeGroupId)
				.then(function () {
					vm.contentTypeDS.getContentType(vm.contentTypeGroupId, vm.contentTypeId);
				})
				.then(function () {
					vm.indexTypesDS.getIndexTypes(vm.contentTypeId);
				});
	
			function upload() {
				if (vm.file) {
					vm.uploadDS.uploadDocument(vm.contentTypeId, vm.file)
					.then(function indexTypesUpload() {
						vm.indexTypesDS.setIndexTypes(vm.indexTypesDS.indexTypes, vm.uploadDS.uploadedDocument.data.DocumentId, vm.contentTypeId)
						.then(function() {
							sbToastService.showSimple(gettextCatalog.getString('Document Uploaded Successfully'));
						}).then(function openViewer() {
							smbDocumentViewerNavigationService.go(vm.contentTypeGroupId, vm.contentTypeId, vm.uploadDS.uploadedDocument.data.DocumentId);
						});
					});
				}
				else {
					sbToastService.showSimple(gettextCatalog.getString('Please select a file to upload'));
				}
			}
	
			function onFileInputClick(ev) {
				// If running in IE or Firefox, need to programatically trigger the input file.
				// Unlike Chrome, when embedding a file input in a button, clicking
				// the button doesn't trigger the file input.
				if (smbEnvironmentService.isIE || smbEnvironmentService.isFireFox) {
					var fileInput = ev.target.querySelector('input[type="file"]');
					if (fileInput) {
						fileInput.click();
					}
				}
			}
		}
	}());

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		// load user selector template via webpack
		var userSelectorTemplateUrl = __webpack_require__(1);
	
		angular.module('smb-app')
			.directive('smbDocumentContextMenu', DocumentContextMenuDirective)
			.controller('smbDocumentContextMenuController', [
				'$scope',
				'$timeout',
				'$state',
				'$q', 
				'$mdDialog',
				'pxAuthService',
				'sbToastService',
				'smbToolbarService',
				'smbDocumentDataStore',
				'smbStatusDataStore',
				'smbToDoListDataStore',
				'smbDocumentDetailsPanelDataStore',
				'smbDocumentViewerNavigationService',
				'smbDeleteDialogService',
				'gettextCatalog',
				DocumentContextMenuController
			]);
	
		var templateUrl = __webpack_require__(180);
		function DocumentContextMenuDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentContextMenuController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					documentId: '@',
					documentTypeId: '@',
					documentGroupId: '@'
				},
				scope: {}
			};
		}
	
		function DocumentContextMenuController($scope, $timeout,$state, $q, $mdDialog, pxAuthService, sbToastService, smbToolbarService, smbDocumentDataStore, smbStatusDataStore, smbToDoListDataStore, smbDocumentDetailsPanelDataStore, smbDocumentViewerNavigationService, smbDeleteDialogService, gettextCatalog) {
			var vm = this;
			vm.smbToolbarService = smbToolbarService;
			vm.documentDS = smbDocumentDataStore;
			vm.toDoListDS = smbToDoListDataStore;
			vm.detailsPanelDS = smbDocumentDetailsPanelDataStore;
	
			(function initDocumentContextMenuController() {
				smbDocumentDataStore.loadUserPermissions(vm.documentGroupId)
					.then(function() {
						return smbStatusDataStore.loadStatuses(vm.documentTypeId);
					})
					.then(function getStatusValues() {
						vm.contentStatuses = smbStatusDataStore.contentStatus[0].Constraints.DataSetValues.map(function(sv) {
							var csv = {};
							csv.Label = sv;
							csv.StatusType = 'Content Status';
							return csv; 
						});
	
						vm.todoStatuses = smbStatusDataStore.todoStatus[0].Constraints.DataSetValues.map(function(sv) {
							var tsv = {};
							tsv.Label = sv;
							tsv.StatusType = 'ToDo Status';
							return tsv; 
						});
						
					})
					.then(function getTagTypeIds() {
						vm.contentStatusTagTypeId = smbStatusDataStore.contentStatus[0].TagTypeId;
						vm.todoStatusTagTypeId = smbStatusDataStore.todoStatus[0].TagTypeId;
						vm.assignedUserIdTagTypeId = smbStatusDataStore.assignedUserId[0].TagTypeId;
						vm.assignedDateTagTypeId = smbStatusDataStore.assignedDate[0].TagTypeId;
					})
					.then(function getDocumentStatusValues() {
						return smbStatusDataStore.getDocumentStatus(vm.documentId);
					})
					.then(function mapDocumentStatusValues(response) {
						vm.documentContentStatusValue = response.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_Content_Status/);
						})[0].Tags || [];
						vm.documentToDoStatusValue = response.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_ToDo_Status/);
						})[0].Tags || [];
						vm.documentAssignedUserId = response.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
						})[0].Tags || 0;
					})
					.then(function getUsersList() {
						return smbStatusDataStore.getUsersWithModifyRights(vm.documentId);
					})
					.then(function(userslist) {
						vm.users = userslist.map(function mapusers(u) {
							var user = {};
							user.UserId = u.UserId;
							user.UserName = u.UserName;
							user.EmailAddress = u.EmailAddress;
							return user;
						});
					})
					.then(function setUIStatusValues() {
						if (vm.documentContentStatusValue.length > 0 && vm.documentContentStatusValue[0].length !== 0) {
							//vm.status = JSON.stringify({ Label: vm.documentContentStatusValue[0], StatusType: 'Content Status' });
							vm.status = { Label: vm.documentContentStatusValue[0], StatusType: 'Content Status' };
							vm.isContentStatusSelected = true;
						}
	
						if (vm.documentToDoStatusValue.length > 0 && vm.documentToDoStatusValue[0].length !== 0) {
							//vm.status = JSON.stringify({Label: vm.documentToDoStatusValue[0], StatusType: 'ToDo Status
							vm.status = {Label: vm.documentToDoStatusValue[0], StatusType: 'ToDo Status'};
							vm.isContentStatusSelected = false;
						}
	
						if (vm.documentAssignedUserId && vm.documentAssignedUserId[0] > 0) {
							vm.assignedUser = vm.users.filter(function(u) {
								return u.UserId === JSON.parse(vm.documentAssignedUserId[0]);
							});
							//vm.assignedUser = JSON.stringify(vm.assignedUser[0]);
							vm.assignedUser = vm.assignedUser[0];
						}
					})
					.finally(function () {
						//hide tiles till loaded
						$timeout(function () { vm.loading = false; }, 50);
					});
					
			}());
			vm.loading = true;
			vm.documentContentStatusValue = null;
			vm.documentToDoStatusValue = null;
			vm.documentAssignedUserId = null;
			vm.documentAssignedDate = null;
	
			vm.contentStatuses = [];
			vm.todoStatuses = [];
			vm.users = [];
			vm.statusIsDirty = false;
	
			vm.contentStatusTagTypeId = null;
			vm.todoStatusTagTypeId = null;
			vm.assignedUserIdTagTypeId = null;
			vm.assignedDateTagTypeId = null;
	
			vm.onChange = onChange;
			vm.saveStatus = saveStatus;
			vm.changeStatus = changeStatus;
			vm.changeAssingedUser = changeAssingedUser;
			vm.deleteDocument = deleteDocument;
	
			vm.isContentStatusSelected = false;
	
			function changeStatus(event) {
				var status = vm.todoStatuses.concat(vm.contentStatuses);
				//select current status
				status = status.map(function (s) {
					if (vm.status && (s.Label === vm.status.Label && s.StatusType === vm.status.StatusType)) {
						s.selected = true;
					}
					else {
						s.selected = false;
					}
					return s;
				});
	
				$mdDialog.show({
					controller: 'smbUserSelectorController',
					controllerAs: 'vm',
					templateUrl: userSelectorTemplateUrl,
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						users: status,
						multiSelect: false
					}
				})
				.then(function (selectedStatus) {
					//new user groups
					if (selectedStatus.length === 1) {
						vm.status = selectedStatus[0];
						onChange();
						vm.saveStatus();
					}
				}, function () {
					//cancel
				});
			}
			function changeAssingedUser(event) {
				var users = vm.users;
				//select current assigned user
				if (vm.assignedUser) {
					users = users.map(function (user) {
						if (user.UserId === vm.assignedUser.UserId) {
							user.selected = true;
						}
						else {
							user.selected = false;
						}
						return user;
					});
				}
	
				$mdDialog.show({
					controller: 'smbUserSelectorController',
					controllerAs: 'vm',
					templateUrl: userSelectorTemplateUrl,
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						users: users,
						multiSelect: false
					}
				})
				.then(function (selectedUser) {
					//new user groups
					if (selectedUser.length === 1) {
						vm.assignedUser = selectedUser[0];
						onChange();
						vm.saveStatus();
					}
				}, function () {
					//cancel
				});
			}
	
			function onChange() {
	
				var Status = vm.status;
				vm.statusIsDirty = false;
				if (Status && Status.StatusType === 'Content Status') {
					vm.isContentStatusSelected = true;
					vm.statusIsDirty = true;
				}
				else if (Status && Status.StatusType === 'ToDo Status') {
					var AssignedUser = vm.assignedUser;
					vm.isContentStatusSelected = false;
					if (AssignedUser && AssignedUser.UserId > 0) {
						vm.statusIsDirty = true;
					}
				}
			}
	
			function saveStatus() {
				var parsedStatus = vm.status;
				var parsedUser = vm.assignedUser;
	
				var contentstatus = {};
				contentstatus.TagTypeId = vm.contentStatusTagTypeId;
				contentstatus.Value = parsedStatus.StatusType === 'Content Status' ? parsedStatus.Label : null;
	
				var todostatus = {};
				todostatus.TagTypeId = vm.todoStatusTagTypeId;
				todostatus.Value = parsedStatus.StatusType === 'ToDo Status' ? parsedStatus.Label : null;
	
				var assigneduserid = {};
				assigneduserid.TagTypeId = vm.assignedUserIdTagTypeId;
				assigneduserid.Value = parsedStatus.StatusType === 'ToDo Status' && parsedUser ? parsedUser.UserId : 0;
	
				var assigneddate = {};
				assigneddate.TagTypeId = vm.assignedDateTagTypeId;
				var date = new Date();
				var mm = date.getMonth() + 1;
				if (mm < 10) {
					mm = '0' + mm;
				}
				var dd = date.getDate();
				if (dd < 10) {
					dd = '0' + dd;
				}
				assigneddate.Value = [mm, dd, date.getFullYear()].join('');
	
				var Status = [];
				Status.push(contentstatus);
				Status.push(todostatus);
				Status.push(assigneduserid);
				Status.push(assigneddate);
	
				smbStatusDataStore.setDocumentStatus(Status, vm.documentId).then(submitSuccess, submitFailure);
				return;
			}
	
			function submitSuccess(response) {
				if (response.Error) {
					submitFailure(response.Error);
					return;
				}
				vm.statusIsDirty = false;
				vm.toDoListDS.loadCount();
			}
	
			function submitFailure(e) {
				//failure
				console.log(e.data.Message);
			}
	
			function deleteDocument(event) {
				var title = gettextCatalog.getString('Delete Document');
				var message = gettextCatalog.getString('Would you like to delete this document?');
				var purgeText = gettextCatalog.getString('Selecting this checkbox will enable permanent deletion of this document that can\'t be undone!');
	
				smbDeleteDialogService
					.show(event, title, message, pxAuthService.isSiteAdmin, purgeText)
					.then(function(purge) {
						return smbDocumentDataStore
							.delete(purge)
							.then(function() {
								return $q.all([
									sbToastService.showSimple(gettextCatalog.getString('Document deleted')),
									smbDocumentViewerNavigationService.back()
								]);
							})
							.catch(function() {
								sbToastService.showSimple(gettextCatalog.getString('Unable to delete document'));
							});				
					}, angular.noop);
			}
		}
	}());

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentDetails', DocumentDetailsDirective)
			.controller('smbDocumentDetailsController', ['smbDocumentDetailsPanelDataStore', DocumentDetailsController]);
	
		var templateUrl = __webpack_require__(181);
		function DocumentDetailsDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentDetailsController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					documentGroupId: '@',
					documentTypeId: '@',
					documentId: '@'
				}
			};
		}
	
		function DocumentDetailsController(smbDocumentDetailsPanelDataStore) {
			var vm = this;
			vm.detailsDS = smbDocumentDetailsPanelDataStore;
		}
	}());

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentHistory', DocumentHistoryDirective)
			.controller('smbDocumentHistoryController', [
				'pxProgressService',
				'smbDocumentHistoryDataStore',
				'gettextCatalog',
				'pxAuthService',
				'sbToastService',
				'sbDocumentDetailService',
				'smbDocumentDataStore',
				'smbContentUploadDataStore',
				DocumentHistoryController
			]);
	
		var templateUrl = __webpack_require__(182);
		/**
		 * @ngdoc directive
		 * @name smb-app.documentHistory
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * @usage
		 *
		 * <smb-document-indexes />
		 */
		function DocumentHistoryDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentHistoryController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					documentId: '@',
					contentTypeId: '@'
				},
				link: function (scope) {
					scope.$watch('vm.activeTab',function (newVal) {
						if (newVal === 1 && scope.vm.docRevisions.length === 0) {
							scope.vm.loadRevisions();
						}
					});
				}
			};
		}
	
		function DocumentHistoryController(pxProgressService, smbDocumentHistoryDataStore, gettextCatalog, pxAuthService, sbToastService, sbDocumentDetailService, smbDocumentDataStore, smbContentUploadDataStore) {
			var vm = this;
			vm.loading = false;
			vm.documentHistoryDS = smbDocumentHistoryDataStore;
			vm.activeTab = 0;
	
			vm.documentDS = smbDocumentDataStore;
			vm.docRevisions = [];
			vm.promoteRevision = promoteRevision;
			vm.isLatest = isLatest;
			vm.uploadRevision = uploadRevision;
			vm.loadRevisions = loadRevisions;
	
			(function initDocumentIndexesController() {
				vm.loading = true;
				pxProgressService.visible = true;
				vm.documentHistoryDS.loadHistory(vm.documentId, vm.documentTypeId, false)
					.finally(function() {
						vm.loading = false;
						pxProgressService.visible = false;
					});
			}());
	
			function loadRevisions() {
				return sbDocumentDetailService.getVersions(vm.documentId)
					.then(function (revisions) {
						vm.docRevisions = revisions.map(function (v) {
							return Object.assign({}, v, {
								DateCreated: new Date(v.DateCreated),
								CreatedBy: v.CreatedBy === pxAuthService.displayName ? 'You' : v.CreatedBy
							});
						});
						return revisions;
					}).then(function () {
						var latest = vm.docRevisions[vm.docRevisions.length - 1];
						var originalFileName = latest.OriginalFileName.split('.');
						vm.extension = originalFileName[originalFileName.length - 1];
						vm.extension = vm.extension && '.' + vm.extension;
					});
			}
	
			function promoteRevision(ev, revision) {
				ev.preventDefault();
				ev.stopPropagation();
				smbContentUploadDataStore.promoteRevision(revision)
					.then(function () {
						return loadRevisions();
					})
					.then(function () {
						sbToastService.showSimple(gettextCatalog.getString('Successfully made revision {rev} the current revision'.replace('{rev}', revision.VersionNumber)));
					});
			}
	
			function isLatest(revision) {
				return vm.docRevisions.indexOf(revision) === vm.docRevisions.length - 1;
			}
	
			function uploadRevision(fileInput) {
				if (!fileInput.files.length) {
					// no files have been selected, don't try to upload
					// non-existant file
					return;
				}
	
				var file = fileInput.files[0];
				smbContentUploadDataStore.uploadRevision(vm.documentId, file)
					.then(function () { /* Reload revisions after creating new one. */
						return loadRevisions();
					})
					.then(function () { /* Reset file input and display success message */
						sbToastService.showSimple(gettextCatalog.getString('New revision saved'));
					})
					.catch(function (err) {
						// show error message
						sbToastService.showSimple(err.data.Message);
					})
					.finally(function () { /* Reset file input */
						fileInput.value = '';
					});
			}
		}
	}());

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentHitList', DocumentHitListDirective)
			.controller('smbDocumentHitListController', ['smbDocumentViewerNavigationService', DocumentHitListController]);
	
		var templateUrl = __webpack_require__(183);
		function DocumentHitListDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentHitListController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					viewOnSelect: '=',
					documents: '=',
					onSelectDocument: '&'
				}
			};
		}
	
		function DocumentHitListController(smbDocumentViewerNavigationService) {
			var vm = this;
			vm.onClick = onClick;
	
			function onClick(document) {
				vm.onSelectDocument({ document: document });
				if (vm.viewOnSelect) {
					smbDocumentViewerNavigationService.go(document.LibraryId, document.FolderId, document.DocumentId);
				}
			}
	
		}
	}());

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentIndexes', DocumentIndexesDirective)
			.controller('smbDocumentIndexesController', [
				'$state',
				'pxProgressService',
				'smbDocumentIndexDataStore',
				'smbDocumentDataStore',
				'smbDocumentDetailsPanelDataStore',
				DocumentIndexesController
			]);
	
		var templateUrl = __webpack_require__(184);
		/**
		 * @ngdoc directive
		 * @name smb-app.smbDocumentIndexes
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * @usage
		 *
		 * <smb-document-indexes />
		 */
		function DocumentIndexesDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentIndexesController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					documentId: '@',
					documentTypeId: '@',
					documentGroupId: '@'
				}
			};
		}
	
		function DocumentIndexesController($state, pxProgressService, smbDocumentIndexDataStore, smbDocumentDataStore, smbDocumentDetailsPanelDataStore) {
			var vm = this;
			vm.loading = false;
			vm.indexDS = smbDocumentIndexDataStore;
			vm.documentDS = smbDocumentDataStore;
			vm.documentDetailsDS = smbDocumentDetailsPanelDataStore;
	
			(function initDocumentIndexesController() {
				vm.loading = true;
				pxProgressService.visible = true;
				vm.indexDS.getIndexes(vm.documentId, vm.documentTypeId, false)
					.then(function() {
						vm.indexDS.indexValues.sort(function(lhs, rhs) {
							if (lhs.sequence < rhs.sequence) {
								return -1;
							} else if (lhs.sequence === rhs.sequence) {
								return 0;
							} else {
								return 1;
							}
						});
					})
					.then(function() {
						vm.documentDS.loadUserPermissions(vm.documentGroupId);
					})
					.finally(function() {
						vm.loading = false;
						pxProgressService.visible = false;
					});
			}());
		}
	}());

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentIndexesEdit', DocumentIndexesEditDirective)
			.controller('smbDocumentIndexesEditController', [
				'gettextCatalog',
				'pxProgressService',
				'sbToastService',
				'smbDocumentIndexDataStore',
				'smbIndexTypesDataStore',
				'smbDocumentDataStore',
				'smbDocumentDetailsPanelDataStore',
				DocumentIndexesEditController
			]);
	
		var templateUrl = __webpack_require__(185);
		/**
		 * @ngdoc directive
		 * @name smb-app.smbDocumentIndexesEdit
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * Document index edit component for the document viewer
		 *
		 * @usage
		 *
		 * <smb-document-indexes-edit />
		 */
		function DocumentIndexesEditDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentIndexesEditController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					documentId: '@',
					documentTypeId: '@',
					documentGroupId: '@'
				}
			};
		}
	
		function DocumentIndexesEditController(
			gettextCatalog,
			pxProgressService,
			sbToastService,
			smbDocumentIndexDataStore,
			smbIndexTypesDataStore,
			smbDocumentDataStore,
			smbDocumentDetailsPanelDataStore
		) {
			var vm = this;
			vm.loading = false;
			vm.indexDS = smbDocumentIndexDataStore;
			vm.indexes = [];
			vm.saveIndexes = saveIndexes;
			vm.documentDetailsDS = smbDocumentDetailsPanelDataStore;
			vm.fieldsStatus = {
				isValid: true
			};
	
			(function initDocumentIndexesEditController() {
				vm.loading = true;
				pxProgressService.visible = true;
				smbDocumentDataStore.loadUserPermissions(vm.documentGroupId)
					.then(function() {
						if (smbDocumentDataStore.canEditFields) {
							return vm.indexDS.getIndexes(vm.documentId, vm.documentTypeId, true);
						} else {
							// Current user can't edit fields, go back to the display page
							smbDocumentDetailsPanelDataStore.toggle(smbDocumentDetailsPanelDataStore.fieldPanel);
							return false;
						}
					})
					.then(function(data) {
						if (data !== false) {
							vm.indexes = vm.indexDS.indexTypePanelModel;
						}
					})
					.finally(function() {
						vm.loading = false;
						pxProgressService.visible = false;
					});
			}());
	
			function saveIndexes() {	
				if(vm.fieldsStatus.isValid) {
					pxProgressService.visible = vm.loading = true;
					smbIndexTypesDataStore.setIndexTypes(vm.indexes, vm.documentId, vm.documentTypeId)
						.then(function() {
							sbToastService.showSimple(gettextCatalog.getString('Fields updated!'));
							smbDocumentDetailsPanelDataStore.toggle(smbDocumentDetailsPanelDataStore.fieldPanel);
						})
						.catch(function(){
							sbToastService.showSimple(gettextCatalog.getString('Unable to update fields.'));
						})
						.finally(function() {
							vm.loading = false;
							pxProgressService.visible = false;
						});
				}
			}
		}
	}());

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentNotes', ['$timeout', DocumentNotesDirective])
			.controller('smbDocumentNotesController', ['smbDocumentNotesDataStore', 'pxAuthService', DocumentNotesController]);
	
		var templateUrl = __webpack_require__(186);
		function DocumentNotesDirective($timeout) {
			return {
				restrict: 'E',
				controller: 'smbDocumentNotesController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					documentId: '@'
				},
				scope: {},
				link: function(scope, element, attrs){
					scope.$watchCollection('vm.notesDS.notes', function (newVal) {
						if (!newVal) { return;}
						scroll();
					});
					function scroll() {
						$timeout(function () {
							var scrollElment = element[0].querySelector('.smb-app-doc-comments__comment-list');
							if (scrollElment) {
								scrollElment.scrollTop = scrollElment.scrollHeight;
								scope.vm.loaded = true;
							}
						}, 100);
					}
					
					scroll();
				}
			};
		}
	
		function DocumentNotesController(smbDocumentNotesDataStore, pxAuthService) {
			var vm = this;
			vm.loaded = false;
			vm.notesDS = smbDocumentNotesDataStore;
			vm.authService = pxAuthService; 
			vm.notesDS.loadNotes(vm.documentId);
			vm.newCommentText = '';
			vm.postComment = postComment;
	
			function postComment() {
				if (vm.newCommentText) {
					var note = { text: vm.newCommentText };
					vm.notesDS.createNote(vm.documentId, note)
						.then(function() {
							vm.newCommentText = '';
						});
				}
			}
		}
	}());

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbDocumentView', DocumentViewDirective)
			.controller('smbDocumentViewController', [
				'$scope',
				'pxProgressService',
				'smbPanelDetailsDataStore',
				'smbToolbarService',
				'smbDocumentDataStore',
				'smbContentUploadDataStore',
				'smbDocumentViewerNavigationService',
				DocumentViewController
			]);
	
		var templateUrl = __webpack_require__(187);
		function DocumentViewDirective() {
			return {
				restrict: 'E',
				controller: 'smbDocumentViewController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					documentGroupId: '@',
					documentTypeId: '@',
					documentId: '@'
				},
				scope: {}
			};
		}
	
		function DocumentViewController($scope, pxProgressService, smbPanelDetailsDataStore, smbToolbarService, smbDocumentDataStore, smbContentUploadDataStore, smbDocumentViewerNavigationService) {
			var vm = this;
			pxProgressService.visible = true; 
			vm.docPages = [];
			vm.panelDetailsDS = smbPanelDetailsDataStore;
	
			(function initDocumentViewController() {
				smbToolbarService.backArrowState = smbDocumentViewerNavigationService.backState;
				if (smbDocumentViewerNavigationService.backStateParams) {
					smbToolbarService.backArrowStateParams = smbDocumentViewerNavigationService.backStateParams;
				}
	
				loadDoc();
	
				var unsubscribe = smbContentUploadDataStore.onUploadSuccess(function() {
					loadDoc();
				});
	
				$scope.$on('$destroy', function() {
					unsubscribe();
				});
			}());
	
			function loadDoc() {
				return smbDocumentDataStore.loadDocument(vm.documentId)
					.then(function () {
						vm.docPages = smbDocumentDataStore.pageUrls;
					})
					.finally(function(){					
						pxProgressService.visible = false; 
					});
			}
		}
	}());

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbHome', [HomeDirective])
			.controller('HomeController',
			[
				'gettextCatalog',
				'$mdMedia',
				'smbToDoListDataStore',
				'smbToolbarService',
				HomeController
			]);
	
		var templateUrl = __webpack_require__(189);
		function HomeDirective() {
			return {
				restrict: 'E',
				controller: HomeController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function HomeController(gettextCatalog, $mdMedia, smbToDoListDataStore, smbToolbarService) {
			smbToolbarService.reset();
	
			var vm = this;
			vm.media = $mdMedia;
			vm.todoListDS = smbToDoListDataStore;
			vm.items = [
				{ label: gettextCatalog.getString('Find Documents'), icon: 'search', state: 'search.contentTypeGroups' },
				{ label: gettextCatalog.getString('Add Documents'), icon: 'note_add', state: 'import.contentTypeGroups' },
				{ label: gettextCatalog.getString('My To-Do List'), icon: 'assignment', state: 'todo.list', isTodoList: true }
			];
		}
	}());

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	(function() { 
		'use strict';
	
		angular.module('smb-app')
			.directive('smbIcon', IconDirective)
			.controller('smbIconController', ['$scope', 'smbIconTypes', 'smbIconDataStore', IconController]);
	
		var templateUrl = __webpack_require__(190);
		/**
		 * @ngdoc directive
		 * @name smb-app.smbIcon2
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * A component for retrieving and displaying user configurable icons. This component currently only works for
		 * SVG icons. Binary image files are not yet supported, but will be in the future.
		 *
		 * @usage
		 *
		 * <smb-icon icon-uri="https://sharebase-api/icons/document" icon-name="document" icon-type="SVG" />
		 */
		function IconDirective() {
			return {
				restrict: 'E',
				controller: 'smbIconController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					iconUri: '@',
					iconName: '@',
					iconType: '@'
				}
			};
		}
	
		function IconController($scope, smbIconTypes, smbIconDataStore) {
			var vm = this;
			vm.iconTypes = smbIconTypes;
			vm.iconData = null;
	
			var _prevUrl;
	
			function loadIcon() {
				smbIconDataStore.getIconData({IconUri: vm.iconUri, IconExtension: vm.iconType})
					.then(function(data) {
						vm.iconData = data;
					});
			}
	
			$scope.$watch('vm.iconUri', function() {
				if (_prevUrl !== vm.iconUri) {
					_prevUrl = vm.iconUri;
					loadIcon();
				}
			});
	
			loadIcon();
		}
	}());

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(62);
	__webpack_require__(22);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(23);
	__webpack_require__(67);
	__webpack_require__(24);
	__webpack_require__(68);
	__webpack_require__(25);
	__webpack_require__(69);
	__webpack_require__(26);
	__webpack_require__(70);
	__webpack_require__(71);
	__webpack_require__(27);
	__webpack_require__(72);
	__webpack_require__(73);
	__webpack_require__(28);
	__webpack_require__(74);
	__webpack_require__(29);
	__webpack_require__(75);
	__webpack_require__(76);
	__webpack_require__(30);
	__webpack_require__(77);
	__webpack_require__(31);
	__webpack_require__(78);
	__webpack_require__(32);
	__webpack_require__(79);
	__webpack_require__(33);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(34);
	__webpack_require__(82);
	__webpack_require__(35);
	__webpack_require__(83);
	__webpack_require__(36);
	__webpack_require__(84);
	__webpack_require__(37);
	__webpack_require__(85);
	__webpack_require__(38);
	__webpack_require__(86);
	__webpack_require__(39);
	__webpack_require__(188);
	__webpack_require__(87);
	__webpack_require__(40);
	__webpack_require__(88);
	__webpack_require__(41);
	__webpack_require__(90);
	__webpack_require__(42);
	__webpack_require__(91);
	__webpack_require__(43);
	__webpack_require__(92);
	__webpack_require__(44);
	__webpack_require__(93);
	__webpack_require__(45);
	__webpack_require__(94);
	__webpack_require__(46);
	__webpack_require__(95);
	__webpack_require__(47);
	__webpack_require__(96);
	__webpack_require__(48);
	__webpack_require__(97);
	__webpack_require__(49);
	__webpack_require__(98);
	__webpack_require__(50);
	__webpack_require__(99);
	__webpack_require__(51);
	__webpack_require__(100);
	__webpack_require__(52);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(53);
	__webpack_require__(103);
	__webpack_require__(54);
	__webpack_require__(104);
	__webpack_require__(55);
	__webpack_require__(105);
	__webpack_require__(56);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbIndexTypeConfig', IndexTypeConfigDirective)
			.controller('smbIndexTypeConfigController', [
				'gettextCatalog',
				'sbToastService',
				'smbIndexTypesDataTypes',
				IndexTypeConfigController
			]);
	
		var templateUrl = __webpack_require__(191);
		function IndexTypeConfigDirective() {
			return {
				restrict: 'E',
				controller: 'smbIndexTypeConfigController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					currentIndexTypes: '=',
					currentIndexTypesTitle: '@',
					indexTypesPool: '=',
					indexTypesPoolTitle: '@',
					indexTypesPoolAddLabel: '@',
					allowEditName: '=',
					allowEditDefaultValue: '=',
					allowDelete: '=',
					onNewItem: '&',
					onEditItem: '&',
					onDelete: '&',
					enableSequencing: '=',
					onSequence: '&'
				}
			};
		}
	
		function IndexTypeConfigController(gettextCatalog, sbToastService, smbIndexTypesDataTypes) {
			var vm = this;
			vm.active = -1;
			vm.newIndexType = {
				name: '',
				dataType: {val: -1},
				defaultValue: ''
			};
	
			vm.smbIndexTypeDataTypes = smbIndexTypesDataTypes;
			vm.currentIndexTypes = vm.currentIndexTypes || [];
			vm.indexTypesPool = vm.indexTypesPool || [];
	
			vm.currentIndexTypesTitle = vm.currentIndexTypesTitle || gettextCatalog.getString('Curent Index Types');
	
			vm.dataTypes = [
				{
					label: smbIndexTypesDataTypes[smbIndexTypesDataTypes.STRING],
					val: smbIndexTypesDataTypes.STRING
				},
				{
					label: smbIndexTypesDataTypes[smbIndexTypesDataTypes.NUMERIC],
					val: smbIndexTypesDataTypes.NUMERIC
				},
				{
					label: smbIndexTypesDataTypes[smbIndexTypesDataTypes.DATE],
					val: smbIndexTypesDataTypes.DATE
				}
			];
	
			vm.setActive = setActive;
			vm.saveEdit = saveEdit;
			vm.cancelEdit = cancelEdit;
			vm.addIndexType = addIndexType;
			vm.addFromPool = addFromPool;
			vm.remove = remove;
			vm.swapIndexTypesOrder = swapIndexTypesOrder;
	
			Object.defineProperty(vm, 'allowEdit', {
				configurable: false,
				enumerable: true,
				get: function() { return vm.allowEditName || vm.allowEditDefaultValue; }
			});
	
			var activeEdit = null;
	
			function setActive(index) {
				vm.active = index;
				activeEdit = copyIndexType(vm.currentIndexTypes[vm.active]);
			}
	
			function saveEdit() {
				var target = vm.currentIndexTypes[vm.active];
				if (!indexTypeConflict(target)) {
					vm.onEditItem({item: target});
					vm.active = -1;
					activeEdit = null;
				} else {
					indexTypeConflictMessage(target.TagTypeName);
				}
			}
	
			function cancelEdit() {
				vm.currentIndexTypes[vm.active] = activeEdit;
				vm.active = -1;
				activeEdit = null;
			}
	
			function copyIndexType(indexType) {
				return Object.assign({}, indexType, {
					Constraints: Object.assign({}, indexType.Constraints),
					Links: Object.assign({}, indexType.Links)
				});
			}
	
			function addIndexType() {
				if (vm.newIndexType && vm.newIndexType.name && vm.newIndexType.dataType && vm.smbIndexTypeDataTypes[vm.newIndexType.dataType.val]) {
					var newIndexType = {
						TagTypeName: vm.newIndexType.name,
						DataType: vm.newIndexType.dataType.val,
						DataTypeName: vm.smbIndexTypeDataTypes[vm.newIndexType.dataType.val],
						Constraints: {},
						Links: {}
					};
					if (vm.newIndexType.defaultValue) {
						newIndexType.Constraints.DefaultValue = vm.newIndexType.defaultValue;
					}
					if (!indexTypeConflict(newIndexType)) {
						vm.onNewItem({item: newIndexType});
						vm.newIndexType.name = '';
						vm.newIndexType.dataType = {val: -1};
						vm.newIndexType.defaultValue = '';
					} else {
						indexTypeConflictMessage(newIndexType.TagTypeName);
					}
				}
			}
	
			function addFromPool(index) {
				vm.onNewItem({item: vm.indexTypesPool[index]});
			}
	
			function remove(index) {
				vm.onDelete({item: vm.currentIndexTypes[index]});
			}
	
			function indexTypeConflict(indexType) {
				var it = vm.currentIndexTypes.find(function(tt) {
					return tt.TagTypeName.toLowerCase() === indexType.TagTypeName.toLowerCase() && tt.TagTypeId !== indexType.TagTypeId;
				});
	
				if (!it && vm.indexTypesPool) {
					it = vm.indexTypesPool.find(function(tt) {
						return tt.TagTypeName.toLowerCase() === indexType.TagTypeName.toLowerCase() && tt.TagTypeId !== indexType.TagTypeId;
					});
				}
	
				return it ? true : false;
			}
	
			function indexTypeConflictMessage(indexTypeName) {
				var message = gettextCatalog.getString('"{{indexTypeName}}" index type already exists!', { indexTypeName: indexTypeName });
				sbToastService.showSimple(message);
			}
	
			function swapIndexTypesOrder(index1, index2) {
				if (vm.enableSequencing) {
					vm.onSequence({index1: index1, index2: index2});
				}
			}
		}
	}());

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbIndexes',[IndexesDirective])
			.controller('IndexesController', [
				'smbIndexTypesDataTypes',
				IndexesController
			]);
	
		var templateUrl = __webpack_require__(192);
		function IndexesDirective() {
			return {
				restrict: 'E',
				controller: IndexesController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					indextypes: '=',
					status: '='
				}
			};
		}
	
		function IndexesController(smbIndexTypesDataTypes) {
			var vm = this;
			vm.dataTypes = smbIndexTypesDataTypes;
			vm.stringFieldRegex = /^[^<>:"/\\|?*]*$/i;
	
			if(vm.status) {
				Object.defineProperty(vm.status, 'isValid', {
					enumerable: true,
					get : function(){
						return Object.keys(vm.fieldsForm.$error).length < 1;
					}
				});
			}
		}
	}());

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/* globals EasyScroller */
	(function () {
		'use strict';
		/**
		 * @ngdoc directive
		 * @name smb-app.directive:smbItemSelector
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * `smbItemSelector` is a hortizonal scrolling list of items
		 *
		 * @param {array=} items The items to show in scroller
		 *
		 * @param {bool} multiple The ability to select multiple items
		 *
		 * @usage
		 *
		 * <smb-item-selector items="['one', 'two']" multiple="true"/>
		 */
	
		angular.module('smb-app')
			.directive('smbItemSelector', ['$window','$timeout', ItemSelectorDirective])
			.controller('ItemSelectorController', [ItemSelectorController]);
	
		var templateUrl = __webpack_require__(193);
		function ItemSelectorDirective($window, $timeout) {
			return {
				restrict: 'E',
				controller: [ItemSelectorController],
				controllerAs: 'vm',
				bindToController: {
					items: '=',
					multiple: '='
				},
				templateUrl: templateUrl,
				scope: true,
				link: function (scope, element) {
					
				}
			};
		}
	
		function ItemSelectorController() {
			var vm = this;
			vm.toggleSelection = function (item) {
				if (vm.isDragging) { return; }
				if (!vm.multiple) {
					vm.items = vm.items.map(function (i) {
						i.selected = false;
						return i;
					});
					item.selected = true;
					return;
				}
	
				item.selected = !item.selected;
			};
		}
	
	}());

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbLogin', LoginDirective)
			.controller('smbLoginController', [
				'gettextCatalog',
				LoginController
			]);
	
		var templateUrl = __webpack_require__(194);
		/**
		 * @ngdoc directive
		 * @name smb-app.smbLogin
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * @usage
		 *
		 * <smb-login />
		 */
		function LoginDirective() {
			return {
				restrict: 'E',
				controller: 'smbLoginController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: { }
			};
		}
	
		function LoginController(gettextCatalog) {
		}
	}());

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * email address and product type
	 * pending registrations
	 */
	(function() {
		'use strict';
	
		angular
			.module('smb-app')
			.directive('smbRegister', [
				RegisterDirective
			])
			.controller('smbRegisterController', [
				'pxEnvironmentService',
				RegisterController
			]);
	
		var templateUrl = __webpack_require__(195);
		function RegisterDirective() {
			return {
				restrict: 'E',
				controller: 'smbRegisterController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					deploymentId: '@',
					authToken: '@'
				}
			};
		}
	
		function RegisterController(pxEnvironmentService) {
			var vm = this;
			vm.pxEnvironmentService = pxEnvironmentService;
			vm.agreeToTerms = false;
		}
	}());

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbStatus',[StatusDirective])
			.controller('StatusController', [
				StatusController
			]);
	
		var templateUrl = __webpack_require__(196);
		function StatusDirective() {
			return {
				restrict: 'E',
				controller: StatusController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					contentStatuses: '=',
					todoStatuses: '=',
					status: '=',
					onStatusChange: '&'
				}
			};
		}
	
		function StatusController() {
			var vm = this;
			vm.onStatusSelected = onStatusSelected;
	
			function onStatusSelected() {
				vm.onStatusChange();
			}
		}
	}());

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbStatusConfig', StatusConfigDirective)
			.controller('smbStatusConfigController', [
				'gettextCatalog',
				'sbToastService',
				'smbStatusConfigDataStore',
				StatusConfigController
			]);
	
		var templateUrl = __webpack_require__(197);
		function StatusConfigDirective() {
			return {
				restrict: 'E',
				controller: 'smbStatusConfigController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					contentStatuses: '=',
					todoStatuses: '=',
					onStatusChange: '&',
					readonly: '='
				}
			};
		}
	
		function StatusConfigController(gettextCatalog, sbToastService, smbStatusConfigDataStore) {
			var vm = this;
	
			vm.statusDS = smbStatusConfigDataStore;
			vm.existingStatuses = null;
	
			vm.checkExistingStatuses = checkExistingStatuses;
	
			vm.onAddContentStatus = onAddContentStatus;
			vm.onDeleteContentStatus = onDeleteContentStatus;
			vm.onAddToDoStatus = onAddToDoStatus;
			vm.onDeleteToDoStatus = onDeleteToDoStatus;
	
			function checkExistingChips(chip) {
				var g = vm.contentStatuses.find(function(g) { return g === chip; });
				if (!g) {
					g = vm.todoStatuses.find(function(g) { return g === chip; });
				}
	
				return g ? true : false;
			}
	
			function isReadOnly() {
				return !!vm.readonly;
			}
	
			function checkExistingStatuses(status) {
				if (vm.existingStatuses === null) {
					vm.existingStatuses = vm.contentStatuses.concat(vm.todoStatuses);
				}
	
				var exists = checkExistingChips(status);
				if (exists) {
					sbToastService.showSimple(gettextCatalog.getString('Status already exists!'));
					return null;
				}
				return status;
			}
	
			function onAddContentStatus(chip) {
				vm.onStatusChange();
				return chip;
			}
	
			function onAddToDoStatus(chip) {
				vm.onStatusChange();
				return chip;
			}
	
			function onDeleteContentStatus(chip) {
				vm.onStatusChange();
				return chip;
			}
	
			function onDeleteToDoStatus(chip) {
				vm.onStatusChange();
				return chip;
			}
		}
	}());

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbToDoList', [ToDoListDirective])
			.controller('ToDoListController',
			[
				'gettextCatalog',
				'smbToolbarService',
				'smbToDoListDataStore',
				'smbIconTypes',
				'smbDocumentViewerNavigationService',
				ToDoListController
			]);
	
		var templateUrl = __webpack_require__(198);
		function ToDoListDirective() {
			return {
				restrict: 'E',
				controller: ToDoListController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
	
				}
			};
		}
	
		function ToDoListController(gettextCatalog, smbToolbarService, smbToDoListDataStore, smbIconTypes, smbDocumentViewerNavigationService) {
			smbToolbarService.set(gettextCatalog.getString('My To Do List'), 'content.home', false, false);
	
			var vm = this;
			vm.toDoListDS = smbToDoListDataStore;
			vm.viewState = viewState;
			vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
	
			(function loadToDoList() {
				smbToDoListDataStore.getDocuments();
			})();
	
			function viewState(doc) {
				smbDocumentViewerNavigationService.go(doc.LibraryId, doc.FolderId, doc.DocumentId);
			}
		}
	}());


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.directive('smbToDoListContextMenu', ToDoListContextMenuDirective)
			.controller('smbToDoListContextMenuController', [
				'smbToolbarService',
				'smbToDoListDataStore',
				ToDoListContextMenuController
			]);
	
		var templateUrl = __webpack_require__(199);
		function ToDoListContextMenuDirective() {
			return {
				restrict: 'E',
				controller: 'smbToDoListContextMenuController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: { }
			};
		}
	
		function ToDoListContextMenuController(smbToolbarService, smbToDoListDataStore) {
			var vm = this;
			vm.smbToolbarService = smbToolbarService;
			vm.todolistDS = smbToDoListDataStore;
	
			vm.dateAscending = false;
			vm.dateDescending = true;
			vm.typeAscending = false;
			vm.typeDescending = false;
			vm.statusAscending = false;
			vm.statusDescending = false;
	
			vm.sortByDate = sortByDate;
			vm.sortByType = sortByType;
			vm.sortByStatus = sortByStatus;
			vm.dateActive = true;
			vm.typeActive = false;
			vm.statusActive = false;
	
			var ASCENDING = true;
			var DESCENDING = false;
	
			function sortByDate() {
				if (vm.dateActive) {
					vm.dateAscending = !vm.dateAscending;
					vm.dateDescending = !vm.dateDescending;
				}
				else {
					vm.dateActive = true;
					vm.typeActive = false;
					vm.statusActive = false;
					vm.dateAscending = true;
					vm.dateDescending = false;
				}
				if (vm.dateAscending) {
					vm.todolistDS.sortByDate(ASCENDING);
				}
				else {
					vm.todolistDS.sortByDate(DESCENDING);
				}
			}
	
			function sortByType() {
				if (vm.typeActive) {
					vm.typeAscending = !vm.typeAscending;
					vm.typeDescending = !vm.typeDescending;
				}
				else {
					vm.dateActive = false;
					vm.typeActive = true;
					vm.statusActive = false;
					vm.typeAscending = true;
					vm.typeDescending = false;
				}
				if (vm.typeAscending) {
					vm.todolistDS.sortByType(ASCENDING);
				}
				else {
					vm.todolistDS.sortByType(DESCENDING);
				}
			}
	
			function sortByStatus() {
				if (vm.statusActive) {
					vm.statusAscending = !vm.statusAscending;
					vm.statusDescending = !vm.statusDescending;
				}
				else {
					vm.dateActive = false;
					vm.typeActive = false;
					vm.statusActive = true;
					vm.statusAscending = true;
					vm.statusDescending = false;
				}
				if (vm.statusAscending) {
					vm.todolistDS.sortByStatus(ASCENDING);
				}
				else {
					vm.todolistDS.sortByStatus(DESCENDING);
				}
			}
		}
	}());

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(200);
		angular
			.module('smb-app')
			.directive('smbTrash', [
				TrashDirective
			])
			.controller('TrashController', [
				'$q',
				'$mdDialog',
				'pxProgressSerivce',
				'settingsService',
				'sbToastService',
				'smbToolbarService',
				'smbDeletedItemsDataStore',
				'gettextCatalog',
				TrashController
			]);
	
		function TrashDirective() {
			return {
				restrict: 'E',
				controller: TrashController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function TrashController($q, $mdDialog, pxProgressService, settingsService, sbToastService, smbToolbarService, smbDeletedItemsDataStore, gettextCatalog) {
			var vm = this;
			var initTasks = [
				smbDeletedItemsDataStore.load()
			];
			vm.deletedItemsDS = smbDeletedItemsDataStore;
			vm.purge = purge;
			vm.restore = restore;
			vm.purgeAll = purgeAll;
			smbToolbarService.reset();
			smbToolbarService.showLogo = false;
			smbToolbarService.title = gettextCatalog.getString('System Trash');
	
			setLoading(true);
			$q.all(initTasks)
				.finally(setLoading(false));
			
			function purge(event, item) {
				var confirm = $mdDialog.confirm()
					.title(gettextCatalog.getString('Delete'))
					.textContent(gettextCatalog.getString('Would you like to permanently delete "{{name}}"?', {
						name: item.name
					}))
					.ariaLabel(gettextCatalog.getString('Confirm permanent document deletion'))
					.targetEvent(event)
					.ok(gettextCatalog.getString('Permanently Delete'))
					.cancel(gettextCatalog.getString('Cancel'));
	
				$mdDialog
					.show(confirm)
						.then(function () {
						smbDeletedItemsDataStore
							.purge(item)
							.then(function () {
								sbToastService.showSimple(gettextCatalog.getString('Successfully deleted'));
						})
						.catch(function () {
								sbToastService.showSimple(gettextCatalog.getString('Unable to purge item'));
						});
				}, angular.noop);
			}
	
			function purgeAll(event) {
				var confirm = $mdDialog.confirm()
					.title(gettextCatalog.getString('Empty Trash'))
					.textContent(gettextCatalog.getString('Would you like to empty the trash? All documents in the trash will be permanently deleted.'))
					.ariaLabel(gettextCatalog.getString('Confirm emptying trash'))
					.targetEvent(event)
					.ok(gettextCatalog.getString('Empty Trash'))
					.cancel(gettextCatalog.getString('Cancel'));
	
				$mdDialog
					.show(confirm)
					.then(function () {
						smbDeletedItemsDataStore
							.purgeAll()
						.then(function () {
								sbToastService.showSimple(gettextCatalog.getString('Trash was emptied'));
						})
						.catch(function () {
								sbToastService.showSimple(gettextCatalog.getString('Unable to empty trash'));
						});
	
				}, angular.noop);
			}
	
			function restore(item) {
				smbDeletedItemsDataStore
					.restore(item)
					.then(function () {
						sbToastService.showSimple(gettextCatalog.getString('Successfully restored'));
					})
					.catch(function () {
						sbToastService.showSimple(gettextCatalog.getString('Unable to restore document'));
					});
			}
	
			function setLoading(isLoading) {
				isLoading = typeof(isLoading) === 'boolean' ? isLoading : false;
				pxProgressService.visible = isLoading;
			}
		}
	}());

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		/**
		 * @ngdoc directive
		 * @name smb-app.directive:smbadminUser
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * `sbadminInviteUsers` form to invite users to a deployment
		 *
		 * @usage
		 *
		 * <sbadmin-user deployment-id='1' user-id='1' />
		 *
		 *
		 * @element input
		 * @param {number=} userId The id of the deployment to user to view details
		 */
	
		angular.module('smb-app')
			.directive('smbadminUser', UserDirective)
			.controller('smbadminUserController', [
				'$state',
				'sbToastService',
				'smbToolbarService',
				'smbUserDataStore',
				'pxProgressService',
				'gettextCatalog',
				UserController
			]);
	
		var templateUrl = __webpack_require__(201);
		function UserDirective() {
			return {
				restrict: 'E',
				controller: 'smbadminUserController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					userId: '@'
				},
				scope: {}
			};
		}
		function UserController($state, sbToastService, smbToolbarService, smbUserDataStore, pxProgressService, gettextCatalog) {
			var isLoading = true;
			var vm = this;
	
			var title = vm.userId ? gettextCatalog.getString('Edit User') : gettextCatalog.getString('Create User');
			smbToolbarService.set(title, 'useradmin.home.users');
	
			vm.smbUserDataStore = smbUserDataStore;
			vm.updateUserLock = updateUserLock;
			vm.submitForm = submitForm;
			vm.toastVisible = false;
			vm.errorMessage = null;
	
			function updateUserLock() {
				if (isLoading || !vm.userId) { return; }
	
				if (smbUserDataStore.user.IsLocked) {
					smbUserDataStore.lockUser(smbUserDataStore.user.UserId).then(function () {
						var message = gettextCatalog.getString('{{userName}} is now locked', { userName: smbUserDataStore.user.UserName });
						toast(message);
					});
					return;
				}
	
				smbUserDataStore.unlockUser(smbUserDataStore.user.UserId).then(function () {
					var message = gettextCatalog.getString('{{userName}} is now unlocked', { userName: smbUserDataStore.user.UserName });
					toast(message);
				});
			}
	
			function submitSuccess(response) {
				//REMOVE for ticket SBWEB-363
				if (response.Error) {
					submitFailure(response);
					return;
				}
				//end of REMOVE
	
				//success
				//route
				$state.go('^');
	
				var message = vm.userId !== null ? gettextCatalog.getString('User updated successfully') : gettextCatalog.getString('User created successfully');
				toast(message);
			}
	
			function submitFailure(res) {
				// Depending on what type of request we make (create or update) we will get a different type of error object
				// This function handles both expected types of objects and displays messages for those.
				// Create requests (POST) will always get 200 and some API error object, update requests will always return an HTTP error response
				// so we can use the status to determine the error
				var existsError = gettextCatalog.getString('A user with the email address {{address}} already exists', { address: smbUserDataStore.user.EmailAddress });
				if (res.status) {
					// assume HTTP error
					switch (res.status) {
						case 409:
							vm.errorMessage = existsError;
							break;
						case 500:
							// Most likely data is missing from request
							vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred, please make sure all required information has been provided');
							break;
						case 400:
							// Happens when the user does not exist
							vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred, the user you are trying to update could not be found');
							break;
						default:
							vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred. If the problem continues please contact support');
					}
				} else if (res.Error) {
					// API error object
					if (res.UserExists) {
						vm.errorMessage = existsError;
					} else if (res.InvalidPassword) {
						// Invalid password message is translated
						vm.errorMessage = res.Error;
					}
				}
				//failure
				pxProgressService.visible = false;
			}
	
			function submitForm() {
	
				if (!vm.userId) {
					//create user
					if (smbUserDataStore.user.Password !== vm.VerifyPassword) {
						vm.errorMessage = gettextCatalog.getString('Passwords do not match');
						return;
					}
	
					pxProgressService.backdrop = true;
					showLoader();
	
					vm.errorMessage = null;
					smbUserDataStore.addUser(smbUserDataStore.user)
						.then(submitSuccess, submitFailure)
						.finally(hideLoader);
					return;
				}
	
				pxProgressService.backdrop = true;
				showLoader();
				//update user
				smbUserDataStore.updateUser(smbUserDataStore.user).then(submitSuccess, submitFailure)
					.finally(hideLoader);
			}
	
			function toast(message) {
				vm.toastVisible = true;
				sbToastService.showSimple(message)
					.finally(function() {
						vm.toastVisible = false;
					});
			}
	
			function showLoader() {
				pxProgressService.visible = true;
			}
			function hideLoader() {
				isLoading = false;
				pxProgressService.visible = false;
			}
			//initialize
			(function loadUser() {
				pxProgressService.visible = true;
	
				vm.smbUserDataStore.getUser(vm.userId)
					.finally(hideLoader);
			}());
		}
	
	}());

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		angular.module('smb-app')
			.directive('smbUserAdministration',
			[
				UserAdminDirective
			])
			.controller('UserAdminController',
			[
				'smbToolbarService',
				'gettextCatalog',
				UserAdminController
			]);
	
		var templateUrl = __webpack_require__(202);
		function UserAdminDirective() {
			return {
				restrict: 'E',
				controller: UserAdminController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
		function UserAdminController(smbToolbarService, gettextCatalog) {
			smbToolbarService.set(gettextCatalog.getString('User Administration'), 'content.home', false, false);
	
			var vm = this;
		}
	
	}());

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		// user selector template loaded via webpack
		var userSelectorTemplateUrl = __webpack_require__(1);
	
		/**
		 * @ngdoc directive
		 * @name smb-app.directive:smbadminUserGroup
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * `smbadminUserGroup` displays a User Group to add/edit
		 *
		 * @usage
		 *
		 * <smbadmin-UserGroup UserGroup-id="1" />
		 *
		 * @element input
		 * @param {number=} UserGroupId The id of the User Group to display
		 */
	
		angular
			.module('smb-app')
			.directive('smbadminUserGroup',
			[
				UserGroupDirective
			])
			.controller('smbadminUserGroupController',
			[
				'$state',
				'$mdDialog',
				'sbToastService',
				'smbToolbarService',
				'smbUserGroupDataStore',
				'smbUsersDataStore',
				'pxAuthService',
				'pxProgressService',
				'gettextCatalog',
				UserGroupController
			]);
	
		var templateUrl = __webpack_require__(203);
		function UserGroupDirective() {
			return {
				restrict: 'E',
				controller: 'smbadminUserGroupController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
					userGroupId: '@'
				},
				scope: {}
			};
		}
	
		function UserGroupController($state, $mdDialog, sbToastService, smbToolbarService, smbUserGroupDataStore, smbUsersDataStore, pxAuthService, pxProgressService, gettextCatalog) {
			var vm = this;
	
			var title = vm.userGroupId ? gettextCatalog.getString('Edit User Group') : gettextCatalog.getString('Create User Group');
			smbToolbarService.set(title, 'useradmin.home.usergroups');
	
			vm.deploymentId = pxAuthService.deploymentId;
			vm.loading = false;
			vm.doneLoading = doneLoading;
			vm.userGroupDS = smbUserGroupDataStore;
			vm.usersDS = smbUsersDataStore;
			vm.removeUser = removeUser;
			vm.addUsers = addUsers;
			vm.save = save;
			vm.systemName = null;
			vm.userExists = userExists;
	
			var currentUsers = null;
	
			(function initUserGroupController() {
				isLoading();
	
				vm.systemName = pxAuthService.systemName;
				vm.userGroupDS.getUserGroup(vm.userGroupId, vm.systemName)
					.then(function loadUserGroup(group) {
						currentUsers = group.Embedded.Users.map(function (usr) { return Object.assign({}, usr); });
					})
					.then(function loadUsers() {
						smbUsersDataStore.getUsers();
					})
					.finally(doneLoading);
			})();
	
			function userExists(usr) {
				if (!currentUsers) {
					return false;
				}
	
				var exists = false;
				var len = currentUsers.length;
	
				for (var i = 0; i < len && !exists; ++i) {
					if (usr.UserId === currentUsers[i].UserId) {
						exists = true;
					}
				}
	
				return exists;
			}
	
			function addUsers(event) {
				var groupUsers = smbUserGroupDataStore.userGroup.Embedded.Users;
				var newUsers = smbUsersDataStore.users.filter(function (user) {
	
					for (var x = 0; x < groupUsers.length; x++) {
						if (groupUsers[x].UserId === user.UserId) {
							return false;
						}
					}
					return true;
				});
	
				$mdDialog.show({
					controller: 'smbUserSelectorController',
					controllerAs: 'vm',
					templateUrl: userSelectorTemplateUrl,
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						users: newUsers,
						multiSelect: true
					}
				})
				.then(function (selectedUsers) {
					//new users
					for (var i = 0; i < selectedUsers.length; i++) {
						smbUserGroupDataStore.userGroup.Embedded.Users.push(selectedUsers[i]);
					}
				}, function () {
					//cancel
				});
			}
	
			function removeUser(user) {
				var userIndex = smbUserGroupDataStore.userGroup.Embedded.Users.indexOf(user);
				if (userIndex === -1) { return; }
				smbUserGroupDataStore.userGroup.Embedded.Users.splice(userIndex, 1);
			}
	
			function save() {
				pxProgressService.backdrop = true;
				isLoading();
	
				smbUserGroupDataStore.saveUserGroup(vm.systemName)
					.then(function (response) {
						vm.userGroup = response;
						$state.go('^');
						var message = vm.userGroupId ? gettextCatalog.getString('User group saved!') : gettextCatalog.getString('New user group created!');
						sbToastService.showSimple(message);
					})
					.catch(function (e) {
						vm.errorMessage = e.data.Message;
					})
					.finally(doneLoading);
			}
	
			function isLoading() {
				vm.loading = true;
				pxProgressService.visible = true;
			}
	
			function doneLoading() {
				vm.loading = false;
				pxProgressService.visible = false;
			}
	
		}
	})();

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		angular.module('smb-app')
			.directive('smbadminUserGroups', [UserGroupsDirective])
			.controller('smbadminUserGroupsController',
			[
				'$state',
				'smbToolbarService',
				'smbUserGroupsDataStore',
				'pxProgressService',
				'gettextCatalog',
				UserGroupsController
			]);
	
		var templateUrl = __webpack_require__(204);
		function UserGroupsDirective() {
			return {
				restrict: 'E',
				controller: UserGroupsController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
		function UserGroupsController($state, smbToolbarService, smbUserGroupsDataStore, pxProgressService, gettextCatalog) {
			smbToolbarService.set(gettextCatalog.getString('User Groups Configuration'), 'useradmin.home');
	
			var vm = this;
			vm.loading = false;
			vm.userGroupDS = smbUserGroupsDataStore;
			vm.addUserGroup = addUserGroup;
			vm.editUserGroup = editUserGroup;
	
			(function loadUserGroups() {
				isLoading();
				smbUserGroupsDataStore.getUserGroups().finally(doneLoading);
			})();
	
			function editUserGroup(group) {
				$state.go('useradmin.home.usergroups.details', { usergroupId: group.UserGroupId });
			}
	
			function addUserGroup() {
				$state.go('useradmin.home.usergroups.details');
			}
	
			function isLoading() {
				vm.loading = true;
				pxProgressService.visible = true;
			}
	
			function doneLoading() {
				vm.loading = false;
				pxProgressService.visible = false;
			}
		}
	
	}());

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.controller('smbUserSelectorController', [
				'$mdDialog',
				'users',
				'multiSelect',
				UserSelectorController]);
	
		function UserSelectorController($mdDialog, users, multiSelect) {
			var vm = this;
			vm.users = JSON.parse(JSON.stringify(users)); //clear object reference
			vm.fullItems = JSON.parse(JSON.stringify(users));
			vm.multiple = multiSelect ? true : false;
			vm.style = { width: (vm.fullItems.length * 170) + 'px' };
			vm.filterPhrase = '';
	
			vm.cancel = function () {
				$mdDialog.cancel();
			};
			vm.add = function () {
				$mdDialog.hide(vm.users.filter(function (user) { return user.selected; }));
			};
	
			vm.filter = function () {
				if (vm.filterPhrase === '') {
					vm.users = JSON.parse(JSON.stringify(vm.fullItems));
					return;
				}
				
				var filter = vm.filterPhrase.toLowerCase();
				vm.users = vm.fullItems.filter(function (item) {
					if (item.UserGroupId) {
						return item.UserGroupName.toLowerCase().indexOf(filter) > -1;
					}
					else if (item.UserId) {
						var nameEmail = item.UserName.toLowerCase() + ' ' + item.EmailAddress.toLowerCase();
						return nameEmail.toLowerCase().indexOf(filter) > -1;
					}
					else if (item.StatusType) {
						return item.Label.toLowerCase().indexOf(filter) > -1;
					}
					else if (item.IconUserFriendlyName) {
						return item.IconUserFriendlyName.toLowerCase().indexOf(filter) > -1;
					}
				});
	
			};
		}
	}());

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
	
		/**
		 * @ngdoc directive
		 * @name smb-app.directive:smbadminUsers
		 * @module smb-app
		 * @restrict E
		 * @description
		 *
		 * `smbadminUsers` displays a deployments users
		 *
		 * @usage
		 *
		 * <sbadmin-users deployment-id="1" />
		 *
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */
	
		angular.module('smb-app')
			.directive('smbadminUsers', [UsersDirective])
			.controller('smbadminUsersController',
			[
				'$state',
				'gettextCatalog',
				'pxProgressService',
				'smbToolbarService',
				'smbUsersDataStore',
				UsersController
			]);
	
		var templateUrl = __webpack_require__(205);
		function UsersDirective() {
			return {
				restrict: 'E',
				controller: 'smbadminUsersController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {}
			};
		}
	
		function UsersController($state, gettextCatalog, pxProgressService, smbToolbarService, smbUsersDataStore) {
			var vm = this;
			smbToolbarService.set(gettextCatalog.getString('Users Configuration'), 'useradmin.home');
	
			vm.smbUsersDataStore = smbUsersDataStore;
			vm.pxProgressService = pxProgressService;
			vm.editUser = editUser;
			vm.createUser = createUser;
	
			function editUser(user) {
				$state.go('useradmin.home.users.details', { userId: user.UserId });
			}
	
			function createUser() {
				$state.go('useradmin.home.users.details', { userId: '' });
			}
	
			//initialize
			(function loadUsers() {
				pxProgressService.visible = true;
				vm.smbUsersDataStore.getUsers().finally(function () { pxProgressService.visible = false; });
			}());
		}
	
	}());

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeConfigDataStore', 
			[
				'$q', 
				'smbContentTypeConfigService',
				'smbStatusConfigService',
				'smbContentTypeTagTypeConfigDataStore',
				ContentTypeConfigDataStore
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeConfigDataStore
		 * 
		 * @description
		 * Data store that manages state for the content type configuration section.
		 */
		function ContentTypeConfigDataStore($q, smbContentTypeConfigService, smbStatusConfigService, smbContentTypeTagTypeConfigDataStore) {
	
			var _contentType;
			var _newContentType = {
				FolderName: '',
				IconName: ''
			};
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeConfigDataStore.getContentType
				 * @methodOf smb-app.smbContentTypeConfigDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads the data store with a content type by id
				 * 
				 * @param {String} groupId Id of the content type group the type belongs to
				 * @param {String} id The content type id
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the content type being loaded
				 */
				getContentType: getContentType,
				
				/**
				 * @ngdoc method
				 * @name smbContentTypeConfigDataStore.saveContentType
				 * @methodOf smb-app.smbContentTypeConfigDataStore
				 * @kind function
				 * 
				 * @description
				 * Saves changes to the current content type. Creates it if it is a new one and
				 * updates it if it is an existing one.
				 * 
				 * @param {String} groupId The id of the content type group it belongs to
				 * @param {ContentType} contentType The content type object to save.
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the saved content type
				 */
				saveContentType: saveContentType,
	
				/**
				 * @ngdoc property
				 * @name smbContentTypeConfigDataStore.contentType
				 * @propertyOf smb-app.smbContentTypeConfigDataStore
				 * @kind property
				 * 
				 * @description
				 * Returns the current content type
				 */
				get contentType() { return _contentType; }
			};
	
			function getContentType(groupId, id) {
				if (!id) {
					_contentType = angular.copy(_newContentType);
					return $q.resolve(_contentType);
				}
	
				return smbContentTypeConfigService.getContentType(groupId, id)
					.then(function (response) {
						_contentType = response;
						return response;
					});
			}
	
			function saveContentType(groupId, contentType) {
				var folder = null;
				if (contentType.FolderId) {
					return smbContentTypeConfigService.updateContentType(groupId, contentType)
						.then(function(res) {
							_contentType = res;
							return res;
						});
				} else {
					return smbContentTypeConfigService.addContentType(groupId, contentType)
						.then(function(res) {
							_contentType = res;
							return res;
						})
						.then(function loadStatuses() {
							return smbStatusConfigService.getStatuses(groupId);
						})
						.then(function mapStatuses(statuses) {
							return smbContentTypeTagTypeConfigDataStore.setTagTypes(_contentType.FolderId, statuses);
						});
				}
			}
		}
	
	}());

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupConfigDataStore',
			[
				'$q',
				'smbUserGroupFilterService',
				'smbLibraryConfigService',
				'smbContentTypeGroupConfigService',
				'smbAclService',
				'smbContentTypeGroupTagTypeConfigService',
				ContentTypeGroupDataStore
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupConfigDataStore
		 *
		 * @description
		 * A data store for managing local content type groups state for
		 * the configuration section.
		 */
		function ContentTypeGroupDataStore($q, smbUserGroupFilterService, smbLibraryConfigService, smbContentTypeGroupConfigService, smbAclService, smbContentTypeGroupTagTypeConfigService) {
			var _contentTypeGroup = null;
			var _contentTypeGroupDetails = null;
	
			var _userGroupsWithViewRights = null;
			var _userGroupsWithFullRights = null;
	
			var _newContentTypeGroup = {
				ContentTypeGroupName: '',
				Icon: ''
			};
	
			// Create the following Status related indexes when creating a Library and assign to itself
			var _contentStatus = {
				TagTypeName: '&&_AirBase_Content_Status',
				DataType: 0
			};
	
			var _todoStatus = {
				TagTypeName: '&&_AirBase_ToDo_Status',
				DataType: 0
			};
	
			var _assignedUserId = {
				TagTypeName: '&&_AirBase_Assigned_UserId',
				DataType: 1
			};
	
			var _assignedDate = {
				TagTypeName: '&&_AirBase_Assigned_Date',
				DataType: 2
			};
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypeGroupConfigDataStore#getContentTypeGroup
				 * @propertyOf smb-app.smbContentTypeGroupConfigDataStore
				 * @kind property
				 *
				 * @description
				 * The currently selected content type group.
				 */
				getContentTypeGroup: getContentTypeGroup,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupConfigDataStore#saveContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Add/Edit a content type group in the system.
				 *
				 * @param {Object} group An object that represents a new content type group
				 * @param {String} group.id The id of the group being edited (only for edit)
				 * @param {String} group.name The name of the new content type group
				 * @param {String} group.icon The name of the selected icon for the new content type group
				 */
				saveContentTypeGroup: saveContentTypeGroup,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupConfigDataStore#assignUserGroupsToContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Assign User Groups to Content Type Group
				 *
				 * @param {Object} group An object that represents a new content type group
				 * @param {String} group.id The id of the group being edited (only for edit)
				 * @param {String} group.name The name of the new content type group
				 * @param {String} group.icon The name of the selected icon for the new content type group
				 */
				assignUserGroupsToContentTypeGroup: assignUserGroupsToContentTypeGroup,
	
				get contentTypeGroup() { return _contentTypeGroup; },
	
				get contentTypeGroupDetails() { return _contentTypeGroupDetails; },
	
				get userGroupsWithViewRights() { return smbUserGroupFilterService.getUserGroupsWithViewRights(); },
	
				get userGroupsWithFullRights() { return smbUserGroupFilterService.getUserGroupsWithFullRights(); },
	
				get userGroupsWithEditRights() { return smbUserGroupFilterService.getUserGroupsWithEditRights(); },
	
				saveUserGroups: saveUserGroups
			};
	
			function getContentTypeGroup(contentTypeGroupId) {
				if (!contentTypeGroupId) {
					_contentTypeGroup = angular.copy(_newContentTypeGroup);
					_contentTypeGroupDetails = [];
	
					smbUserGroupFilterService.filterUserGroups(_contentTypeGroupDetails);
	
					return $q.resolve(_contentTypeGroup);
				}
				return smbLibraryConfigService
					.getLibrary(contentTypeGroupId)
					.then(function (response) {
						_contentTypeGroup = response;
						return response;
					})
					.then(function (contentTypeGroup) {
						return smbLibraryConfigService
							.getLibraryDetails(contentTypeGroup);
					})
					.then(function (details) {
						_contentTypeGroupDetails = details;
	
						smbUserGroupFilterService.filterUserGroups(details);
	
						return _contentTypeGroup;
					});
	
			}
	
			function saveContentTypeGroup(contentTypeGroup)
			{
				var lib = null;
				if (contentTypeGroup.id) {
					lib = { LibraryId: contentTypeGroup.id, LibraryName: contentTypeGroup.name, IconId: contentTypeGroup.icon };
					return smbContentTypeGroupConfigService.editContentTypeGroup(lib)
						.then(function (response) {
							_contentTypeGroup = response;
							return response;
						});
				}
				else {
					lib = { LibraryName: contentTypeGroup.name, IconId: contentTypeGroup.icon };
					return smbContentTypeGroupConfigService.createContentTypeGroup(lib)
						.then(function (response) {
							_contentTypeGroup = response;
							return response;
						})
						.then(function createContentStatus() {
							return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _contentStatus);
						})
						.then(function createToDoStatus() {
							return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _todoStatus);
						})
						.then(function createAssignedUserId() {
							return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _assignedUserId);
						})
						.then(function createAssignedDate() {
							return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _assignedDate);
						});
				}
			}
	
			function saveUserGroups(viewUserGroups, fullUserGroups, editUserGroups) {
				viewUserGroups = viewUserGroups.map(function(g) {
					return smbAclService.createViewAccessRights(_contentTypeGroup.LibraryId, g);
				});
	
				fullUserGroups = fullUserGroups.map(function(g) {
					return smbAclService.createFullAccessRights(_contentTypeGroup.LibraryId, g);
				});
	
				editUserGroups = editUserGroups.map(function(g) {
					return smbAclService.createEditAccessRights(_contentTypeGroup.LibraryId, g);
				});
	
				return smbAclService.saveDocumentGroupAcls(_contentTypeGroup.LibraryId, viewUserGroups.concat(fullUserGroups).concat(editUserGroups));
			}
	
			function assignUserGroupsToContentTypeGroup(acls)
			{
				return smbLibraryConfigService.assignUserGroupsToLibrary(acls, _contentTypeGroup.LibraryId);
			}
		}
	}());

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupTagTypesConfigDataStore', [
				'$q',
				'smbContentTypeGroupTagTypeConfigService',
				'smbIndexTypesDataTypes',
				ContentTypeGroupTagTypesConfigDataStore
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupTagTypesConfigDataStore
		 *
		 * @description
		 * State management of tag types for content type group configuration.
		 */
		function ContentTypeGroupTagTypesConfigDataStore($q, smbContentTypeGroupTagTypeConfigService, smbIndexTypesDataTypes) {
	
			var _tagTypes;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypeGroupTagTypesConfigDataStore#tagTypes
				 * @propertyOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
				 * @kind property
				 *
				 * @description
				 * Get a colleciton of @see TagType objects that have previously been loaded.
				 *
				 * @returns {TagType[]} A collection of @see TagType objects
				 */
				get tagTypes() { return _tagTypes; },
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupTagTypesConfigDataStore#getTagTypes
				 * @propertyOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Load all tag types for a single content type group.
				 *
				 * @returns {Deferred<TagType[]>} A promise that resolves to a collection
				 * of @see TagType objects.
				 */
				getTagTypes: getTagTypes,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupTagTypesConfigDataStore#addTagType
				 * @propertyOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Create a new tag type and add it to the tagTypes property
				 *
				 * @returns {Deferred<TagType>} A promise that resolves to the newly
				 * created tag type.
				 */
				addTagType: addTagType,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupTagTypesConfigDataStore#editTagType
				 * @methodOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Saves changes to an existing @see TagType object.
				 *
				 * @param {ObjectId} groupId Id of the document type group that owns the tag type.
				 * @param {TagType} tagType The tag type object to save.
				 *
				 * @returns {Promise<TagType>} A promise that resolves to the saved tag type.
				 */
				editTagType: editTagType
			};
	
			function getTagTypes(groupId) {
				if (!(typeof groupId === 'number' || typeof groupId === 'string') || groupId === '') {
					_tagTypes = [];
					return $q.resolve(_tagTypes);
				}
	
				return smbContentTypeGroupTagTypeConfigService.getTagTypes(groupId)
					.then(function(tagTypes) {
						_tagTypes = tagTypes.filter(function filterStatuses(tagtype) {
							return !(tagtype.TagTypeName.match(/&&_AirBase_.*/));
						})
						.map(function(tagType) {
							if (tagType.DataType === smbIndexTypesDataTypes.NUMERIC && tagType.Constraints && tagType.Constraints.DefaultValue) {
								tagType.Constraints.DefaultValue = tagType.Constraints.DefaultValue.indexOf('.') >= 0 ?
									parseFloat(tagType.Constraints.DefaultValue) : parseInt(tagType.Constraints.DefaultValue, 10);
							}
	
							return tagType;
						});
						return tagTypes;
					});
			}
	
			function editTagType(groupId, tagType) {
				if (typeof groupId !== 'number' && typeof groupId !== 'string') {
					return $q.reject(new Error('Missing required group id'));
				} else if (!tagType) {
					return $q.reject(new Error('Missing required tag type'));
				} else if (!tagType.TagTypeName) {
					return $q.reject(new Error('The tag type must have a name'));
				} else if (!smbIndexTypesDataTypes[tagType.DataType]) {
					return $q.reject(new Error('The tag type must have a data type'));
				} else if (!tagType.TagTypeId) {
					return $q.reject(new Error('Missing required tag type id'));
				}
	
				return smbContentTypeGroupTagTypeConfigService.editTagType(groupId, tagType)
					.then(function(data) {
						if (!_tagTypes) {
							_tagTypes = [];
						}
						_tagTypes = _tagTypes.map(function(tt) { return tt.TagTypeId === tagType.TagTypeId ? data : tt; });
					});
			}
	
			function addTagType(groupId, tagType) {
				if (typeof groupId !== 'number' && typeof groupId !== 'string') {
					return $q.reject(new Error('Missing required group id'));
				} else if (!tagType) {
					return $q.reject(new Error('Missing required tag type'));
				} else if (!tagType.TagTypeName) {
					return $q.reject(new Error('The tag type must have a name'));
				} else if (!smbIndexTypesDataTypes[tagType.DataType]) {
					return $q.reject(new Error('The tag type must have a data type'));
				}
	
				return smbContentTypeGroupTagTypeConfigService.createTagType(groupId, tagType)
					.then(function(data) {
						if (!_tagTypes) {
							_tagTypes = [];
						}
						_tagTypes.push(data);
						return data;
					});
			}
		}
	}());

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupsConfigDataStore', ['$q', 'smbLibraryConfigService', ContentTypeGroupsConfigDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupsConfigDataStore
		 * 
		 * @description
		 * A data store for managing local content type groups state for
		 * the configuration section.
		 */
		function ContentTypeGroupsConfigDataStore($q, smbLibraryConfigService) {
			var _groups;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypeGroupsConfigDataStore#groups
				 * @propertyOf smb-app.smbContentTypeGroupsConfigDataStore
				 * @kind property
				 * 
				 * @description
				 * An array of all content type groups in the system.
				 */
				get groups() { return _groups; },
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsConfigDataStore#loadGroups
				 * @methodOf smb-app.smbContentTypeGroupsConfigDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads all content type groups from the API.
				 * 
				 * @returns {Promise} A promise that resolves to an array of all content type groups in the system.
				 */
				loadGroups: loadGroups,
				/**
				* @ngdoc method
				* @name smbContentTypeGroupsConfigDataStore#deleteGroup
				* @methodOf smb-app.smbContentTypeGroupsConfigDataStore
				* @kind function
				* 
				* @description
				* Deletes a content type group.
				* 
				* @param {Number} groupId The document type group id.
				* @param {Boolean} purge Permanently deleted the document type group if true.
				* @returns {Promise} A promise that resolves if the delete was successful.
				*/
				deleteGroup: deleteGroup
			};
	
			function loadGroups() {
				return smbLibraryConfigService.getLibraries()
					.then(function (libraries) {
						_groups = libraries.map(function mapLibraryDetails(lib) {
							return {
								id: lib.LibraryId,
								name: lib.LibraryName,
								icon: lib.IconName,
								links: {
									self: lib.Links.Self,
									icon: lib.Links.IconUri
								}
							};
						});
	
						return _groups;
					});
			}
	
			function deleteGroup(groupId) {
				if (!groupId) {
					return $q.resolve(new Error('No type ID provided.'));
				} else {
					return smbLibraryConfigService
						.deleteLibrary(groupId)
						.then(function(){
							_groups = _groups.filter(function(library){
								return library.id !== groupId;
							});
						});
				}
			}
		}
	}());

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeTagTypeConfigDataStore', [
				'$q',
				'smbContentTypeTagTypeConfigService',
				'smbIndexTypesDataTypes',
				ContentTypeTagTypeConfigDataStore
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeTagTypeConfigDataStore
		 *
		 * @description
		 * Manages state for index type configuration at the content type level
		 */
		function ContentTypeTagTypeConfigDataStore($q, smbContentTypeTagTypeConfigService, smbIndexTypesDataTypes) {
	
			var _tagTypes;
			var _contentStatus;
			var _todoStatus;
			var _assignedUserId;
			var _assignedDate;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypeTagTypeConfigDataStore#tagTypes
				 * @methodOf smb-app.smbContentTypeTagTypeConfigDataStore
				 * @kind property
				 *
				 * @description
				 * Holds the current collection of tag types for a single content type.
				 *
				 * @returns {TagType[]} A collection of @see TagType objects
				 */
				get tagTypes() { return _tagTypes; },
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeTagTypeConfigDataStore#getTagTypes,
				 * @methodOf smb-app.smbContentTypeTagTypeConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Gets the tag types for a content type and sets the tagTypes property
				 *
				 * @param {String|Number} id The content type id
				 *
				 * @returns {Promise<TagType[]>} A promise that resolves to a collection of
				 * @see TagType objects
				 */
				getTagTypes: getTagTypes,
	
				get contentStatus() { return _contentStatus; },
	
				get todoStatus() { return _todoStatus; },
	
				get assignedUserId() { return _assignedUserId; },
	
				get assignedDate() { return _assignedDate; },
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeTagTypeConfigDataStore#setTagTypes
				 * @methodOf smb-app.smbContentTypeTagTypeConfigDataStore
				 * @kind function
				 *
				 * @description
				 * Sets the tag type associations for a content type. This function
				 * will completely replace the current collection of tag types for a
				 * content type.
				 *
				 * @param {String|Number} id The content type id
				 * @param {TagType[]} tagTypes The tag types to associate the content type with
				 *
				 * @returns {Promise<TagType[]>} A promise that resolves to the tag types given as an argument.
				 */
				setTagTypes: setTagTypes
			};
	
			function getTagTypes(id) {
				if (!(typeof id === 'number' || typeof id === 'string') || id === '') {
					_tagTypes = [];
					return $q.resolve(_tagTypes);
				}
	
				return smbContentTypeTagTypeConfigService.getTagTypes(id)
					.then(function(tt) {
						_tagTypes = tt.map(function(tagType) {
							if (tagType.DataType === smbIndexTypesDataTypes.NUMERIC && tagType.Constraints && tagType.Constraints.DefaultValue) {
								tagType.Constraints.DefaultValue = tagType.Constraints.DefaultValue.indexOf('.') >= 0 ?
									parseFloat(tagType.Constraints.DefaultValue) : parseInt(tagType.Constraints.DefaultValue, 10);
							}
	
							return tagType;
						});
	
						_contentStatus = _tagTypes.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_Content_Status/);
						});
						_todoStatus = _tagTypes.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_ToDo_Status/);
						});
						_assignedUserId = _tagTypes.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
						});
						_assignedDate = _tagTypes.filter(function(tt) {
							return tt.TagTypeName.match(/&&_AirBase_Assigned_Date/);
						});
						return _tagTypes;
					});
			}
	
			function setTagTypes(id, tagTypes) {
				if (!(typeof id === 'number' || typeof id === 'string')) {
					return $q.reject(new Error('Missing required document type id'));
				} else if (!tagTypes) {
					return $q.reject(new Error('Missing required tag types'));
				}
	
				var associations = tagTypes.map(function(tt) { return {TagTypeId: tt.TagTypeId, Constraints: tt.Constraints}; });
				return smbContentTypeTagTypeConfigService.setTagTypes(id, associations)
					.then(function() {
						_tagTypes = tagTypes;
						return _tagTypes;
					});
			}
		}
	
	}());

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbStatusConfigDataStore', [
				'$q', 
				'smbStatusConfigService', 
				StatusConfigDataStore
				]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbStatusConfigDataStore
		 * 
		 * @description
		 * Data store that manages state for the content type configuration section.
		 */
		function StatusConfigDataStore($q, smbStatusConfigService) {
	
			var _contentStatus;
			var _todoStatus;
			var _assignedUserId;
			var _assignedDate;
	
			var _contentStatusValues = [];
			var _todoStatusValues = [];
	
			return {
				/**
				 * @ngdoc method
				 * @name smbStatusConfigDataStore.getContentStatuses
				 * @methodOf smb-app.smbStatusConfigDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads the data store with a content type by id
				 * 
				 * @param {String} groupId Id of the content type group the type belongs to
				 * @param {String} id The content type id
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the content type being loaded
				 */
				get contentStatus() { return _contentStatus; },
	
				get todoStatus() { return _todoStatus; },
	
				get contentStatusValues() { return _contentStatusValues; },
	
				get todoStatusValues() { return _todoStatusValues; },
	
				get assignedUserId() { return _assignedUserId; },
	
				get assignedDate() { return _assignedDate; },
	
				loadStatuses: loadStatuses,
	
				// loadStatusValues: loadStatusValues,
				
				/**
				 * @ngdoc method
				 * @name smbStatusConfigDataStore.saveContentStatuses
				 * @methodOf smb-app.smbStatusConfigDataStore
				 * @kind function
				 * 
				 * @description
				 * Saves changes to the current content type. Creates it if it is a new one and
				 * updates it if it is an existing one.
				 * 
				 * @param {String} groupId The id of the content type group it belongs to
				 * @param {ContentType} contentType The content type object to save.
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the saved content type
				 */
	
				saveStatuses: saveStatuses
			};
	
			function loadStatuses(groupId) {
				return smbStatusConfigService.getStatuses(groupId)
				.then(function mapStatuses(statuses) {
					_contentStatus = statuses.filter(function filterCStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_Content_Status/);
					});
					_todoStatus = statuses.filter(function filterTStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_ToDo_Status/);
					});
					_assignedUserId = statuses.filter(function filterCStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
					});
					_assignedDate = statuses.filter(function filterTStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_Assigned_Date/);
					});
					return statuses;
				});
			}
	
			// function loadStatusValues(folderId, contentStatus, todoStatus) {
			// 	return smbStatusConfigService.getStatusValues(folderId, contentStatus.TagTypeId)
			// 			.then(function setContentStatusValues(response) {
			// 				_contentStatusValues = response.data;
			// 				return response.data;
			// 			})
			// 			.then(function loadToDoStatusValues() {
			// 				return smbStatusConfigService.getStatusValues(folderId, todoStatus.TagTypeId);
			// 			})
			// 			.then(function setToDoStatusValues(response) {
			// 				_todoStatusValues = response.data;
			// 				return response.data;
			// 			});
			// }
	
			function saveStatuses(folderId, contentStatus, todoStatus) {
				return smbStatusConfigService.setStatuses(folderId, contentStatus.TagTypeId, contentStatus.Constraints)
					.then(function saveToDoStatuses() {
						return smbStatusConfigService.setStatuses(folderId, todoStatus.TagTypeId, todoStatus.Constraints);
					});
			}
		}
	}());

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		
		angular.module('smb-app')
			.factory('smbContentSearchDataStore', ['$q', 'smbContentSearchService', ContentSearchDataStore]);
		
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesDataStore
		 * 
		 * @description
		 * Manages the state for the content types configuration.
		 */
		function ContentSearchDataStore($q, smbContentSearchService) {
			var _groupId;
			var _typeId;
			var _tagValues = [];
	
			var _documents = null;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypesDataStore.contentTypes
				 * @propertyOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * All content types that belong to the current content type group.
				 */
				get documents() {
					return _documents;
				},
	
				/**
				 * @ngdoc method
				 * @name smbContentTypesDataStore.getDocuments
				 * @methodOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * Loads and returns all content types for a specific content type group by group id.
				 * 
				 * @param {Number} groupId The content type group id
				 * 
				 * @returns {Deferred} A promise that resolves to a collection of content types.
				 */
				getDocuments: getDocuments,
	
				getContentTypeGroupSearchResults: getContentTypeGroupSearchResults,
				
				setTagValues: setTagValues
			};	
	
			function getDocuments(groupId, typeId) {
				return smbContentSearchService.getDocuments(groupId, typeId, _tagValues)
						.then(function (types) {
							_documents = types.map(function(doc) {
								var d;
								d = doc;
								var index = doc.DocumentAutoName ? doc.DocumentAutoName.indexOf('&&_AirBase_') : -1;
								if (index !== -1) {
									d.DocumentAutoName = doc.DocumentAutoName.substring(0, index > 0 ? index - 5 : 0);
								}
								var contentStatus = doc.StatusInformation.filter(function(tt) {
									return (tt.TagTypeName.match(/&&_AirBase_Content_Status/));
								});
								var todoStatus = doc.StatusInformation.filter(function(tt) {
									return (tt.TagTypeName.match(/&&_AirBase_ToDo_Status/));
								});
								if (contentStatus != null && contentStatus.length > 0 && contentStatus[0].Tags[0].length > 0) {
									d.Status = contentStatus[0].Tags[0];
								}
								else if (todoStatus != null && todoStatus.length > 0 && todoStatus[0].Tags[0].length > 0) {
									d.Status = todoStatus[0].Tags[0];
								}
								else {
									d.Status = '';
								}
								return d;
							});
							return types;
						});
			}
	
			function getContentTypeGroupSearchResults(groupId) {
				return smbContentSearchService.getContentTypeGroupSearchResults(groupId, _tagValues)
						.then(function (types) {
							_documents = types.map(function(doc) {
								var d;
								d = doc;
								var index = doc.DocumentAutoName ? doc.DocumentAutoName.indexOf('&&_AirBase_') : -1;
								if (index !== -1) {
									d.DocumentAutoName = doc.DocumentAutoName.substring(0, index > 0 ? index - 5 : 0);
								}						
								var contentStatus = doc.StatusInformation.filter(function(tt) {
									return (tt.TagTypeName.match(/&&_AirBase_Content_Status/));
								});
								var todoStatus = doc.StatusInformation.filter(function(tt) {
									return (tt.TagTypeName.match(/&&_AirBase_ToDo_Status/));
								});
								if (contentStatus != null && contentStatus.length > 0 && contentStatus[0].Tags[0].length > 0) {
									d.Status = contentStatus[0].Tags[0];
								}
								else if (todoStatus != null && todoStatus.length > 0 && todoStatus[0].Tags[0].length > 0) {
									d.Status = todoStatus[0].Tags[0];
								}
								else {
									d.Status = '';
								}
								return d;
							});
							return types;
						});
			}
	
			function setTagValues(tagValues) {
				_tagValues = tagValues
				.filter(function filterTags(t) {
						if (t.indexValue) {
							return t;
						}
					})
					.map(function mapSearchTags(tag) {
					var mappedTag = {};
					mappedTag.TagTypeId = tag.TagTypeId;
					if (tag.DataTypeName === 'Date')
					{
						var date = tag.indexValue;
	
						var mm = date.getMonth() + 1;
						if (mm < 10)
						{
							mm = '0' + mm;
						}
						
						var dd = date.getDate();
						if (dd < 10)
						{
							dd = '0' + dd;
						}
	
						mappedTag.Value = [mm, dd, date.getFullYear()].join('');
					}
					else
					{
						mappedTag.Value = tag.indexValue;
					}
					return mappedTag;
				});
			}
			
		}
	}());

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupsDataStore', ['$q', 'smbContentTypeGroupsService', contentTypeGroupsDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupsDataStore
		 * 
		 * @description
		 * A data store for managing local content type groups state for
		 * the configuration section.
		 */
		function contentTypeGroupsDataStore($q, smbContentTypeGroupsService) {
			var _allGroups;
			var _fullAccessGroups;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypeGroupsDataStore#groups
				 * @propertyOf smb-app.smbContentTypeGroupsDataStore
				 * @kind property
				 * 
				 * @description
				 * An array of all content type groups in the system.
				 */
				get allGroups() { return _allGroups; },
	
				get fullAccessGroups() { return _fullAccessGroups; },
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsDataStore#loadGroups
				 * @methodOf smb-app.smbContentTypeGroupsDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads all content type groups from the API.
				 * 
				 * @returns {Promise} A promise that resolves to an array of all content type groups in the system.
				 */
				loadAllGroups: loadAllGroups,
	
				loadFullAccessGroups: loadFullAccessGroups
			};
	
			function loadAllGroups() {
				return smbContentTypeGroupsService.getAllContentTypeGroups()
					.then(function (groups) {
						return groups.map(function mapLibraryDetails(lib) {
							return {
								id: lib.LibraryId,
								name: lib.LibraryName,
								icon: lib.IconName,
								links: {
									self: lib.Links.Self,
									icon: lib.Links.IconUri
								}
							};
						});
					})
					.then(function (groups) {
						_allGroups = groups;
						return groups;
					});
			}
	
			function loadFullAccessGroups() {
				return smbContentTypeGroupsService.getFullAccessContentTypeGroups()
					.then(function (groups) {
						return groups.map(function mapLibraryDetails(lib) {
							return {
								id: lib.LibraryId,
								name: lib.LibraryName,
								icon: lib.IconName,
								links: {
									self: lib.Links.Self,
									icon: lib.Links.IconUri
								}
							};
						});
					})
					.then(function (groups) {
						_fullAccessGroups = groups;
						return groups;
					});
			}
		}
	}());

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupsSearchDataStore', ['$q', 'smbContentTypeGroupsSearchService', contentTypeGroupsSearchDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupsDataStore
		 * 
		 * @description
		 * A data store for managing local content type groups state for
		 * the configuration section.
		 */
		function contentTypeGroupsSearchDataStore($q, smbContentTypeGroupsSearchService) {
			var _allGroups;
			var _fullAccessGroups;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypeGroupsDataStore#groups
				 * @propertyOf smb-app.smbContentTypeGroupsDataStore
				 * @kind property
				 * 
				 * @description
				 * An array of all content type groups in the system.
				 */
				get allGroups() { return _allGroups; },
	
				get fullAccessGroups() { return _fullAccessGroups; },
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsDataStore#loadGroups
				 * @methodOf smb-app.smbContentTypeGroupsDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads all content type groups from the API.
				 * 
				 * @returns {Promise} A promise that resolves to an array of all content type groups in the system.
				 */
				loadAllGroups: loadAllGroups,
	
				loadFullAccessGroups: loadFullAccessGroups
			};
	
			function loadAllGroups() {
				return smbContentTypeGroupsSearchService.getAllContentTypeGroups()
					.then(function (groups) {
						return groups.map(function mapLibraryDetails(lib) {
							return {
								id: lib.LibraryId,
								name: lib.LibraryName,
								icon: lib.IconName,
								links: {
									self: lib.Links.Self,
									icon: lib.Links.IconUri
								}
							};
						});
					})
					.then(function (groups) {
						_allGroups = groups;
						return groups;
					});
			}
	
			function loadFullAccessGroups() {
				return smbContentTypeGroupsSearchService.getFullAccessContentTypeGroups()
					.then(function (groups) {
						return groups.map(function mapLibraryDetails(lib) {
							return {
								id: lib.LibraryId,
								name: lib.LibraryName,
								icon: lib.IconName,
								links: {
									self: lib.Links.Self,
									icon: lib.Links.IconUri
								}
							};
						});
					})
					.then(function (groups) {
						_fullAccessGroups = groups;
						return groups;
					});
			}
		}
	}());

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		
		angular.module('smb-app')
			.factory('smbContentTypesDataStore', ['$q', 'smbContentTypesService', ContentTypesDataStore]);
		
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesDataStore
		 * 
		 * @description
		 * Manages the state for the content types configuration.
		 */
		function ContentTypesDataStore($q, smbContentTypesService) {
			var _groupId;
			var _contentTypes;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypesDataStore.contentTypes
				 * @propertyOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * All content types that belong to the current content type group.
				 */
				get contentTypes() {
					return _contentTypes;
				},
	
				/**
				 * @ngdoc method
				 * @name smbContentTypesDataStore.getContentTypes
				 * @methodOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * Loads and returns all content types for a specific content type group by group id.
				 * 
				 * @param {Number} groupId The content type group id
				 * 
				 * @returns {Deferred} A promise that resolves to a collection of content types.
				 */
				getContentTypes: getContentTypes,
				/**
				 * @ngdoc method
				 * @name smbContentTypesDataStore.deleteContentType
				 * @methodOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * Deletes a document type with the specified ID.
				 * 
				 * @param {Number} typeId The document type id
				 * 
				 * @returns {Deferred} A promise that will resolve if the deletion was successful.
				 */
				deleteContentType: deleteContentType
			};	
	
			function getContentTypes(groupId) {
				if (!groupId) {
					return $q.resolve(_contentTypes);
				} else {
					return smbContentTypesService.getContentTypes(groupId)
						.then(function (types) {
							_contentTypes = types;
							_groupId = groupId;
							return types;
						});
				}
			}
	
			function deleteContentType(typeId, purge){
				if (!typeId) {
					return $q.resolve(new Error('No type ID provided.'));
				} else {
					return smbContentTypesService
						.deleteContentType(typeId, purge)
						.then(function(){
							_contentTypes = _contentTypes.filter(function(contentType){
								return contentType.FolderId !== typeId;
							});
						});
				}
			}
		}
	}());

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		
		angular.module('smb-app')
			.factory('smbContentTypesSearchDataStore', ['$q', 'smbContentTypesSearchService', ContentTypesSearchDataStore]);
		
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesDataStore
		 * 
		 * @description
		 * Manages the state for the content types configuration.
		 */
		function ContentTypesSearchDataStore($q, smbContentTypesSearchService) {
			var _groupId;
			var _contentTypes;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypesDataStore.contentTypes
				 * @propertyOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * All content types that belong to the current content type group.
				 */
				get contentTypes() {
					return _contentTypes;
				},
	
				/**
				 * @ngdoc method
				 * @name smbContentTypesDataStore.getContentTypes
				 * @methodOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * Loads and returns all content types for a specific content type group by group id.
				 * 
				 * @param {Number} groupId The content type group id
				 * 
				 * @returns {Deferred} A promise that resolves to a collection of content types.
				 */
				getContentTypes: getContentTypes
			};	
	
			function getContentTypes(groupId) {
				if (!groupId) {
					return $q.resolve(_contentTypes);
				} else {
					return smbContentTypesSearchService.getContentTypes(groupId)
						.then(function (types) {
							_contentTypes = types;
							_groupId = groupId;
							return types;
						});
				}
			}
	
		}
	}());

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		
		angular.module('smb-app')
			.factory('smbContentUploadDataStore', ['$http', '$q', 'gettextCatalog', 'sbToastService', 'smbContentUploadService', ContentUploadDataStore]);
		
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentUploadDataStore
		 * 
		 * @description
		 * Manages the state for the content types configuration.
		 */
		function ContentUploadDataStore($http, $q, gettextCatalog, sbToastService, smbContentUploadService) {
			var _uploadedDocument = null;
			var _uploadHandlers = [];
	
			return {
	
				get uploadedDocument() {
					return _uploadedDocument;
				},
				
				uploadDocument: uploadDocument,
	
				/**
				 * @ngdoc method
				 * @name smbContentUploadDataStore#onUploadSuccess
				 * @methodOf smb-app.smbContentUploadDataStore
				 * @kind function
				 * 
				 * @description
				 * Add a function that gets called when a file is successfully uploaded.
				 * 
				 * @param {Function} handler The function to be called when a file is uploaded
				 * @returns {Function} A function that can be called to remove your handler.
				 * 
				 * @example
				 *     function SomeController($scope, smbContentUploadDataStore) {
				 *         var removeHandler = smbContentUploadDataStore.onUploadSuccess(function() {
				 *             console.log('uploaded a new file');
				 *         });
				 * 		   $scope.$on('$destroy', function() {
				 *             removeHandler();
				 *         });
				 *     }
				 */
				onUploadSuccess: onUploadSuccess,
	
				/**
				 * @ngdoc method
				 * @name smbContentUploadDataStore#uploadRevision
				 * @methodOf smb-app.smbContentUploadDataStore
				 * @kind function
				 * 
				 * @description
				 * Upload a file as a new revision for an existing document
				 * 
				 * @param {Number} documentId Id of the document that gets the new revision
				 * @param {Object} file Browser file object for the file to upload.
				 * 
				 * @returns {Deferred} A promise
				 */
				uploadRevision: uploadRevision,
	
				/**
				 * @ngdoc method
				 * @name smbContentUploadDataStore#promoteRevision
				 * @methodOf smb-app.smbContentUploadDataStore
				 * @kind function
				 * 
				 * @description
				 * Promote a document revision to the current revsion
				 * This will be treated as an uploaded file, therefore the upload handlers will be executed on success.
				 * 
				 * @param {Object} revision The revision object to promote
				 * @returns {Deferred} A promise that resolves to the document that was saved as the current revision.
				 */
				promoteRevision: promoteRevision
			};
	
			function onUploadSuccess(handler) {
				if (typeof handler !== 'function') {
					return;
				}
	
				_uploadHandlers.push(handler);
				return function() {
					var i = _uploadHandlers.indexOf(handler);
					_uploadHandlers.splice(i, 1);
				};
			}
	
			function uploadRevision(documentId, file) {
				return smbContentUploadService.uploadRevision(documentId, file)
					.then(function(res) {
						_uploadedDocument = res;
						_uploadHandlers.forEach(function(handler) { handler(_uploadedDocument); });
						return _uploadedDocument;
					});
			}
	
			function uploadDocument(folderId, file) {
				return smbContentUploadService.uploadFile(folderId, file)
				.then(function(response) {
					_uploadedDocument = response;
					_uploadHandlers.forEach(function(handler) { handler(_uploadedDocument); });
					return _uploadedDocument;
				})
				.catch(function(err) {
					sbToastService.showSimple(err.data.Message);
				});
			}
	
			function promoteRevision(document) {
				return $http.post(document.Links.PromoteUri)
					.then(function(response) {
						_uploadedDocument = response;
						_uploadHandlers.forEach(function(handler) { handler(_uploadedDocument); });
						return _uploadedDocument;
					});
			}
		}
	}());

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular
			.module('smb-app')
			.factory('smbDeletedItemsDataStore', [
				'$q',
				'smbDeletedItemsService',
				DeletedItemsDataStore
			]);
	
		function DeletedItemsDataStore($q, smbDeletedItemsService){
			var _adminTrash;
	
			return {
				/**
				 * @ngdoc method
				 * @name smbDocumentDataStore#load
				 * @methodOf smb-app.smbDeletedItemsDataStore
				 * @kind function
				 *
				 * @description
				 * Loads the trash for the AirBase deployment.
				 *
				 * @returns {Deferred} Returns a promise that resolves to an object containing admin trash.
				 */
				load: load,
				/**
				 * @ngdoc method
				 * @name smbDocumentDataStore#purge
				 * @methodOf smb-app.smbDeletedItemsDataStore
				 * @kind function
				 *
				 * @description
				 * Permanently deleted the provided item.
				 *
				 * @param {object} purgeddItem The trash item to permanently delete.
				 * @returns {Deferred} Returns a promise that resolves if the deletio nwas successful
				 */
				purge: purge,
				/**
				 * @ngdoc method
				 * @name smbDocumentDataStore#purgeAll
				 * @methodOf smb-app.smbDeletedItemsDataStore
				 * @kind function
				 *
				 * @description
				 * Permanently deleteds all admin trash items in the datastore.
				 *
				 * @returns {Deferred} Returns a promise that resolves if all individual purges succeeded.
				 */
				purgeAll: purgeAll,
				/**
				 * @ngdoc method
				 * @name smbDocumentDataStore#restore
				 * @methodOf smb-app.smbDeletedItemsDataStore
				 * @kind function
				 *
				 * @description
				 * Restores the provided item from the trash.
				 *
				 * @param {object} restoredItem The trash item to restore.
				 * @returns {Deferred} Returns a promise that resolves to a server representation of the restored item.
				 */
				restore: restore,
				/**
				 * @ngdoc property
				 * @name smbDocumentDataStore#adminTrash
				 * @propertyOf smb-app.smbDocumentDataStore
				 * @kind property
				 *
				 * @description
				 * Gets the administratively viewable trash for the deployment.
				 *
				 * @returns {array} Returns a list of deleted admins from the deployment.
				 */
				get adminTrash() { return _adminTrash; }
			};
	
			function load() {
				return smbDeletedItemsService
					.getAdminTrash()
					.then(function(trash){
						_adminTrash = trash.map(function(t){
							return new DeletedItem(t);
						});
	
						return _adminTrash;
					});
			}
	
			function purge(purgedItem) {
				var embedded = purgedItem.__data.Embedded;
				return smbDeletedItemsService
					.purge(embedded.Document || embedded.Folder)
					.then(function(item){
						_adminTrash = _adminTrash.filter(function(t){
							return t.id !== purgedItem.id;
						});
	
						return purgedItem;
					});
			}
	
			function restore(restoredItem) {
				return smbDeletedItemsService
					.restore(restoredItem.__data)
					.then(function(item){
						_adminTrash = _adminTrash.filter(function(t){
							return t.id !== restoredItem.id;
						});
	
						return item;
					});
			}
	
			function purgeAll() {
				var purgePromises = _adminTrash.map(function(t){
					var embedded = t.__data.Embedded;
					return smbDeletedItemsService.purge(embedded.Document || embedded.Folder);
				});
	
				return $q.all(purgePromises)
					.then(function(){
						_adminTrash = [];
					});
			}
		}
	
		function DeletedItem(trash) {
			var isDoc = !!trash.Embedded.Document;
			this.id = isDoc ? trash.Embedded.Document.DocumentId :  trash.Embedded.Folder.FolderId;
	
			// differentiate folders and documents with shared IDs in the client
			this.id += ('-' + Date.now());
	
			this.name = getItemName(isDoc, trash);
			this.icon = {
				uri : isDoc ? trash.Links.FolderIconUri : trash.Embedded.Folder.Links.IconUri,
				name : isDoc ? '' : trash.Embedded.Folder.IconName
			};
			this.deleted = trash.DateDeleted;
			this.deletedBy = trash.DeletedByUserName;
			this.__data = trash;
		}
	
		/**
		 * @private
		 * @description
		 * Helper function that returns the correct name to use based on the item type.
		 *
		 * @param {boolean} isDoc Set to true if the item is a document and false if it is not.
		 * @param {Object} item The item to get the name from.
		 * @returns {string} Returns a string that can be used as the items display name in the trash.
		 */
		function getItemName(isDoc, item) {
			if (!isDoc) {
				return item.ItemName;
			}
	
			// Truncate any status value from the auto name
			// Statuses are set as tag types that have the prefix &&_AirBase,
			// so find the first instance of this and remove everything after it.
			// We substract 5 from the index so as to remove any trailing pipes as well.
			// This may be unneccessary as well, it looks like status value are not being
			// added to the auto name anymore, this just needs to be confirmed.
			var name = item.Embedded.Document.DocumentAutoName;
			if (name === null) {
				// If there is no autoname, the value will be null,
				// so set it to an empty string, so there are no null reference errors.
				name = '';
			}
			var index = name.indexOf('&&_AirBase_');
			if (index >= 0) {
				name = name.substring(0, index > 0 ? index - 5 : 0);
			}
	
			return name;
		}
	})();

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular
			.module('smb-app')
			.factory('smbDocumentDataStore', [
				'$q',
				'sbDocumentService',
				'smbAclService',
				'SMB_RIGHTS',
				'SMB_RIGHTS_TYPE',
				DocumentDataStore
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentDataStore
		 *
		 * @description
		 * A datastore that manages the state of a document and its content.
		 */
		function DocumentDataStore($q, sbDocumentService, smbAclService, SMB_RIGHTS, SMB_RIGHTS_TYPE) {
	
			var _document = null;
			var _pageCount = null;
			var _pages = [];
			var _acl = null;
	
			return {
				/**
				 * @ngdoc method
				 * @name smbDocumentDataStore#loadDocument
				 * @methodOf smb-app.smbDocumentDataStore
				 * @kind function
				 *
				 * @description
				 * Loads a document by id
				 *
				 * @param {String} documentId The document id
				 *
				 * @returns {Deferred} Returns a promise that resolves to an object that represents a document.
				 */
				loadDocument: loadDocument,
	
				loadUserPermissions: loadUserPermissions,
				delete: deleteDocument,
	
				get document() { return _document; },
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDataStore#pageCount
				 * @propertyOf smb-app.smbDocumentDataStore
				 * @kind property
				 *
				 * @description
				 * Gets the number of pages in the document
				 *
				 * @returns {number} Returns the number of pages in the selected document.
				 */
				get pageCount() { return _pageCount; },
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDataStore#pages
				 * @propertyOf smb-app.smbDocumentDataStore
				 * @kind function
				 *
				 * @description
				 * Gets the document pages
				 *
				 * @returns
				 * Returns an array of object that represent the document pages
				 */
				get pages() { return _pages; },
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDataStore#pageUrls
				 * @propertyOf smb-app.smbDocumentDataStore
				 * @kind property
				 *
				 * @description
				 * Get an array of urls that can be used to retrieve the individual
				 * pages of a document.
				 *
				 * @returns {String[]} An array of urls as strings.
				 */
				get pageUrls() {
					// pxScrollViewer will not retrieve an updated page if the url has not changed
					// which it doesn't in our case
					var cacheBust = new Date().getTime();
					return _pages.map(function(p) { return p.Url + '&airbase_cache_bust=' + cacheBust; });
				},
	
				get acl() { return _acl; },
	
				get canEditFields() { return this.canEditStatus; },
	
				get canEditStatus() { return !!_acl && (_acl.hasAdminAccess() || _acl.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights].param)); },
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDataStore#hasFullRights
				 * @propertyOf smb-app.smbDocumentDataStore
				 * @kind property
				 *
				 * @description
				 * Returns true if the current user has full rights to the current document.
				 */
				get hasFullRights() { return !!_acl && (_acl.hasAdminAccess() || _acl.hasFullAccess()); }
			};
	
			function loadDocument(documentId) {
				return sbDocumentService
					.getDocument(documentId)
					.then(function (docView) {
						_document = docView;
						_pageCount = docView.PageCount;
	
						_pages = [];
						for (var i = 1; i <= docView.PageCount; i++) {
							_pages.push({
								Id: i,
								Url: docView.PageTemplate.replace(docView.PageTemplateParam, i)
							});
						}
	
						return _document;
					});
			}
	
			function loadUserPermissions(documentGroupId) {
				return smbAclService.getUserPermissionsForDocumentGroup(documentGroupId)
					.then(function(acl) {
						_acl = acl;
						return _acl;
					});
			}
	
			function deleteDocument(purge){
				if(!_document) {
					return $q.reject(new Error('No document loaded.'));
				} 
				
				return sbDocumentService
					.deleteDocument(_document.Embedded.Document.DocumentId, purge)
					.then(function(){
						_document = null;
					});				
			}
		}
	}());

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbDocumentDetailsPanelDataStore', ['smbPanelDetailsDataStore', DocumentDetailsPanelDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentDetailsPanelDataStore
		 *
		 * @description
		 * This datastore manages the state of the document details related content
		 * within the application's side panel. It consumes the general smbPanelDetailsDataStore
		 * to control the side panel itself.
		 */
		function DocumentDetailsPanelDataStore(smbPanelDetailsDataStore) {
			// Panel names
			var _fieldPanel = 'index-panel';
			var _fieldEdit = 'index-edit';
			var _history = 'history';
			var _comments = 'comments';
	
			var _currentPanel;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbDocumentDetailsPanelDataStore#showFieldPanel
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Returns true if the document field panel should be displayed in
				 * the document details panel.
				 */
				get showFieldPanel() { return _currentPanel === _fieldPanel; },  /* TODO: Change name to `showFieldPanel` */
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDetailsPanelDataStore#showFieldEdit
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Returns true if the field edit form should be displayed in the document details panel.
				 */
				get showFieldEdit() { return _currentPanel === _fieldEdit; }, /* TODO: Change name to `showFieldEdit` */
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDetailsPanelDataStore#showHistory
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Returns true if the history panel should be displayed in the document details panel.
				 */
				get showHistory() { return _currentPanel === _history; },
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDetailsPanelDataStore#showComments
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Returns true if the comments panel should be displayed in the document details panel.
				 */
				get showComments() { return _currentPanel === _comments; },
	
				/**
				 * @ngdoc property
				 * @name smbDocumentDetailsPanelDataStore#fieldPanel
				 * @propertyOf smb-app.smbDcoumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Constant that represents the name of the field panel.
				 */
				get fieldPanel() { return _fieldPanel; },
	
				/**
				 * @ngdoc property
				 * @name smbDcoumentDetailsPanelDataStore#fieldEditPanel
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Constant that represents the name of the field edit form panel.
				 */
				get fieldEditPanel() { return _fieldEdit; },
	
				/**
				 * @ngdoc property
				 * @name smbDcoumentDetailsPanelDataStore#historyPanel
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Constant that represents the name of the history panel.
				 */
				get historyPanel() { return _history; },
	
				/**
				 * @ngdoc property
				 * @name smbDcoumentDetailsPanelDataStore#commentsPanel
				 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind property
				 *
				 * @description
				 * Constant that represents the name of the comments panel.
				 */
				get commentsPanel() { return _comments; },
	
				/**
				 * @ngdoc method
				 * @name smbDcoumentDetailsPanelDataStore#toggle
				 * @methodOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind method
				 *
				 * @description
				 * Toggle the document details side panel with a specific page of the panel.
				 * If passing the name of the panel page that is currently displayed, it will
				 * close the entire side panel. If the side panel is already open but toggled
				 * with a different page, the side panel will stay open and will switch to
				 * the new page. If the argument is not a valid document details panel page,
				 * then nothing happens.
				 *
				 * @param {string} panelName Then name of document details panel to display.
				 */
				toggle: toggle,
	
				/**
				 * @ngdoc method
				 * @name smbDcoumentDetailsPanelDataStore#closePanel
				 * @methodOf smb-app.smbDocumentDetailsPanelDataStore
				 * @kind method
				 *
				 * @description
				 * Closes the document details panel as well as the general app side panel.
				 */
				closePanel: closePanel
			};
	
			function closePanel() {
				_currentPanel = undefined;
				smbPanelDetailsDataStore.reset();
			}
	
			function toggle(panelName) {
				if (!smbPanelDetailsDataStore.isOpen) {
					_currentPanel = undefined;
				}
	
				if ([_fieldPanel, _fieldEdit, _history, _comments].indexOf(panelName) < 0) {
					return;
				}
	
				if (panelName === _currentPanel) {
					// close the panel
					closePanel();
				} else {
					if (!_currentPanel) {
						smbPanelDetailsDataStore.toggle();
					}
					_currentPanel = panelName;
				}
			}
		}
	}());

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbDocumentHistoryDataStore', ['smbDocumentHistoryService', DocumentHistoryDataStore]);
			
		var tokenRegex = /\[@(.*?)\[\/\]/g; 
		// will capture with User=5]john from [@User=5]john[/]
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentNotesDataStore
		 * 
		 * @description
		 * Manages state for the notes for a single document.
		 */
		function DocumentHistoryDataStore(smbDocumentHistoryService) {
			var _history;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbDocumentNotesDataStore#notes
				 * @propertyOf smb-app.smbDocumentNotesDataStore
				 * @kind property
				 * 
				 * @description
				 * Returns the current collection of notes
				 * 
				 * @returns {DocumentNote[]} An array of @see DocumentNote objects
				 */
				get history() { return _history; },
	
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesDataStore#loadNotes
				 * @propertyOf smb-app.smbDocumentNotesDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads the document notes for a specific document by id
				 * 
				 * @param {String} documentId The document id
				 * 
				 * @returns {Deferred<DocumentNote[]>} A promise that resolves to a collection of @see DocumentNote objects
				 */
				loadHistory: loadHistory
	
			};
	
			function loadHistory(documentId) {
				return smbDocumentHistoryService.getHistory(documentId)
					.then(function(history) {
						
						_history = history.map(function(hi) { 
							var final = hi.Message.replace('&&_AirBase_Assigned_Date', 'assigned date')
							.replace('&&_AirBase_ToDo_Status', 'To Do Status')
							.replace('&&_AirBase_Content_Status', 'Status')
							.replace('&&_AirBase_Assigned_UserId', 'assgined user')
							.replace(/\./g, '');
							return {'Message' : tokenStringFilterReplace(final), 'UserName': hi.UserName, 'ActivityDate': tokenStringExtractDate(final)};
						});
						return _history;
					});
			}
	
			function tokenStringFilterReplace (str) {
				if (!str) {
					return str;
				}
	
				return str.replace(tokenRegex, function (token, capture) {
					// the captured text is in the form "User=5]john"
					var parts = capture.split(']');
					var attrPart = parts[0].split('=');
					if (attrPart[0] === 'User') {
						return '';
					}
					if (attrPart[0] === 'Document') {
						return '';
					}
					if (attrPart[0] === 'Action' && attrPart[1] === 'tagged') {
						return 'modified field value on';
					}
					if (attrPart[0] === 'Action' && attrPart[1] === 'untagged') {
						return 'removed field value ';
					}
					if (attrPart[0] === 'Action' && attrPart[1] === 'commented') {
						return 'commented ';
					}
					if (attrPart[0] === 'Date') {
						return '';
					}
					
					var message = parts[1];
					return parts[1];
				});
			}
	
			function tokenStringExtractDate(str) {
				if (!str) {
					return str;
				}
	
				var datestring = '';
				str = str.replace(tokenRegex, function (token, capture) {
					// the captured text is in the form "User=5]john"
					var parts = capture.split(']');
					var attrPart = parts[0].split('=');
					if (attrPart[0] === 'Date') {
						datestring = parts[1];
						return parts[1];
					}				
					return '';
				});
	
				return datestring + '.';
			}
		}
	}());

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbDocumentIndexDataStore', [
				'$q',
				'smbIndexTypesDataTypes',
				'smbIndexTypesService',
				DocumentIndexDataStore
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentIndexDataStore
		 *
		 * @description
		 * Service for managing index values for a single document
		 */
		function DocumentIndexDataStore($q, smbIndexTypesDataTypes, smbIndexTypesService) {
	
			var _indexTypes;
			var _indexValues;
			var _documentId;
			var _contentTypeId;
	
			return {
	
				get indexTypes() { return _indexTypes; },
				get indexValues() { return _indexValues; },
	
				get indexTypePanelModel() {
					return _indexTypes.map(function(indexType) {
						var val = _indexValues.find(function(iv) { return iv.TagTypeName === indexType.TagTypeName; });
						var temp = angular.extend({}, indexType);
						if (val && val.Tags && val.Tags.length > 0) {
							temp.defaultValue = val.Tags[0];
						}
	
						if (temp.DataType === smbIndexTypesDataTypes.NUMERIC) {
							temp.defaultValue = parseFloat(temp.defaultValue);
						}
	
						return temp;
					});
				},
	
				getIndexes: getIndexes
	
			};
	
			function getIndexes(documentId, contentTypeId, useCached) {
				if (canUseCached(documentId, contentTypeId, useCached)) {
					return $q.resolve(_indexValues);
				} else {
					return smbIndexTypesService.getIndexTypes(contentTypeId)
						.then(function(types) {
							_indexTypes = types.filter(function(tt) {
								return !(tt.TagTypeName.match(/&&_AirBase_.*/));
							});
							_contentTypeId = contentTypeId;
							return smbIndexTypesService.getDocumentIndexes(documentId);
						})
						.then(function(data) {
							_documentId = documentId;
							_indexValues = [];
	
							var sequence = 0;
	
							_indexValues = data.TypedTags.filter(function(tt) {
								return !(tt.TagTypeName.match(/&&_AirBase_.*/));
							})
							.map(function(tt) {
								var val = tt.Tags[0];
								var indexType = _indexTypes.find(function(it) { return it.TagTypeName === tt.TagTypeName; });
	
								if (indexType && indexType.DataType === smbIndexTypesDataTypes.NUMERIC && val) {
									tt.Tags[0] = toNumber(val);
									tt.isNumber = true;
								} else if (indexType && indexType.DataType === smbIndexTypesDataTypes.DATE && val) {
									tt.Tags[0] = toDate(val);
									tt.isDate = true;
								}
	
								var i = _indexTypes.indexOf(indexType);
								if (i < 0) {
									i = sequence;
								}
	
								tt.sequence = i;
								sequence++;
								return tt;
							});
							return _indexValues;
						});
				}
			}
	
			function canUseCached(documentId, contentTypeId, useCached) {
				return useCached && documentId === _documentId && contentTypeId === _contentTypeId &&
					_indexTypes && _indexValues;
			}
	
			function toNumber(val) {
				if (!val && typeof val !== 'number') {
					return;
				}
	
				var num = parseFloat(val);
				return isNaN(num) ? undefined : num;
			}
	
			function toDate(val) {
				if (!val) {
					return;
				}
	
				var m = parseInt(val.substr(0, 2));
				var d = parseInt(val.substr(2, 2));
				var y = parseInt(val.substr(4));
	
				return new Date(y, m - 1, d);
			}
		}
		
	}());

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbDocumentNotesDataStore', ['smbDocumentNotesService', DocumentNotesDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentNotesDataStore
		 * 
		 * @description
		 * Manages state for the notes for a single document.
		 */
		function DocumentNotesDataStore(smbDocumentNotesService) {
			var _notes;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbDocumentNotesDataStore#notes
				 * @propertyOf smb-app.smbDocumentNotesDataStore
				 * @kind property
				 * 
				 * @description
				 * Returns the current collection of notes
				 * 
				 * @returns {DocumentNote[]} An array of @see DocumentNote objects
				 */
				get notes() { return _notes; },
	
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesDataStore#loadNotes
				 * @propertyOf smb-app.smbDocumentNotesDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads the document notes for a specific document by id
				 * 
				 * @param {String} documentId The document id
				 * 
				 * @returns {Deferred<DocumentNote[]>} A promise that resolves to a collection of @see DocumentNote objects
				 */
				loadNotes: loadNotes,
	
				createNote: createNote
			};
	
			function loadNotes(documentId) {
				return smbDocumentNotesService.getNotes(documentId)
					.then(function(notes) {
						notes.reverse();
						_notes = notes;
						return notes;
					});
			}
	
			function createNote(documentId, note) {
				return smbDocumentNotesService.createNote(documentId, note)
					.then(function(data) {
						if (!_notes) {
							_notes = [];
						}
						_notes.unshift(data);
						return data;
					});
			}
		}
	
	}());

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbIconDataStore', ['$q', '$sce', 'smbIconService', IconDataStore]);
	
		/**
		 * @typedef {Object} Icon
		 * @property {String} IconFriendlyUserName A human readable label for an icon
		 * @property {String} IconExtension The icon data type as a capitalized version of the extension
		 * @property {String} IconUri The url to get the icon data
		 */
	
		function IconDataStore($q, $sce, smbIconService) {
			var _icons;
	
			return {
				get icons() { return _icons; },
				loadIcons: loadIcons,
				getIconData: getIconData
			};
	
			function loadIcons() {
				if (!_icons) {
					return smbIconService.getIcons()
						.then(function(data) {
							_icons = data;
							return data;
						});
				} else {
					return $q.resolve(_icons);
				}
			}
	
			function getIconData(icon) {
				return smbIconService.getIconData(icon.IconUri, icon.IconExtension)
					.then(function(data) {
						var iconImage = { isBinary: data.isBinary };
						if (data.isBinary) {
							var blob = new Blob([data.imageData], {type: data.contentType});
							var objUrl = URL.createObjectURL(blob);
							iconImage.data = objUrl;
						} else {
							iconImage.data = $sce.trustAsHtml(data.imageData);
						}
						return iconImage;
					});
			}
		}
	}());

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(112);
	__webpack_require__(113);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(130);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(133);

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbIndexTypesDataStore', ['$q', 'smbIndexTypesService', 'smbIndexTypesDataTypes', IndexTypesDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbIndexTypesDataStore
		 *
		 * @description
		 * Manages the state for the content types configuration.
		 */
		function IndexTypesDataStore($q, smbIndexTypesService, smbIndexTypesDataTypes) {
			var _typeId;
			var _groupId;
			var _indexTypes;
			var _groupIndexTypes;
			var _contentStatus = {
				TagTypeId: 0,
				Value: ''
			};
			var _todoStatus = {
				TagTypeId: 0,
				Value: ''
			};
			var _assignedUserId = {
				TagTypeId: 0,
				Value: ''
			};
			var _assignedDate = {
				TagTypeId: 0,
				Value: ''
			};
	
			return {
				/**
				 * @ngdoc property
				 * @name smbIndexTypesDataStore.indexTypes
				 * @propertyOf smb-app.smbIndexTypesDataStore
				 *
				 * @description
				 * All content types that belong to the current content type group.
				 */
				get indexTypes() {
					return _indexTypes;
				},
	
				get groupIndexTypes() {
					return _groupIndexTypes;
				},
	
				get contentStatusId() { return _contentStatus.TagTypeId; },
	
				get todoStatusId() { return _todoStatus.TagTypeId; },
	
				get assignedUserId() { return _assignedUserId.TagTypeId; },
	
				get assignedDateId() { return _assignedDate.TagTypeId; },
	
				/**
				 * @ngdoc method
				 * @name smbIndexTypesDataStore.getindexTypes
				 * @methodOf smb-app.smbIndexTypesDataStore
				 *
				 * @description
				 * Loads and returns all content types for a specific content type group by group id.
				 *
				 * @param {Number} groupId The content type group id
				 *
				 * @returns {Deferred} A promise that resolves to a collection of content types.
				 */
				getIndexTypes: getIndexTypes,
	
				getDocumentTypeGroupIndexTypes: getDocumentTypeGroupIndexTypes,
	
				setIndexTypes: setIndexTypes
			};
	
			function getIndexTypes(typeId) {
				if (!typeId) {
					return $q.resolve(_indexTypes);
				} else {
					return smbIndexTypesService.getIndexTypes(typeId)
						.then(function(types) {
							_contentStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
								return tagtype.TagTypeName.match(/&&_AirBase_Content_Status/);
							})[0].TagTypeId;
	
							_todoStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
								return tagtype.TagTypeName.match(/&&_AirBase_ToDo_Status/);
							})[0].TagTypeId;
	
							_assignedUserId.TagTypeId = types.filter(function filterStatuses(tagtype) {
								return tagtype.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
							})[0].TagTypeId;
	
							_assignedDate.TagTypeId = types.filter(function filterStatuses(tagtype) {
								return tagtype.TagTypeName.match(/&&_AirBase_Assigned_Date/);
							})[0].TagTypeId;
							return types;
						})
						.then(function (types) {
							_indexTypes = types.filter(function filterStatuses(tagtype) {
								return !(tagtype.TagTypeName.match(/&&_AirBase_.*/));
							})
							.map(function(tt) {
								if (tt.DataType === smbIndexTypesDataTypes.NUMERIC && tt.Constraints && tt.Constraints.DefaultValue) {
									var val = tt.Constraints.DefaultValue;
									tt.Constraints.DefaultValue = val.indexOf('.') >= 0 ? parseFloat(val) : parseInt(val, 10);
								}
								return tt;
							})
							.map(function(tt) {
								if (tt.Constraints) {
									tt.defaultValue = tt.Constraints.DefaultValue;
								}
								return tt;
							});
	
							_typeId = typeId;
							return types;
						});
				}
			}
	
			function getDocumentTypeGroupIndexTypes(groupId) {
				if (!groupId) {
					return $q.resolve(_groupIndexTypes);
				} else {
					return smbIndexTypesService.getDocumentTypeGroupIndexTypes(groupId)
						.then(function (types) {
							_groupId = groupId;
							_groupIndexTypes = types
								.filter(function filterStatuses(tagtype) {
									return !(tagtype.TagTypeName.match(/&&_AirBase_.*/));
								})
								.map(function(it) {
									if (it.Constraints) {
										it.defaultValue = it.Constraints.DefaultValue;
									}
	
									if (it.DataType === smbIndexTypesDataTypes.NUMERIC) {
										it.indexValue = +it.IndexValue;
	
										if(angular.isDefined(it.defaultValue)) { 
											it.defaultValue = +it.defaultValue;
										}									
									}
									
									return it;
								});
							
							return _groupIndexTypes;
						});
				}
			}
	
			function setIndexTypes(indexes, documentId, typeId) {
				var tagcollection = indexes
				.filter(function filterTags(t) {
						if (t.indexValue) {
							return t;
						}
					}
				)
				.map(function mapTags(t) {
					var tag = {};
					tag.TagTypeId = t.TagTypeId;
	
					if (t.DataTypeName === 'Date')
					{
						var date = t.indexValue;
	
						var mm = date.getMonth() + 1;
						if (mm < 10)
						{
							mm = '0' + mm;
						}
	
						var dd = date.getDate();
						if (dd < 10)
						{
							dd = '0' + dd;
						}
	
						tag.Value = [mm, dd, date.getFullYear()].join('');
					}
					else
					{
						tag.Value = t.indexValue;
					}
	
					return tag;
				});
	
				return smbIndexTypesService.getIndexTypes(typeId)
				.then(function(types) {
					_contentStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
						return tagtype.TagTypeName.match(/&&_AirBase_Content_Status/);
					})[0].TagTypeId;
	
					_todoStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
						return tagtype.TagTypeName.match(/&&_AirBase_ToDo_Status/);
					})[0].TagTypeId;
	
					_assignedUserId.TagTypeId = types.filter(function filterStatuses(tagtype) {
						return tagtype.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
					})[0].TagTypeId;
	
					_assignedDate.TagTypeId = types.filter(function filterStatuses(tagtype) {
						return tagtype.TagTypeName.match(/&&_AirBase_Assigned_Date/);
					})[0].TagTypeId;
				})
				.then(function() {
					return smbIndexTypesService.getDocumentIndexes(documentId);
				})
				.then(function(ft) {
					var value = null;
					value = ft.TypedTags.find(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Content_Status/);
					});
					_contentStatus.Value = value.Tags[0] ? value.Tags[0] : '';
					value = null;
					value = ft.TypedTags.find(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_ToDo_Status/);
					});
					_todoStatus.Value = value.Tags[0] ? value.Tags[0] : '';
					value = null;
					value = ft.TypedTags.find(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
					});
					_assignedUserId.Value = value.Tags[0] ? value.Tags[0] : '';
					value = null;
					value = ft.TypedTags.find(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Assigned_Date/);
					});
					_assignedDate.Value = value.Tags[0] ? value.Tags[0] : '';
				})
				.then(function() {
					if (_contentStatus.Value) {
						tagcollection.push(_contentStatus);
					}
					if (_todoStatus.Value) {
						tagcollection.push(_todoStatus);
					}
					if (_assignedUserId.Value) {
						tagcollection.push(_assignedUserId);
					}
					if (_assignedDate.Value) {
						tagcollection.push(_assignedDate);
					}
				})
				.then(function() {
					return smbIndexTypesService.setIndexTypes(tagcollection, documentId);
				})
				.then(function (response) {
					return response;
				});
			}
		}
	}());

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbPanelDetailsDataStore', ['$mdMedia',PanelDetailsDataStore]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbPanelDetailsDataStore
		 *
		 * @description
		 * Manages the state of the application's side panel.
		 */
		function PanelDetailsDataStore($mdMedia) {
			var _isOpen = false;
			var _isOpenInline = false;
	
			return {
				/**
				 * @ngdoc property
				 * @name smbPanelDetailsDataStore#isOpen
				 * @propertyOf smb-app.smbPanelDetailsDataStore
				 * @kind property
				 *
				 * @description
				 * Returns true if the side panel is currently open.
				 *
				 * @returns {boolean} A boolean flag that indicates whether the side panel is open (true)
				 * or closed (false).
				 */
				get isOpen() { return _isOpen; },
	
				/**
				 * @ngdoc property
				 * @name smbPanelDetailsDataStore#isOpen
				 * @propertyOf smb-app.smbPanelDetailsDataStore
				 * @kind property
				 *
				 * @description
				 * Use to open or close the side panel. Set to true to open the side panel
				 * and false to close the side panel.
				 *
				 * @param {boolean} val The value to set the property to.
				 */
				set isOpen(val) { _isOpen = val; },
	
				/**
				 * @ngdoc property
				 * @name smbPanelDetailsDataStore#isOpenInline
				 * @propertyOf smb-app.smbPanelDetailsDataStore
				 * @kind property
				 *
				 * @description
				 * Indicates if the side panel is open in inline mode.
				 *
				 * @returns {boolean} True if the panel is open inline
				 */
				get isOpenInline() { return _isOpenInline; },
	
				/**
				 * @ngdoc method
				 * @name smbPanelDetailsDataStore#toggle
				 * @methodOf smb-app.smbPanelDetailsDataStore
				 * @kind method
				 *
				 * @description
				 * Toggle the side panel. Opens it if it is currently closed and closes it if
				 * it is currently open.
				 */
				toggle: toggle,
	
				/**
				 * @ngdoc method
				 * @name smbPanelDetailsDataStore#reset
				 * @methodOf smb-app.smbPanelDetailsDataStore
				 * @kind method
				 *
				 * @description
				 * Resets the state of the side panel back to default (which is closed).
				 */
				reset: reset,
	
				/**
				 * @ngdoc method
				 * @name smbPanelDetailsDataStore#showPanel
				 * @methodOf smb-app.smbPanelDetailsDataStore
				 * @kind method
				 *
				 * @description
				 * Returns true if the panel should be open.
				 *
				 * @returns {boolean} True if the panel should be open.
				 */
				showPanel: showPanel
			};
	
			function toggle() {
				_isOpen = !_isOpen;
				if ($mdMedia('gt-sm')) {
					_isOpenInline = !_isOpenInline;
				}
			}
	
			function showPanel() {
				return _isOpen || _isOpenInline;
			}
	
			function reset() {
				_isOpen = false;
				_isOpenInline = false;
			}
		}
	}());

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbStatusDataStore', [
				'$q', 
				'smbStatusService', 
				StatusDataStore
				]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbStatusDataStore
		 * 
		 * @description
		 * Data store that manages state for the content type uration section.
		 */
		function StatusDataStore($q, smbStatusService) {
	
			var _contentStatus;
			var _todoStatus;
			var _assignedUserId;
			var _assignedDate;
	
			var _contentStatusValues = [];
			var _todoStatusValues = [];
	
			return {
				/**
				 * @ngdoc method
				 * @name smbStatusDataStore.getContentStatuses
				 * @methodOf smb-app.smbStatusDataStore
				 * @kind function
				 * 
				 * @description
				 * Loads the data store with a content type by id
				 * 
				 * @param {String} groupId Id of the content type group the type belongs to
				 * @param {String} id The content type id
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the content type being loaded
				 */
				get contentStatus() { return _contentStatus; },
	
				get todoStatus() { return _todoStatus; },
	
				get contentStatusValues() { return _contentStatusValues; },
	
				get todoStatusValues() { return _todoStatusValues; },
	
				get assignedUserId() { return _assignedUserId; },
	
				get assignedDate() { return _assignedDate; },
	
				loadStatuses: loadStatuses,
	
				getDocumentStatus: getDocumentStatus,
	
				getUsersWithModifyRights: getUsersWithModifyRights,
	
				setDocumentStatus: setDocumentStatus
			};
	
			function loadStatuses(folderId) {
				return smbStatusService.getStatuses(folderId)
				.then(function(response) {
					return response.filter(function statuses(tt) {
							return tt.TagTypeName.match(/&&_AirBase_.*/);
						});
				})
				.then(function mapStatuses(statuses) {
					_contentStatus = statuses.filter(function filterCStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_Content_Status/);
					});
					_todoStatus = statuses.filter(function filterTStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_ToDo_Status/);
					});
					_assignedUserId = statuses.filter(function filterCStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
					});
					_assignedDate = statuses.filter(function filterTStatuses(s) {
						return s.TagTypeName.match(/&&_AirBase_Assigned_Date/);
					});
					return statuses;
				});
			}
	
			function getDocumentStatus(documentId) {
				return smbStatusService.getDocumentStatus(documentId)
				.then(function(response) {
					return response;
				});
			}
	
			function getUsersWithModifyRights(documentId) {
				return smbStatusService.getUsers(documentId)
				.then(function(response) {
					return response.data;
				});
			}
	
			function setDocumentStatus(status, documentId) {
				return smbStatusService.setDocumentStatus(status, documentId);
			}
		}
	}());

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		
		angular.module('smb-app')
			.factory('smbToDoListDataStore', ['$q', '$interval', 'gettextCatalog', 'smbToDoListService', 'smbSortService', ToDoListDataStore]);
		
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesDataStore
		 * 
		 * @description
		 * Manages the state for the content types configuration.
		 */
		function ToDoListDataStore($q, $interval, gettextCatalog, smbToDoListService, smbSortService) {
	
			var _documents = null;
	
			var ASSIGNED_DATE = '&&_AirBase_Assigned_Date';
			var CONST_TODOLIST_POLL_INTERVAL = 20000;
			var _count = 0;	
			var _interval;	
	
			return {
				/**
				 * @ngdoc property
				 * @name smbContentTypesDataStore.contentTypes
				 * @propertyOf smb-app.smbContentTypesDataStore
				 * 
				 * @description
				 * All content types that belong to the current content type group.
				 */
				get documents() {
					return _documents;
				},
	
				/**
				 * @ngdoc method
				 * @name toDoListDataStore.getDocuments
				 * @methodOf smb-app.toDoListDataStore
				 * 
				 * @description
				 * Loads and returns all content types for a specific content type group by group id.
				 * 
				 * @param {Number} groupId The content type group id
				 * 
				 * @returns {Deferred} A promise that resolves to a collection of content types.
				 */
				getDocuments: getDocuments,
	
				sortByDate: sortByDate,
	
				sortByType: sortByType,
	
				sortByStatus: sortByStatus,
	
				loadCount: loadCount,
	
				init: init,
	
				/**
				 * @ngdoc method
				 * @name smbToDoListDataStore#clear
				 * @methodOf smb-app.toDoListDataStore
				 * @kind function
				 * 
				 * @description
				 * Clears the interval that was initiated by @see init
				 */
				clear: clear,
	
				get count() { return _count; }
				
			};	
	
			function getDocuments() {
				return smbToDoListService.getDocuments()
					.then(function (types) {
						_documents = types.map(function(doc) {
							var d;
							d = doc;
							var index = doc.DocumentAutoName ? doc.DocumentAutoName.indexOf('&&_AirBase_') : -1;
							if (index !== -1) {
								d.DocumentAutoName = doc.DocumentAutoName.substring(0, index > 0 ? index - 5 : 0);
							}						
							var contentStatus = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_Content_Status/));
							});
							var todoStatus = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_ToDo_Status/));
							});
							d.DateAssigned = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_Assigned_Date/));
							});
							if (contentStatus != null && contentStatus.length > 0 && contentStatus[0].Tags[0].length > 0) {
								d.Status = contentStatus[0].Tags[0];
							}
							else if (todoStatus != null && todoStatus.length > 0 && todoStatus[0].Tags[0].length > 0) {
								d.Status = todoStatus[0].Tags[0];
							}
							else {
								d.Status = '';
							}
	
							if (d.DateAssigned != null && d.DateAssigned.length > 0) {
								d.DateAssigned = d.DateAssigned[0].Tags[0];
							}					
							return d;
						});
						sortByDate(false);
						return _documents;
					});
			}
	
			function sortByDate(params) {
				_documents.sort(function(a, b) {
					var result = smbSortService.sortDate(new Date(b.DateAssigned.replace(/T(\d:){2}(\d){1}/, '')), new Date(a.DateAssigned.replace(/T(\d:){2}(\d){1}/, '')));
					if (result === 0 && a.DocumentAutoName !== null && b.DocumentAutoName !== null) {
						result = a.DocumentAutoName.toLowerCase().localeCompare(b.DocumentAutoName.toLowerCase());
					}
					return result;
				});
				if (!params) {
					_documents.reverse();
				}
			}
	
			function sortByType(params) {
				_documents.sort(function(a,b) {
					return smbSortService.sortByString(a.LibraryName + a.FolderName, b.LibraryName + b.FolderName, params);
				});			
			}
	
			function sortByStatus(params) {
				_documents.sort(smbSortService.sortObjectByStringProperty('Status', params));
			}
	
			function init() {
				if (!_interval) {
					_interval = $interval(function() {
						loadCount();
					}, CONST_TODOLIST_POLL_INTERVAL);
				}
			}
	
			function clear() {
				if (angular.isDefined(_interval)) {
					$interval.cancel(_interval);
					_interval = undefined;
				}
			}
	
			function loadCount() {
				return smbToDoListService.getCount()
					.then(function (count) {
						_count = count;
						return count;
					});
			}
		}
	}());

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		/**
		* @ngdoc service
		* @name  smb-app.smbUserDataStore
		* 
		* @description 
		* A datastore used to retrieve and interact with a smb-app user
		**/
	
		angular
			.module('smb-app')
			.factory('smbUserDataStore',
			[
				'$q',
				'pxAuthService',
				'sbUserService',
				UserDataStore
			]);
	
		function UserDataStore($q, pxAuthService, sbUserService) {
			var _user = null;
			var _newUser = {
				'UserName': null,
				'EmailAddress': null,
				'Password': null,
				'Embedded': {
					'Roles': []
				}
			};
	
			return {
				/**
				* @ngdoc method
				* @name smbUserDataStore#getUser
				* @methodOf smb-app.smbUserDataStore
				* @kind function
				*
				* @description
				* Gets a user
				*
				* @returns {Deferred} A promise that will resolve with a user
				* 
				*/
				getUser: getUser,
	
				/**
				* @ngdoc method
				* @name smbUserDataStore#addUser
				* @methodOf smb-app.smbUserDataStore
				* @kind function
				*
				* @description
				* Adds a new user
				*
				* @returns {Deferred} A promise that will resolve with a new user
				* 
				*/
				addUser: addUser,
	
				/**
				* @ngdoc method
				* @name smbUserDataStore#updateUser
				* @methodOf smb-app.smbUserDataStore
				* @kind function
				*
				* @description
				* Gets an updated user
				*
				* @returns {Deferred} A promise that will resolve with an updated user
				* 
				*/
				updateUser: updateUser,
	
				/**
				* @ngdoc method
				* @name smbUserDataStore#lockUser
				* @methodOf smb-app.smbUserDataStore
				* @kind function
				*
				* @description
				* Locks a user
				*
				* @returns {Deferred} A promise that will resolve
				* 
				*/
				lockUser: lockUser,
	
				/**
				* @ngdoc method
				* @name smbUserDataStore#unlockUser
				* @methodOf smb-app.smbUserDataStore
				* @kind function
				*
				* @description
				* Unlocks a user
				*
				* @returns {Deferred} A promise that will resolve
				* 
				*/
				unlockUser: unlockUser,
	
				/**
				* @ngdoc property
				* @name smbUserDataStore#user
				* @propertyOf smb-app.smbUserDataStore
				* @kind property
				*
				* @description
				* A user
				* 
				* @returns {object} A user
				*/
				get user() { return _user; },
				
				/**
				* @ngdoc property
				* @name smbUserDataStore#isSiteAdmin
				* @propertyOf smb-app.smbUserDataStore
				* @kind property
				*
				* @description
				* Set user site admin role
				*/
				set isSiteAdmin(val) { setSiteAdmin(val); setUserAdmin(val);},
				
				/**
				* @ngdoc property
				* @name smbUserDataStore#isSiteAdmin
				* @propertyOf smb-app.smbUserDataStore
				* @kind property
				*
				* @description
				* Get user site admin role
				*/
				get isSiteAdmin() { return _user ? _user.Embedded.Roles.indexOf('SiteAdmin') > -1 : false;},
				/**
				* @ngdoc property
				* @name smbUserDataStore#isUsereAdmin
				* @propertyOf smb-app.smbUserDataStore
				* @kind property
				*
				* @description
				* Set user user admin role
				*/
				set isUserAdmin(val) { setUserAdmin(val);},
				
				/**
				* @ngdoc property
				* @name smbUserDataStore#isUsereAdmin
				* @propertyOf smb-app.smbUserDataStore
				* @kind property
				*
				* @description
				* Get user user admin role
				*/
				get isUserAdmin() { return _user ? _user.Embedded.Roles.indexOf('UserAdmin') > -1 : false;}
			};
	
			function getUser(userId) {
				if (!userId) {
					_user = angular.copy(_newUser);
					return $q.resolve(_user);
				}
				return sbUserService.getUser(userId, pxAuthService.deploymentId).then(function (response) {
					//clean duplicate roles
					response.Embedded.Roles = response.Embedded.Roles.filter(function (v, i, a) { return a.indexOf(v) === i; });
					_user = response;
	
					return response;
				});
			}
	
			function addUser(user) {
				return sbUserService.addUser(user, pxAuthService.systemName).then(function (response) {
					return response;
				});
			}
	
			function updateUser(user) {
				return sbUserService.updateUser(user, pxAuthService.deploymentId).then(function (response) {
					return response;
				});
			}
	
			function lockUser(userId) {
				return sbUserService.lockUser(userId, pxAuthService.deploymentId).then(function (response) {
					return response;
				});
			}
	
			function unlockUser(userId) {
				return sbUserService.unlockUser(userId, pxAuthService.deploymentId).then(function (response) {
					return response;
				});
			}
	
			function setSiteAdmin(val) {
				var index = _user.Embedded.Roles.indexOf('SiteAdmin');
				if (!val && index > -1) {
					//remove role
					_user.Embedded.Roles.splice(index, 1);
					return;
				}
	
				if (val && index === -1) {
					//add role
					_user.Embedded.Roles.push('SiteAdmin');
					return;
				}
			}
	
			function setUserAdmin(val) {
				var index = _user.Embedded.Roles.indexOf('UserAdmin');
				if (!val && index > -1) {
					//remove role
					_user.Embedded.Roles.splice(index, 1);
					return;
				}
	
				if (val && index === -1) {
					//add role
					_user.Embedded.Roles.push('UserAdmin');
					return;
				}
			}
		}
	
	})();

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		/**
		* @ngdoc service
		* @name  smb-app.smbUserGroupDataStore
		* 
		* @description 
		* A datastore used to retrieve and interact with a smb-app user group
		**/
	
		angular
			.module('smb-app')
			.factory('smbUserGroupDataStore',
			[
				'$q',
				'pxAuthService',
				'sbUserGroupService',
				'smbSortService',
				UserGroupDataStore
			]);
	
		function UserGroupDataStore($q, pxAuthService, sbUserGroupService, smbSortService) {
			var _userGroup = null;
	
			var _newUserGroup = {
				UserGroupName: '',
				Embedded: {
					Users: []
				}
			};
	
			return {
				/**
				* @ngdoc method
				* @name smbUserGroupDataStore#getUserGroup
				* @methodOf smb-app.smbUserGroupDataStore
				* @kind function
				*
				* @description
				* Gets a user group
				*
				* @returns {Deferred} A promise that will resolve with a user group
				* 
				*/
				getUserGroup: getUserGroup,
	
				/**
				* @ngdoc method
				* @name smbUserGroupDataStore#saveUserGroup
				* @methodOf smb-app.smbUserGroupDataStore
				* @kind function
				*
				* @description
				* Saves a UserGroup
				*
				* @returns {Deferred} A promise that will resolve with a saved user group
				* 
				*/
				saveUserGroup: saveUserGroup,
	
				/**
				* @ngdoc method
				* @name smbUserGroupDataStore#containsUser
				* @methodOf smb-app.smbUserGroupDataStore
				* @kind function
				*
				* @description
				* Determines whether a user exists in the user group's collection of users
				*
				* @returns {boolean} A boolean represnetation of a user's existance in the user group's collection of users
				* 
				*/
				containsUser: containsUser,
	
				/**
				* @ngdoc property
				* @name smbUserGroupDataStore#userGroup
				* @propertyOf smb-app.smbUserGroupDataStore
				* @kind property
				*
				* @description
				* A user group
				* 
				* @returns {object} A user group
				*/
				get userGroup() { return _userGroup; }
			};
	
			function getUserGroup(userGroupId) {
				if (!userGroupId) {
					_userGroup = angular.copy(_newUserGroup);
	
					return $q.resolve(_userGroup);
				}
				return sbUserGroupService
					.getUserGroup(userGroupId, pxAuthService.systemName)
					.then(function (response) {
						response.Embedded.Users.sort(smbSortService.sortObjectByStringProperty('UserName'));
						_userGroup = response;				
	
						return response;
					});
			}
	
			function saveUserGroup() {
				if (_userGroup.UserGroupId) {
					return sbUserGroupService
						.updateUserGroup(_userGroup, pxAuthService.systemName)
						.then(function (response) {
							_userGroup = response;
	
							return response;
						});
				} else {
					return sbUserGroupService
						.addUserGroup(_userGroup, pxAuthService.systemName)
						.then(function (response) {
							_userGroup = response;
	
							return response;
						});
				}
			}
	
			function containsUser(user) {
				for (var i = 0; i < _userGroup.Embedded.Users.length; i++) {
					if (_userGroup.Embedded.Users[i].UserId === user.UserId) {
						return true;
					}
				}
	
				return false;
			}
		}
	
	})();

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		/**
		* @ngdoc service
		* @name  smb-app.smbUserGroupsDataStore
		* 
		* @description 
		* A datastore used to retrieve smb-app user groups
		**/
	
		angular
			.module('smb-app')
			.factory('smbUserGroupsDataStore',
			[
				'pxAuthService',
				'sbUserGroupsService',
				UserGroupsDataStore
			]);
	
		function UserGroupsDataStore(pxAuthService, sbUserGroupsService) {
			var _userGroups = [];
	
			return {
				/**
				* @ngdoc method
				* @name smbUserGroupsDataStore#getUserGroups
				* @methodOf smb-app.smbUserGroupsDataStore
				* @kind function
				*
				* @description
				* Gets a collection of user groups
				*
				* @returns {Deferred} A promise that will resolve with a collection of user groups
				* 
				*/
				getUserGroups: getUserGroups,
	
				/**
				* @ngdoc property
				* @name smbUserGroupsDataStore#userGroups
				* @propertyOf smb-app.smbUserGroupsDataStore
				* @kind property
				*
				* @description
				* A collection of user groups
				* 
				* @returns {array} An array of user groups
				*/
				get userGroups() { return _userGroups; }
			};
	
			function getUserGroups() {
				return sbUserGroupsService
					.getUserGroups(pxAuthService.systemName)
					.then(function (response) {
						_userGroups = response;
						return response;
					});
			}
		}
	
	})();

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		/**
		* @ngdoc service
		* @name  smb-app.smbUsersDataStore
		* 
		* @description 
		* A datastore used to retrieve smb-app users
		**/
	
		angular
			.module('smb-app')
			.factory('smbUsersDataStore',
			[
				'pxAuthService',
				'sbUsersService',
				UsersDataStore
			]);
	
		function UsersDataStore(pxAuthService, sbUsersService) {
			var _users = [];
	
			return {
				/**
				* @ngdoc method
				* @name smbUsersDataStore#getUsers
				* @methodOf smb-app.smbUsersDataStore
				* @kind function
				*
				* @description
				* Gets a collection of users
				*
				* @returns {Deferred} A promise that will resolve with a collection of users
				* 
				*/
				getUsers: getUsers,
	
				/**
				* @ngdoc property
				* @name smbUsersDataStore#users
				* @propertyOf smb-app.smbUsersDataStore
				* @kind property
				*
				* @description
				* A collection of users
				* 
				* @returns {array} An array of users
				*/
				get users() { return _users; }
			};
	
			function getUsers() {
				return sbUsersService
					.getUsers(pxAuthService.systemName)
					.then(function (response) {
						_users = response;	
						return response;
					});
			}
		}
	
	})();

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/* jshint maxcomplexity: false */
	/* jshint maxstatements: false */
	/* jshint bitwise: false */
	(function() {
		'use strict';
	
		angular.module('smb-app')
			.constant('SMB_SITE_ADMIN_GROUP', '&&_AIRBASE_SITE_ADMIN')
			.constant('SMB_RIGHTS_TYPE', {
				admin: 1,
				fullRights: 2,
				viewRights: 3,
				editRights: 4
			})
			.factory('SMB_RIGHTS', ['gettextCatalog', 'PX_PERMISSION_TYPE', 'SMB_SITE_ADMIN_GROUP', function(gettextCatalog, PX_PERMISSION_TYPE, SMB_SITE_ADMIN_GROUP) {
				return [
					{id: '', param: 0, name: ''},
					{id: 1, param: PX_PERMISSION_TYPE.FULLCONTROL, name: SMB_SITE_ADMIN_GROUP},
					{
						id: 2,
						param: PX_PERMISSION_TYPE.READ | PX_PERMISSION_TYPE.ADDDOC | PX_PERMISSION_TYPE.READDOC | PX_PERMISSION_TYPE.MODDOC | PX_PERMISSION_TYPE.DELDOC | PX_PERMISSION_TYPE.READFOLD | PX_PERMISSION_TYPE.MODFOLD | PX_PERMISSION_TYPE.DNLDDOC,
						name: gettextCatalog.getString('Full Rights')
					},
					{
						id: 3,
						param: PX_PERMISSION_TYPE.READ | PX_PERMISSION_TYPE.READDOC | PX_PERMISSION_TYPE.READFOLD,
						name: gettextCatalog.getString('View Rights')
					},
					{
						id: 4,
						param: PX_PERMISSION_TYPE.READ | PX_PERMISSION_TYPE.ADDDOC | PX_PERMISSION_TYPE.READDOC | PX_PERMISSION_TYPE.MODDOC | PX_PERMISSION_TYPE.READFOLD | PX_PERMISSION_TYPE.MODFOLD | PX_PERMISSION_TYPE.DNLDDOC,
						name: gettextCatalog.getString('Edit Rights')
					}
				];
			}])
			/**
			 * @ngdoc service
			 * @name smb-app.smbAclService
			 *
			 * @description
			 * A service for easily creating document groups based on the
			 * three different predefined access levels for document groups.
			 */
			.factory('smbAclService', [
				'$http',
				'$q',
				'pxUriPathService',
				'PX_PERMISSION_TYPE',
				'PX_ACL_CONST',
				'PX_OBJECT_TYPE',
				'SMB_RIGHTS_TYPE',
				'SMB_RIGHTS',
				'SMB_SITE_ADMIN_GROUP',
				AclService
			]);
	
		function AclService(
			$http,
			$q,
			pxUriPathService,
			PX_PERMISSION_TYPE,
			PX_ACL_CONST,
			PX_OBJECT_TYPE,
			SMB_RIGHTS_TYPE,
			SMB_RIGHTS,
			SMB_SITE_ADMIN_GROUP
		) {
	
			/**
			 * @description
			 * An object that represents a single user group's access level to
			 * a single document group.
			 *
			 * @param {any} right The access rights for the document group and user group
			 * @param {any} objectType The object type; can be document, document group, or document type. Almost always library.
			 * @param {any} objectId The id of the object; typically the document group id.
			 * @param {any} userGroup The user group the access rights are for.
			 */
			function Acl(right, objectType, objectId, userGroup) {
				this._right = right;
				this._objectType = objectType;
				this._objectId = objectId;
				this._userGroup = userGroup;
			}
	
			/**
			 * @description
			 * Returns true if the acl represents admin rights to the given object.
			 *
			 * @returns {Boolean} True if the acl represents admin rights and false otherwise.
			 */
			Acl.prototype.hasAdminAccess = function hasAdminAccess() {
				return this._right.id === SMB_RIGHTS_TYPE.admin;
			};
	
			/**
			 * @description
			 * Returns true if the acl represents full access rights to the given object.
			 *
			 * @returns {Boolean} True if the acl represents full access rights and false otherwise.
			 */
			Acl.prototype.hasFullAccess = function hasFullAccess() {
				return this.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.fullRights].param);
			};
	
			/**
			 * @description
			 * Returns true if the acl represents view access rights to the given object
			 *
			 * @returns {Boolean} True if the acl represents view access rights and false otherwise.
			 */
			Acl.prototype.hasViewAccess = function hasViewAccess() {
				return this.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.viewRights].param);
			};
	
			/**
			 * @description
			 * Returns true if the acl represents edit access rights to the given object.
			 */
			Acl.prototype.hasEditAccess = function hasEditAccess() {
				return this.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights].param);
			};
	
			/**
			 * Check if the ACL has all of the specified permissions.
			 *
			 * @param {number} perm The permissions to check against the acl.
			 * @returns {boolean} True if the instance has access to all given permissions and false otherwise.
			 */
			Acl.prototype.hasAllPermissions = function hasAllPermissions(perm) {
				return (this._right.param & perm) === perm;
			};
	
			/**
			 * @description
			 * Creates an object that represents the acl type expected by the Phoenix API.
			 *
			 * @returns {Object} An ACL object that is compatible with the Phoenix API.
			 */
			Acl.prototype.toServerAcl = function() {
				var serverAcl = {
					RoleName: null,
					UserGroupId: this._userGroup.UserGroupId,
					UserGroupName: this._userGroup.UserGroupName,
					Embedded: { Permissions: [] }
				};
	
				switch (this._objectType) {
					case PX_OBJECT_TYPE.DOCUMENT:
						serverAcl.DocumentId = this._objectId;
						break;
					case PX_OBJECT_TYPE.FOLDER:
						serverAcl.FolderId = this._objectId;
						break;
					case PX_OBJECT_TYPE.LIBRARY:
						serverAcl.LibraryId = this._objectId;
						break;
				}
	
				var permissionVal = PX_PERMISSION_TYPE.FULLCONTROL;
				while (permissionVal < PX_ACL_CONST.MaxPermission) {
					var newPerm = {
						PermissionValue: permissionVal,
						Allow: false,
						Deny: false
					};
	
					if (this._right.id === SMB_RIGHTS_TYPE.admin) {
						newPerm.Allow = permissionVal === PX_PERMISSION_TYPE.FULLCONTROL;
					} else if (this._right.id === SMB_RIGHTS_TYPE.fullRights) {
						newPerm.Allow = permissionVal === PX_PERMISSION_TYPE.READ ||
							permissionVal === PX_PERMISSION_TYPE.ADDDOC ||
							permissionVal === PX_PERMISSION_TYPE.MODDOC ||
							permissionVal === PX_PERMISSION_TYPE.READDOC ||
							permissionVal === PX_PERMISSION_TYPE.DELDOC ||
							permissionVal === PX_PERMISSION_TYPE.READFOLD ||
							permissionVal === PX_PERMISSION_TYPE.DNLDDOC ||
							permissionVal === PX_PERMISSION_TYPE.MODFOLD;
					} else if (this._right.id === SMB_RIGHTS_TYPE.viewRights) {
						newPerm.Allow = permissionVal === PX_PERMISSION_TYPE.READ ||
							permissionVal === PX_PERMISSION_TYPE.READDOC ||
							permissionVal === PX_PERMISSION_TYPE.READFOLD;
					} else if (this._right.id === SMB_RIGHTS_TYPE.editRights) {
						var x = this._right.param & permissionVal;
						newPerm.Allow = x === permissionVal;
					}
	
					serverAcl.Embedded.Permissions.push(newPerm);
	
					if (permissionVal < 0) {
						permissionVal = 1;
					} else {
						/* jshint -W016 */
						permissionVal <<= 1;
						/* jshint +W016 */
					}
				}
	
				return serverAcl;
			};
	
			Object.defineProperties(Acl.prototype, {
				'objectId': {
					configurable: false,
					enumerable: true,
					get: function() { return this._objectId; }
				}
			});
	
			/**
			 * @description
			 * A factory method that creates an Acl instance from a Phoenix API representation
			 * of an ACL.
			 *
			 * @param {Object} serverAcl A Phoenix API ACL object.
			 *
			 * @returns {Acl} An Acl instance that represents the API acl.
			 */
			Acl.fromServerAcl = function fromServerAcl(serverAcl) {
				var rights = SMB_RIGHTS.find(function(r) {
					return r.param === serverAcl.Privileges;
				});
	
				if (!rights) {
					return;
				}
	
				return new Acl(rights, serverAcl.LibraryId, {
					UserGroupId: serverAcl.UserGroupId,
					UserGroupName: serverAcl.UserGroupName
				});
			};
	
			return {
				/**
				 * @ngdoc method
				 * @name smbAclService#createAdminRights
				 * @methodOf smb-app.smbAclService
				 * @kind function
				 *
				 * @description
				 * Creates and admin level acl for a document group
				 *
				 * @param {ObjectId} documentGroupId The document group to create the acl for
				 * @param {ObjectId} userGroupId Id of the admin user group.
				 *
				 * @returns {Acl} An instance of @see Acl
				 */
				createAdminRights: createAdminRights,
	
				/**
				 * @ngdoc method
				 * @name smbAclService#createFullAccessRights
				 * @methodOf smb-app.smbAclService
				 * @kind function
				 *
				 * @description
				 * Creates a full access level acl for a specific document group
				 *
				 * @param {ObjectId} documentGroupId The document group to create the acl for
				 * @param {Object} userGroup The user group to create the ACL for
				 */
				createFullAccessRights: createFullAccessRights,
	
				/**
				 * @ngdoc method
				 * @name smbAclService#createViewAccessRights
				 * @methodOf smb-app.smbAclService
				 * @kind function
				 *
				 * @description
				 * Creates a view access acl for a specific document group
				 *
				 * @param {ObjectId} documentGroupId The document group id to create the acl for
				 * @param {Object} userGroup The user group to create the acl for
				 */
				createViewAccessRights: createViewAccessRights,
	
				createEditAccessRights: createEditAccessRights,
	
				/**
				 * @ngdoc method
				 * @name smbAclService#saveDocumentGroupAcls
				 * @methodOf smb-app.smbAclService
				 * @kind function
				 *
				 * @description
				 * Save a list of Acl objects for a specific document group.
				 *
				 * @param {ObjectId} documentGroupId The id of the document group to save the acls to
				 * @param {Acl[]} acls An array of Acl objects.
				 *
				 * @returns {Promise<Acl[]>} An object that resolves to an array of the Acl objects
				 * that were just saved.
				 */
				saveDocumentGroupAcls: saveDocumentGroupAcls,
	
				/**
				 * @ngdoc method
				 * @name smbAclService#getUserPermissionsForDocumentGroup
				 * @methodOf smb-app.smbAclService
				 * @kind function
				 *
				 * @description
				 * Gets the current user's permission for a document group.
				 *
				 * @param {ObjectId} documentGroupId The id of the document group whose user permissions are being retrieved.
				 *
				 * @returns {Promise<Acl>} A promise that resolves to an Acl object.
				 */
				getUserPermissionsForDocumentGroup: getUserPermissionsForDocumentGroup,
	
				/**
				 * @ngdoc method
				 * @name smbAclService#getUserPermissionsForDocumentType
				 * @methodOf smb-app.smbAclService
				 * @kind function
				 *
				 * @description
				 * Gets the current user's permission for a document type.
				 *
				 * @param {ObjectId} documentTypeId The id of the document type whose user permissions are being retrieved.
				 *
				 * @returns {Promise<Acl>} A promise that resolves to an Acl object.
				 */
				getUserPermissionsForDocumentType: getUserPermissionsForDocumentType
			};
	
			function createAdminRights(documentGroupId, userGroupId) {
				return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.admin], PX_OBJECT_TYPE.LIBRARY, documentGroupId, {
					UserGroupId: userGroupId,
					UserGroupName: SMB_SITE_ADMIN_GROUP
				});
			}
	
			function createFullAccessRights(documentGroupId, userGroup) {
				return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.fullRights], PX_OBJECT_TYPE.LIBRARY, documentGroupId, userGroup);
			}
	
			function createViewAccessRights(documentGroupId, userGroup) {
				return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.viewRights], PX_OBJECT_TYPE.LIBRARY, documentGroupId, userGroup);
			}
	
			function createEditAccessRights(documentGroupId, userGroup) {
				return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights], PX_OBJECT_TYPE.LIBRARY, documentGroupId, userGroup);
			}
	
			function saveDocumentGroupAcls(documentGroupId, acls) {
				var url = pxUriPathService.resolvePath('/libraries/' + documentGroupId + '/permissions/replace');
				acls = acls.map(function(acl) { return acl.toServerAcl(); });
				return $http.post(url, acls)
					.then(function() { return acls; });
			}
	
			function getUserPermissionsForDocumentGroup(documentGroupId) {
				var url = '/libraries/' + documentGroupId + '/permissionsforuser';
				return $http.get(pxUriPathService.resolvePath(url))
					.then(function(res) { return res.data; })
					.then(getAclWithMostAccess)
					.then(Acl.fromServerAcl);
			}
	
			function getUserPermissionsForDocumentType(documentTypeId) {
				var url = '/f/' + documentTypeId + '/permissionsforuser';
				return $http.get(pxUriPathService.resolvePath(url))
					.then(function(res) { return res.data; })
					.then(getAclWithMostAccess)
					.then(Acl.fromServerAcl);
			}
	
			function getAclWithMostAccess(acls) {
				return acls.reduce(function(prev, curr) {
					var cmp = cmpAcl(prev, curr);
					return cmp <= 0 ? prev : curr;
				});
			}
	
			function cmpAcl(acl1, acl2) {
				return acl2.Privileges - acl1.Privileges;
			}
	
			function filterOwnerAcl(acl) {
				return acl.RoleName !== 'Owner';
			}
		}
	}());

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeConfigService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentTypeConfigService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeConfigService
		 * 
		 * @description
		 * Exposes methods for retrieving, updating, and creating content types.
		 */
		function ContentTypeConfigService($http, $q, gettextCatalog, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeConfigService.getContentType
				 * @methodOf smb-app.smbContentTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Retrieves a single content type by id.
				 * 
				 * @param {String} groupId Id of the content type group the type belongs to
				 * @param {String} id The id of the content type to retrieve.
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the content type.
				 */
				getContentType: getContentType,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeConfigService.addContentType
				 * @methodOf smb-app.smbContentTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Creates a new content type that belongs to a specific content type group
				 * 
				 * @param {String} groupId Id of the content type group the new content type belongs to
				 * @param {Object} contentType An object that represents the new content type
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the newly created content type.
				 */
				addContentType: addContentType,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeConfigService.updateContentType
				 * @methodOf smb-app.smbContentTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Updates an existing content type
				 * 
				 * @returns {Deferred} Returns a promise that resolves to the updated content type.
				 */
				updateContentType: updateContentType
			};
	
			function getContentType(groupId, id) {
				if (!id) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type id')));
				}
				var uri = pxUriPathService.resolvePath('/f/' + id);
				return $http.get(uri)
					.then(function (response) {
						return response.data;
					});
			}
	
			function addContentType(groupId, contentType) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				} else if (!contentType) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type')));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/folders');
				return $http.post(uri, contentType)
					.then(function (response) {
						return response.data;
					});
			}
	
			function updateContentType(groupId, contentType) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				} else if (!contentType) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type')));
				}
				return $http.patch(pxUriPathService.resolvePath('/f/' + contentType.FolderId), contentType)
					.then(function(res) {
						return res.data;
					});
			}
		}
	
	}());

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupConfigService',
			[
				'$http',
				'pxUriPathService',
				ContentTypeGroupConfigService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupConfigService
		 * 
		 * @description
		 * A service that exposes methods for creating and updating content type groups.
		 */
		function ContentTypeGroupConfigService($http, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupConfigService#createContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupConfigService
				 * @kind function
				 * 
				 * @description
				 * Creates a new content type group in the system.
				 * 
				 * @param {Object} group An object representing the content type group to create
				 *
				 * @returns {Promise} A promise that resolves to the newly created content type group
				 */
				createContentTypeGroup: createContentTypeGroup,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupConfigService#createContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupConfigService
				 * @kind function
				 * 
				 * @description
				 * Saves changes made to an existing content type group
				 * 
				 * @param {Object} group An object that represents an existing content type group
				 * 
				 * @returns {Promise} A promise that resolves to the content type group that was changed
				 */
				editContentTypeGroup: editContentTypeGroup
			};
	
			function createContentTypeGroup(group) {
				return $http.post(pxUriPathService.resolvePath('/libraries'), group)
					.then(function (res) { return res.data; });
			}
	
			function editContentTypeGroup(group) {
				return $http.patch(pxUriPathService.resolvePath('/libraries/' + group.LibraryId), group)
					.then(function(res) {
						return res.data;
					});
			}	
		}
	}());

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupTagTypeConfigService', [
				'$http',
				'$q',
				'pxUriPathService',
				ContentTypeGroupTagTypeConfigService
			]);
	
		/**
		 * @typedef {Object} TagTypeConstraints
		 * @property {String} DefaultValue A default value for a tag type
		 * @property {String[]} DataSetValues An array of values for the tag type. If this exists
		 * the tag type value must be one of the values in this array.
		 */
	
		/**
		 * @typedef {Object} TagTypeLinks
		 * @property {String} TagValuesUri Uri to get all tag values associated to a tag type.
		 * @property {String} DataSetValuesUri Uri to get the data set values for a tag type.
		 */
		
		/**
		 * @typedef {Object} TagType
		 * @property {Number} TagTypeId The unique id of the tag type.
		 * @property {String} TagTypeName The name of the tag type.
		 * @property {String} FlavorName The flavor name?  TODO: Not sure what this is
		 * @property {Number} DataType Numeric representation of the data type.
		 * @property {String} DataTypeName String representation of the data type.
		 * @property {TagTypeConstraints} Constraints The contraints for the tag type.
		 * @property {TagTypeLinks} Links The related links for a tag type.
		 */
	
		/**
		 * @typedef {Object} CreateTagType
		 * @description
		 * Defines the minimum required properties on an object used to create a new tag type.
		 * @property {String} TagTypeName The name for the new tag type.
		 * @property {Number} DataType Numeric representation of the tag types data type.
		 * @property {TagTypeConstraints} Contraints Can optionally specify the constraints when creating the tag type.
		 */
	
		/**
		* @ngdoc service
		* @name smb-app.smbContentTypeGroupTagTypeConfigService
		*
		* @description
		* Exposes methods for configuring tag types for content type groups
		*/
		function ContentTypeGroupTagTypeConfigService($http, $q, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupTagTypeConfigService#getTagTypes
				 * @methodOf smb-app.smbContentTypeGroupTagTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Gets the collection of all tag types associated with a content type group.
				 * 
				 * @param {String} groupId Id of the content type group
				 * 
				 * @returns {Deferred<TagType[]>} A promise that resolves to a collection of
				 * all TagType objects associated with the content type group.
				 */
				getTagTypes: getTagTypes,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupTagTypeConfigService#createTagType
				 * @methodOf smb-app.smbContentTypeGroupTagTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Creates a new tag type and associates it with a content type group.
				 * 
				 * @param {String} groupId Id of the content type group to associate the
				 * new tag type with.
				 * @param {CreateTagType} tagType The tag type object to create
				 * 
				 * @returns {Deferred<TagType>} Returns a promise that resolves to the newly
				 * created tag type.
				 */
				createTagType: createTagType,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupTagTypeConfigService#editTagType
				 * @methodOf smb-app.smbContentTypeGroupTagTYpeConfigService
				 * @kind method
				 * 
				 * @description
				 * Saves changes to an existing tag type.
				 * 
				 * @param {ObjectId} groupId Id the the document type group that owns the tag type.
				 * @param {TagType} tagType The tag type object to update
				 * 
				 * @returns {Promise<TagType>} A promise that resolves to the tag type that was updated.
				 */
				editTagType: editTagType
			};
	
			function getTagTypes(groupId) {
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
				return $http.get(uri)
					.then(function(res) {
						return res.data;
					});
			}
	
			function createTagType(groupId, tagType) {
				if (!tagType) {
					return $q.reject(new Error('Invalid request: Must specify the tag type to create'));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
				return $http.post(uri, tagType)
					.then(function(res) {
						return res.data;
					});
			}
	
			function editTagType(groupId, tagType) {
				var url = '/libraries/' + groupId + '/tagtypes/' + tagType.TagTypeId;
				return $http.patch(pxUriPathService.resolvePath(url), tagType)
					.then(function(res) { return res.data; });
			}
	
		}
	}());

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeTagTypeConfigService', [
				'$http',
				'$q',
				'pxUriPathService',
				ContentTypeTagTypeConfigService
			]);
	
		/**
		 * @typedef {Object} TagTypeAssoication
		 * @param {Number} TagTypeId The id of the tag type being associated with an item
		 */
	
		/**
		* @ngdoc service
		* @name smb-app.smbContentTypeTagTypeConfigService
		*
		* @description
		* Exposes methods for adding and removing index types from a library
		*/
		function ContentTypeTagTypeConfigService($http, $q, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeTagTypeConfigService#getTagTypes
				 * @methodOf smb-app.smbContentTypeTagTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Gets all tag types that are associated with a content type.
				 * 
				 * @param {String|Number} id The content type id
				 * 
				 * @returns {Promise<TagType[]>} A promise that resolves to a collection of @see TagType objects.
				 */
				getTagTypes: getTagTypes,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeTagTypeConfigService#setTagTypes
				 * @methodOf smb-app.smbContentTypeTagTypeConfigService
				 * @kind function
				 * 
				 * @description
				 * Sets the tag type associations for a single content type. This function will
				 * completely replace the current set of associations on the content type with
				 * this new set.
				 * 
				 * @param {String|Number} id The content type id
				 * @param {TagTypeAssoication[]} associations The collection of tag type associations to
				 * put on the content type. 
				 */
				setTagTypes: setTagTypes
			};
	
			function getTagTypes(id) {
				if (!(typeof id === 'string' || typeof id === 'number')) {
					return $q.reject(new Error('Missing required document type id'));
				}
	
				var uri = pxUriPathService.resolvePath('/f/' + id + '/tagtypes');
				return $http.get(uri)
					.then(function(res) {
						return res.data;
					});
			}
	
			function setTagTypes(id, associations) {
				if (!(typeof id === 'string' || typeof id === 'number')) {
					return $q.reject(new Error('Missing required document type id'));
				} else if (!associations) {
					return $q.reject(new Error('Must specify the associations to add to the document type.'));
				}
	
				var uri = pxUriPathService.resolvePath('/f/' + id + '/tagtypes');
				return $http.put(uri, associations)
					.then(function() {
						return associations;
					});
			}
		}
	}());

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbStatusConfigService', [
				'$http',
				'$q',
				'pxUriPathService',
				StatusConfigService
			]);
	
		function StatusConfigService($http, $q, pxUriPathService) {
	
			return {
				getStatuses: getStatuses,
	
				setStatuses: setStatuses
			};
	
			function getStatuses(groupId) {
				if (!(typeof groupId === 'string' || typeof groupId === 'number')) {
					return $q.reject(new Error('Missing required document type group id'));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
				return $http.get(uri)
					.then(function(res) {
						return res.data.filter(function statuses(tt) {
							return tt.TagTypeName.match(/&&_AirBase_.*/);
						});
					});
			}
	
			function setStatuses(folderId, tagTypeId, constraints) {
				if (!(typeof folderId === 'string' || typeof folderId === 'number')) {
					return $q.reject(new Error('Missing required document type id'));
				} else if (!constraints) {
					return $q.reject(new Error('Must specify the constraints to add to the document type.'));
				}
	
				var uri = pxUriPathService.resolvePath('/f/' + folderId + '/tagtypes/' + tagTypeId + '/constraints');
				return $http.put(uri, constraints)
					.then(function() {
						return constraints;
					});
			}
		}
	}());

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentSearchService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentSearchService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesService
		 * 
		 * @description
		 * Exposes methods for retrieving content types that belong to a content
		 * type group.
		 */
		function ContentSearchService($http, $q, gettextCatalog, pxUriPathService) {
			
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypesService.getContentTypes
				 * @methodOf smb-app.smbContentTypesService
				 * @kind function
				 * 
				 * @description
				 * Gets all content types the belong to a content type group
				 * 
				 * @param {Number} groupId Id of the content type group
				 * 
				 * @returns {Deferred} A promise that will resolve to a collection of content types
				 */
				getDocuments: getDocuments,
	
				getContentTypeGroupSearchResults: getContentTypeGroupSearchResults
			};
	
			function getDocuments(groupId, typeId, tagValues) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				}
	
				var uri = pxUriPathService.resolvePath('/documenttypes/' + typeId + '/search');
				return $http.post(uri, tagValues)
					.then(function (response) {
						return response.data.Embedded.Documents;
					});
			}
	
			function getContentTypeGroupSearchResults(groupId, tagValues) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				}
	
				var uri = pxUriPathService.resolvePath('/documenttypegroups/' + groupId + '/search');
				return $http.post(uri, tagValues)
					.then(function (response) {
						return response.data.Embedded.Documents;
					});
			}
		}
	}());

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeAcls', [
				'SMB_RIGHTS_TYPE',
				'SMB_RIGHTS',
				function(SMB_RIGHTS_TYPE, SMB_RIGHTS) {
					return {
						VIEW_RIGHTS: SMB_RIGHTS[SMB_RIGHTS_TYPE.viewRights].param,
						FULL_RIGHTS: SMB_RIGHTS[SMB_RIGHTS_TYPE.fullRights].param,
						EDIT_RIGHTS: SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights].param,
						READ_DOCUMENTS: 16,
						CREATE_DOCUMENTS: 8,
						MODIFY_DOCUMENTS: 2
					};
				}
			]);
	}());

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupsSearchService',
			[
				'$http',
				'pxUriPathService',
				'smbContentTypeAcls',
				ContentTypeGroupsSearchService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupsService
		 * 
		 * @description
		 * A service that exposes methods for creating and updating content type groups.
		 */
		function ContentTypeGroupsSearchService($http, pxUriPathService, smbContentTypeAcls) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsService#createContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupsService
				 * @kind function
				 * 
				 * @description
				 * Creates a new content type group in the system.
				 * 
				 * @param {Object} group An object representing the content type group to create
				 *
				 * @returns {Promise} A promise that resolves to the newly created content type group
				 */
				getAllContentTypeGroups: getAllContentTypeGroups,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsService#createContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupsService
				 * @kind function
				 * 
				 * @description
				 * Saves changes made to an existing content type group
				 * 
				 * @param {Object} group An object that represents an existing content type group
				 * 
				 * @returns {Promise} A promise that resolves to the content type group that was changed
				 */
				getFullAccessContentTypeGroups: getFullAccessContentTypeGroups
			};
	
			function getAllContentTypeGroups() {
				return $http.get(pxUriPathService.resolvePath('/libraries?acl=' + smbContentTypeAcls.READ_DOCUMENTS))
					.then(function (res) { return res.data.filter(function (lib) {
						return !lib.IsPrivate;
					}); 
				});
			}
	
			function getFullAccessContentTypeGroups() {
				return $http.get(pxUriPathService.resolvePath('/libraries?acl=' + smbContentTypeAcls.CREATE_DOCUMENTS))
					.then(function (res) { return res.data.filter(function (lib) {
						return !lib.IsPrivate;
					}); 
				});
			}	
		}
	}());

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypeGroupsService',
			[
				'$http',
				'pxUriPathService',
				'smbContentTypeAcls',
				ContentTypeGroupsService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypeGroupsService
		 * 
		 * @description
		 * A service that exposes methods for creating and updating content type groups.
		 */
		function ContentTypeGroupsService($http, pxUriPathService, smbContentTypeAcls) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsService#createContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupsService
				 * @kind function
				 * 
				 * @description
				 * Creates a new content type group in the system.
				 * 
				 * @param {Object} group An object representing the content type group to create
				 *
				 * @returns {Promise} A promise that resolves to the newly created content type group
				 */
				getAllContentTypeGroups: getAllContentTypeGroups,
	
				/**
				 * @ngdoc method
				 * @name smbContentTypeGroupsService#createContentTypeGroup
				 * @methodOf smb-app.smbContentTypeGroupsService
				 * @kind function
				 * 
				 * @description
				 * Saves changes made to an existing content type group
				 * 
				 * @param {Object} group An object that represents an existing content type group
				 * 
				 * @returns {Promise} A promise that resolves to the content type group that was changed
				 */
				getFullAccessContentTypeGroups: getFullAccessContentTypeGroups
			};
	
			function getAllContentTypeGroups() {
				return $http.get(pxUriPathService.resolvePath('/libraries?acl=' + smbContentTypeAcls.READ_DOCUMENTS))
					.then(function (res) { return res.data.filter(function (lib) {
						return !lib.IsPrivate;
					}); 
				});
			}
	
			function getFullAccessContentTypeGroups() {
				return $http.get(pxUriPathService.resolvePath('/libraries?acl=' + smbContentTypeAcls.CREATE_DOCUMENTS))
					.then(function (res) { return res.data.filter(function (lib) {
						return !lib.IsPrivate;
					}); 
				});
			}	
		}
	}());

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypesSearchService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentTypesSearchService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesService
		 * 
		 * @description
		 * Exposes methods for retrieving content types that belong to a content
		 * type group.
		 */
		function ContentTypesSearchService($http, $q, gettextCatalog, pxUriPathService) {
			
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypesService.getContentTypes
				 * @methodOf smb-app.smbContentTypesService
				 * @kind function
				 * 
				 * @description
				 * Gets all content types the belong to a content type group
				 * 
				 * @param {Number} groupId Id of the content type group
				 * 
				 * @returns {Deferred} A promise that will resolve to a collection of content types
				 */
				getContentTypes: getContentTypes
			};
	
			function getContentTypes(groupId) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/folders');
				return $http.get(uri)
					.then(function (response) {
						return response.data.filter(function (lib) {
												return !lib.IsPrivate;
											});
					});
			}
		}
	}());

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbContentTypesService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentTypesService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesService
		 * 
		 * @description
		 * Exposes methods for retrieving content types that belong to a content
		 * type group.
		 */
		function ContentTypesService($http, $q, gettextCatalog, pxUriPathService) {
			
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypesService.getContentTypes
				 * @methodOf smb-app.smbContentTypesService
				 * @kind function
				 * 
				 * @description
				 * Gets all content types the belong to a content type group
				 * 
				 * @param {Number} groupId Id of the content type group
				 * 
				 * @returns {Deferred} A promise that will resolve to a collection of content types
				 */
				getContentTypes: getContentTypes,
				deleteContentType: deleteContentType
			};
	
			function getContentTypes(groupId) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/folders');
				return $http.get(uri)
					.then(function (response) {
						return response.data;
					});
			}
	
			function deleteContentType(typeId, purge) {
				if (!typeId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type id')));
				}
	
				purge = typeof(purge) === 'boolean' ? purge : false;
				var uri = pxUriPathService.resolvePath('/f/{id}?purge={purge}', {
					id: typeId,
					purge: purge
				});
	
				return $http.delete(uri);
			}
		}
	}());

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular
			.module('smb-app')
			.factory('smbContentUploadService',
			[
				'$http',
				'$q',
				'pxUriPathService',
				UploadService
			]);
	
		function UploadService($http, $q, pxUriPathService) {
	
			var chunkSize = 1024 * 512;
	
			return {
	
				/**
				* @name uploadFile
				* @kind function
				* @description
				* Uploads a file. This method will chunk the file and upload
				* incrementally so as not to avoid request timeouts and content length 
				* restrictions
				*
				* @param {number} folderId - The folder to which this document should be posted
				* @param {Object} file - A file object which was generated by a browser events
				* 
				* @returns {Deferred} A promise that will resolve when the file
				* has finished uploading, or a rejection with an error if a problem
				* occurs during the upload process.
				*
				* @example
				*       function onFileDrop(e) {
				*           e.preventDefault();
				*           e.stopPropagation();
				*
				*           var files = e.originalEvent.dataTransfer.files;
				*                           
				*           pxUpload.uploadFile(folderId, files[0])
				*               .then(function() {
				*                   console.log('success!');
				*               })
				*               .catch(function(){
				*                   console.log('error!');
				*               })
				*       }
				*/
				uploadFile: uploadFile,
	
				/**
				 * @ngdoc method
				 * @name uploadRevision
				 * @kind function
				 * @description
				 * Upload a file that will be saved as a new revision to an existing document.
				 * 
				 * @param {Number} documentId The id of the document the revision belongs to.
				 * @param {Object} file A file object that was generated by browser events.
				 * 
				 * @returns {Deferred} A promise that will resolve when the file has finished
				 * uploading, or a rejection with an error if a problem occurs during the upload process.
				 */
				uploadRevision: uploadRevision,
	
				/**
				 * @ngdoc property
				 * @name revisionUploadSuccess
				 * @kind property
				 * @description
				 * Event that gets emitted when a new revision has been successfully uploaded.
				 */
				get revisionUploadSuccess() { return '@AirBase/RevisionUploadSuccess'; },
	
				/**
				 * @ngdoc method
				 * @name revisionUploadClickHandler
				 * @kind property
				 * @description
				 * Click handler for revision upload buttons. Had to do it this way because
				 * the button click wasn't natively invoking the file input when there is an
				 * <md-icon> element within the button as well.
				 * 
				 * @param {Object} scope Angular scope element for the target directive
				 * @param {Object} element Angular element that represents the directive
				 * @param {String} targetButton HTML id of the target button
				 * @param {String} targetInput HTML id of the target file input
				 */
				revisionUploadClickHandler: revisionUploadClickHandler
			};
	
			function revisionUploadClickHandler(scope, element, targetButton, targetInput) {
				var buttons = element.find('button');
				var inputs = element.find('input');
	
				var revisionButton;
				var props = Object.keys(buttons).filter(function(k) { return k !== 'length'; });
				var prop;
				for (prop in props) {
					if (buttons[prop].getAttribute('id') === targetButton) {
						revisionButton = buttons[prop];
						break;
					}
				}
	
				var revisionInput;
				props = Object.keys(inputs).filter(function(k) { return k !== 'length'; });
				for (prop in props) {
					if (inputs[prop].getAttribute('id') === targetInput) {
						revisionInput = inputs[prop];
						break;
					}
				}
	
				if (revisionButton && revisionInput) {
	
					var clickHandler = function() { revisionInput.click(); };
					revisionButton.addEventListener('click', clickHandler);
					
					scope.$on('$destroy', function() {
						revisionButton.removeEventListener('click', clickHandler);
					});
				}
			}
	
			function startUpload(id, file, isRevision) {
				var uri = isRevision === true ? '/documents/{id}/revisions/temp' : '/f/{id}/temp';
				uri = pxUriPathService.resolvePath(uri.replace('{id}', id));
	
				return $http.post(uri, { FileName: file.name})
					.then(function(res) {
						return res.data;
					});
			}
	
			function sendChunk(file, uri, offset, chunkSize) {
				var endOffset = offset + chunkSize;
				if (endOffset >= file.size) {
					endOffset = file.size;
				}
				
				var data = readSlice(file, offset, endOffset);
	
				return $http.patch(uri, data, {
					headers: {
						'Content-Type': 'application/octet-stream'
					}
				});
			}
	
			function readSlice(file, startByte, endByte) {
				var fn = 'slice';
				
				if (file.slice) {
					fn = 'slice';
				} else if (file.mozSlice) {
					fn = 'mozSlice';
				} else if (file.webkitSlice) {
					fn = 'webkitSlice';
				}
	
				return file[fn](startByte, endByte);
			}
	
			function uploadInChunks(file, serverTempFile) {
				var patchUri = serverTempFile.Links.Location;
	
				return $q(function(resolve, reject) {
	
					(function chunk(offset, fileData) {
						if (offset <= file.size) {
							return sendChunk(file, patchUri, offset, chunkSize)
								.then(function(response) {
									chunk(offset + chunkSize, response.data);
								})
								.catch(reject);
						} else {
							resolve(fileData);
						}
					}(0));
					
				});
			}
	
			function finalizeUpload(id, fileData, isRevision) {
				var uri = isRevision === true ? '/documents/{id}/revisions' : '/f/{id}/documents';
				uri = pxUriPathService.resolvePath(uri.replace('{id}', id));
	
				return $http.post(uri, {}, {
					headers: {
						'x-sharebase-fileref': JSON.stringify(fileData)
					}
				});
			}
	
			/**
			 * Uploads a file to the phoenix API. The file can either be
			 * a new document or a revision to an existing document.
			 * 
			 * @private
			 * 
			 * @param {Number} id Folder id if uploading a new document and document id if uploading a revision.
			 * @param {Object} file JavaScript file object representing the file to upload.
			 * @param {Boolean} isRevision Flag that indicates if the file is a revision. Set to true to
			 *   upload a revion; defaults to false.
			 */
			function _uploadFile(id, file, isRevision) {
				return startUpload(id, file, isRevision)
					.then(function(serverTempFile) {
						return uploadInChunks(file, serverTempFile);
					})
					.then(function(fileData) {
						return finalizeUpload(id, fileData, isRevision);
					});
			}
	
			function uploadRevision(documentId, file) {
				return _uploadFile(documentId, file, true);
			}
	
			function uploadFile(folderId, file) {
				return _uploadFile(folderId, file);
			}
		}
	
	})();

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
		'usestrict';
		var deleteDialogTemplateUrl = __webpack_require__(6);
		angular
			.module('smb-app')
			.factory('smbDeleteDialogService',[
				'$mdDialog',
				DeleteDialogService
			])
			.controller('DeleteDialogController', [
				'$mdDialog',
				'title',
				'message',
				'showPurgeOption',
				'purgeText',
				DeleteDialogController
			]);
	
		function DeleteDialogService($mdDialog){
			return {
				show: function(event, title, message, showPurgeOption, purgeText) {			
					return $mdDialog.show({
						controller: 'DeleteDialogController',
						controllerAs: 'vm',
						templateUrl: deleteDialogTemplateUrl,
						targetEvent: event,
						locals: {
							title: title,
							message: message,
							showPurgeOption: showPurgeOption,
							purgeText: purgeText 
						},
						clickOutsideToClose: false
					});
				}
			};
		}
	
		function DeleteDialogController($mdDialog, title, message, showPurgeOption, purgeText) {
			var vm = this;
			vm.title = title;
			vm.message = message;
			vm.showPurgeOption = showPurgeOption || false;
			vm.purgeText = purgeText;
			vm.permanentlyDelete = false;
			vm.delete = function() {
				$mdDialog.hide(vm.permanentlyDelete);
			};
			vm.cancel = function() {
				$mdDialog.cancel();
			};
		}
	})();


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular
			.module('smb-app')
			.factory('smbDeletedItemsService', [
				'$http',
				'$q',
				'pxUriPathService',
				DeletedItemsService
			]);
	
		function DeletedItemsService($http, $q, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesService#getAdminTrash
				 * @methodOf smb-app.smbDeletedItemsService
				 * @kind function
				 * 
				 * @description
				 * Gets the collection of all deleted items from the deployment.
				 * 
				 * @returns {Deferred<DocumentNote>} A promise that resolves to a collection of deleted document objects.
				 */
				getAdminTrash: getAdminTrash,
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesService#purge
				 * @methodOf smb-app.smbDeletedItemsService
				 * @kind function
				 * 
				 * @description
				 * Permanently deleted the provided item from the system.
				 * 
				 * @param {object} item The trash item to permanently delete.
				 *
				 * @returns {Deferred} A promise that resolves if the purge succeeded.
				 */
				purge: purge,
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesService#restore
				 * @methodOf smb-app.smbDeletedItemsService
				 * @kind function
				 * 
				 * @description
				 * Restores the provided item and removes it from trash.
				 * 
				 * @param {object} item The trash item to restore.
				 *
				 * @returns {Deferred} A promise that resolves to the restored item.
				 */
				restore: restore
			};
	
			function getAdminTrash() {
				var uri = pxUriPathService.resolvePath('/admin/trash');
	
				return $http.get(uri)
					.then(function(resp) {
						return resp.data;
					});
			}
	
			function restore(item){	
				var p = $q.reject(new Error('Invalid item to restore.'));
				if(item && item.Links) {		
					p = $http.patch(item.Links.RestoreUri)
						.then(function(resp){
							return resp.data;
						});				
				}
	
				return p;
			}
	
			function purge(item) {
				var p = $q.reject(new Error('Must provide a valid item to purge.'));
				if(item && item.Links) {
					var uri = item.Links.Self + '?purge=true';
					p = $http.delete(uri);
				}
	
				return p;
			}
		}
	})();

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbDocumentHistoryService', [
				'$http',
				'$q',
				'gettextCatalog',
				'pxUriPathService',
				DocumentHistoryService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentNotesService
		 * 
		 * @description
		 * Exposes methods for retrieving and creating document notes.
		 */
		function DocumentHistoryService($http, $q, gettextCatalog, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesService#getNotes
				 * @methodOf smb-app.smbDocumentNotesService
				 * @kind function
				 * 
				 * @description
				 * Gets the collection of all notes for a document
				 * 
				 * @param {String} documentId Id of the document whose notes are being retrieved.
				 *
				 * @returns {Deferred<DocumentNote>} A promise that resolves to a collection of @see DocumentNote objects
				 */
				getHistory: getHistory
	
			};
	
			function getHistory(documentId) {
				if (!documentId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document id')));
				}
	
				var uri = '/documents/' + documentId + '/activities?top=-1&descend=false';
				return $http.get(pxUriPathService.resolvePath(uri))
					.then(function(response) {
						return response.data;
					});
			}
		}
	}());

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		/**
		 * @typedef {Object} DocumentNote
		 * @property {Number} id A unique id for the note object
		 * @property {String} text The note text
		 * @property {Date} date Timestamp when the note was created
		 * @property {Date} lastActivityDate Last date of note activity TODO: Find out exactly what this is
		 * @property {String} userName Name of the user that created the note
		 * @property {String} replyToUrl A link for replying to the note TODO: Don't know if we are supporting this
		 */
	
		/**
		 * @typedef {Object} NewDocumentNote
		 * @description
		 * An object that represents a new document note
		 * @property {String} text The note text
		 */
	
		angular.module('smb-app')
			.factory('smbDocumentNotesService', [
				'$http',
				'$q',
				'gettextCatalog',
				'pxUriPathService',
				DocumentNotesService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentNotesService
		 * 
		 * @description
		 * Exposes methods for retrieving and creating document notes.
		 */
		function DocumentNotesService($http, $q, gettextCatalog, pxUriPathService) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesService#getNotes
				 * @methodOf smb-app.smbDocumentNotesService
				 * @kind function
				 * 
				 * @description
				 * Gets the collection of all notes for a document
				 * 
				 * @param {String} documentId Id of the document whose notes are being retrieved.
				 *
				 * @returns {Deferred<DocumentNote>} A promise that resolves to a collection of @see DocumentNote objects
				 */
				getNotes: getNotes,
	
				/**
				 * @ngdoc method
				 * @name smbDocumentNotesService#createNote
				 * @methodOf smb-app.smbDocumentNotesService
				 * @kind function
				 * 
				 * @description
				 * Create a new note for a document
				 * 
				 * @param {NewDocumentNote} An object representing a new document note
				 * 
				 * @returns {Deferred<DocumentNote>} A promise that resolves to the newly created document note.
				 */
				createNote: createNote
			};
	
			function getNotes(documentId) {
				if (!documentId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document id')));
				}
	
				var uri = '/documents/' + documentId + '/comments';
				return $http.get(pxUriPathService.resolvePath(uri))
					.then(function(response) {
						return response.data.Embedded.Comments;
					})
					.then(function(data) {
						return data.map(commentToDocumentNote);
					});
			}
	
			function createNote(documentId, note) {
				if (!documentId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document id')));
				} else if (!(note && note.text)) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required note text')));
				}
	
				var comment = { CommentText: note.text };
	
				var uri = '/documents/' + documentId + '/comments';
				return $http.post(pxUriPathService.resolvePath(uri), comment)
					.then(function(response) {
						return response.data;
					})
					.then(commentToDocumentNote);
			}
	
			function commentToDocumentNote(comment) {
				return {
					id: comment.CommentId,
					text: comment.CommentText,
					date: comment.CommentDate,
					lastActivityDate: comment.LastActivityDate,
					userName: comment.UserName,
					replyToUrl: comment.Links && comment.Links.ReplyToUri
				};
			}
	
		}
	}());

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular
			.module('smb-app')
			.factory('smbDocumentViewerNavigationService', [
				'$state', 
				'$q',
				DocumentViewerNavigationService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbDocumentViewerNavigationService
		 *
		 * @description
		 * Small service that provides a convience method for navigating to
		 * the document viewer.
		 */
		function DocumentViewerNavigationService($state, $q) {
			var _previousState;
			var _previousStateParams;
	
			var _defaultState = 'content.home';
	
			return {
				go: go,
				back: back,
	
				get backState() { return _previousState ? _previousState.name : _defaultState; },
	
				get backStateParams() { return _previousStateParams; }
			};
	
			function go(documentGroupId, documentTypeId, documentId) {
				_previousState = $state.current;
				_previousStateParams = $state.params || null;
	
				$state.go('document.view', {
					documentGroupId: documentGroupId,
					documentTypeId: documentTypeId,
					documentId: documentId
				});
			}
	
			function back() {
				var p = $q.reject(new Error('No applicable previous state.'));
				if (_previousState) {
					p = _previousStateParams ? 
						$state.go(_previousState.name, _previousStateParams) :
						$state.go(_previousState.name);				
				} else if(angular.isDefined($state.params.documentGroupId) && angular.isDefined($state.params.documentTypeId)) {
					// default to document type group search
					p = $state.go('search.contentTypeGroups.contentTypes.search', {
						groupId: $state.params.documentGroupId,
						typeId: $state.params.documentTypeId
					});
				}
	
				return p;
			}
		}
	}());

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular
			.module('smb-app')
			.factory('smbEnvironmentService', [
				'$window',
				'pxEnvironmentService',
				EnvironmentService
			]);
	
		function EnvironmentService($window, pxEnvironmentService) {
			var ua = $window.navigator.userAgent;
			var defaults = {
				configurable: false,
				enumerable: true
			};
	
			// http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
			var service = Object.create(pxEnvironmentService, {
				isIE: angular.merge({
					value: ua.indexOf('Trident') >= 0
				}, defaults),
				isFireFox: angular.merge({
					value: ua.indexOf('Mozilla') >= 0 && (typeof $window.InstallTrigger !== 'undefined')
				}, defaults)
			});
	
			return service;
		}
	}());

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.constant('smbIconTypes', {
				JPEG: 0,
				GIF: 1,
				PNG: 2,
				ICO: 3,
				SVG: 4,
				0: 'JPEG',
				1: 'GIF',
				2: 'PNG',
				3: 'ICO',
				4: 'SVG'
			})
			.factory('smbIconService', ['$http', 'pxUriPathService', 'smbIconTypes', IconService]);
	
		function IconService($http, pxUriPathService, smbIconTypes) {
	
			var _binaryTypes = [
				smbIconTypes[smbIconTypes.JPEG],
				smbIconTypes[smbIconTypes.GIF],
				smbIconTypes[smbIconTypes.PNG],
				smbIconTypes[smbIconTypes.ICO]
			];
	
			return {
	
				getIcons: getIcons,
				getIconData: getIconData
	
			};
	
			function getIcons() {
				return $http.get(pxUriPathService.resolvePath('/systemicons/SMB'))
					.then(function(res) { return res.data; });
			}
	
			function getIconData(url, type) {
				var request = {
					method: 'GET',
					url: url,
					headers: {
						Accept: getMediaType(type)
					},
					cache: true
				};
	
				if (isBinary(type)) {
					request.responseType = 'arraybuffer';
				}
	
				return $http(request)
					.then(function(res) { 
						return {
							imageData: res.data,
							isBinary: isBinary(type),
							contentType: res.headers('Content-Type')
						};
					});
			}
	
			function getMediaType(type) {
				var mediaType = 'image/';
	
				switch (type) {
					case smbIconTypes[smbIconTypes.JPEG]:
						return mediaType + 'jpeg';
					case smbIconTypes[smbIconTypes.GIF]:
						return mediaType + 'gif';
					case smbIconTypes[smbIconTypes.PNG]:
						return mediaType + 'png';
					case smbIconTypes[smbIconTypes.ICO]:
						return mediaType + 'ico';
					case smbIconTypes[smbIconTypes.SVG]:
						return mediaType + 'svg+xml';
					default:
						throw new Error('Unsupported data type for smbIcon');
				}
			}
	
			function isBinary(type) {
				return _binaryTypes.indexOf(type) >= 0;
			}
	
		}
	
	}());

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134);
	__webpack_require__(135);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(6);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(162);

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.constant('smbIndexTypesDataTypes', {
				STRING: 0,
				NUMERIC: 1,
				DATE: 2,
				0: 'Text',
				1: 'Number',
				2: 'Date',
				STRING_MAX_LENGTH: 256
			});
	}());

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbIndexTypesService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', IndexTypesService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbIndexTypesService
		 * 
		 * @description
		 * Exposes methods for retrieving content types that belong to a content
		 * type group.
		 */
		function IndexTypesService($http, $q, gettextCatalog, pxUriPathService) {
			
			return {
				/**
				 * @ngdoc method
				 * @name smbIndexTypesService.getIndexTypes
				 * @methodOf smb-app.smbIndexTypesService
				 * @kind function
				 * 
				 * @description
				 * Gets all content types the belong to a content type group
				 * 
				 * @param {Number} typeId Id of the content type group
				 * 
				 * @returns {Deferred} A promise that will resolve to a collection of content types
				 */
				getIndexTypes: getIndexTypes,
	
				getDocumentTypeGroupIndexTypes: getDocumentTypeGroupIndexTypes,
	
				setIndexTypes: setIndexTypes,
	
				getDocumentIndexes: getDocumentIndexes
			};
	
			function getIndexTypes(typeId) {
				if (!typeId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type id')));
				}
	
				var uri = pxUriPathService.resolvePath('/f/' + typeId + '/tagtypes');
				return $http.get(uri)
					.then(function (response) {
						return response.data;
					});
			}
	
			function getDocumentTypeGroupIndexTypes(groupId) {
				if (!groupId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
				return $http.get(uri)
					.then(function (response) {
						return response.data;
					});
			}
	
			function setIndexTypes(indexes, documentId) {
				var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/systemtags');
				return $http.put(uri, indexes)
					.then(function (response) {
						return response;
					});
			}
	
			function getDocumentIndexes(documentId) {
				var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/tags');
				return $http.get(uri)
					.then(function(res) { return res.data; });
			}
		}
	}());

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		
		angular.module('smb-app')
			.factory('smbLibraryConfigService',	[
				'$q',
				'$http',
				'pxUriPathService',
				'settingsService',
				'gettextCatalog',
				LibraryConfigService
			]);
	
		var path = '/libraries';
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbLibraryConfigService
		 * 
		 * @description
		 * A service that exposes methods for configuring content type libraries.
		 */
		function LibraryConfigService($q, $http, pxUriPathService, settingsService, gettextCatalog) {
	
			return {
				/**
				 * @ngdoc method
				 * @name smbLibraryConfigService#getLibrary
				 * @methodOf smb-app.smbLibraryConfigService
				 * @kind function
				 * 
				 * @description
				 * Gets a single content type library by id
				 * 
				 * @param {String} libraryId The id of the library being retrieved
	
				 * @returns {Promise} A promise that resolves to the content type library
				 * with the matching id.
				 */
				getLibrary: getLibrary,
				/**
				 * @ngdoc method
				 * @name smbLibraryConfigService#deleteLibrary
				 * @methodOf smb-app.smbLibraryConfigService
				 * @kind function
				 * 
				 * @description
				 * Deletes a single content type library by id
				 * 
				 * @param {String} libraryId The id of the library being deleted
	
				 * @returns {Promise} A promise that resolves if the deleted succeeded.
				 */
				deleteLibrary: deleteLibrary,
				/**
				 * @ngdoc method
				 * @name smbLibraryConfigService#getLibraries
				 * @methodOf smb-app.smbLibraryConfigServices
				 * @kind function
				 * 
				 * @description
				 * Gets the collection of all content type libraries for the deployment
				 * 
				 * @returns {Promise} A promise that resolves to an array of content type
				 * library objects.
				 */
				getLibraries: getLibraries,
	
				getLibraryDetails: getLibraryDetails,
	
				assignUserGroupsToLibrary: assignUserGroupsToLibrary
	
			};
	
			function getLibrary(libraryId) {
				return $http.get(pxUriPathService.resolvePath(path + '/' + libraryId))
					.then(function (response) { return response.data; });
			}
	
			function getLibraries() {
				return $http.get(pxUriPathService.resolvePath(path))
					.then(function (response) { return response.data; });
			}
	
			function getLibraryDetails(library) {
				return $http.get(settingsService.serverAPIPath + '/libraries/' + library.LibraryId + '/permissions', {
				}).then(function (response) {
					return response.data;
				});
			}
	
			function assignUserGroupsToLibrary(acls, libraryId) {
				return $http.post(settingsService.serverAPIPath + '/libraries/' + libraryId + '/permissions/replace', acls)
				.then(function (response) {
					return response.data;
				});
			}
	
			function deleteLibrary(libraryId) {
				if (!libraryId) {
					return $q.reject(new Error(gettextCatalog.getString('Missing required library id')));
				}
	
				var uri = pxUriPathService.resolvePath('/libraries/{id}', {
					id: libraryId
				});
	
				return $http.delete(uri);
			}
		}
	}());

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbSortService', [SortService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbSortService
		 * 
		 * @description
		 * A service that provides sorting functions for the different data types
		 * in the application. The methods in this service are intended to be passed
		 * to an arrays sort function. As a result, all of the methods are pure functions
		 * which do not rely on `this`.
		 */
		function SortService() {
	
			return {
	
				/**
				 * @ngdoc method
				 * @name smbSortService.sortObjectStringByProperty
				 * @methodOf smb-app.smbSortService
				 * @kind function
				 * 
				 * @description
				 * Creates and returns a function that can be to sort an array of
				 * objects by a specific string property.
				 * 
				 * @param {String} propertyName The name of the property the objects should
				 * be sorted by
				 * 
				 * @returns {Function} A function that can be used in array's sort method to
				 * sort objects by a specific property anem
				 */
				sortObjectByStringProperty: sortObjectByStringProperty,
	
				sortObjectByDateProperty: sortObjectByDateProperty,
	
				sortDate: sortDate,
	
				sortByString: sortByString
			};
	
			function sortObjectByStringProperty(propertyName, direction) {
				return function (obj1, obj2) {
					return sortByString(obj1[propertyName], obj2[propertyName], direction);
				};
			}
	
			function sortByString(string1, string2, direction) {
				if (direction) {
					return string1.toLowerCase().localeCompare(string2.toLowerCase());
				}
				else {
					return string2.toLowerCase().localeCompare(string1.toLowerCase());
				}
			}
	
			function sortObjectByDateProperty(propertyName) {
				return function(obj1, obj2) {
					return sortDate(obj1[propertyName], obj2[propertyName]);
				};
			}
	
			function sortDate(date1, date2) {
				var y1 = date1.getFullYear();
				var m1 = date1.getMonth();
				var d1 = date1.getDate();
	
				var y2 = date2.getFullYear();
				var m2 = date2.getMonth();
				var d2 = date2.getDate();
	
				if (y1 < y2) {
					return 1;
				} else if (y1 > y2) {
					return -1;
				} else if (m1 < m2) {
					return 1;
				} else if (m1 > m2) {
					return -1;
				} else if (d1 < d2) {
					return 1;
				} else if (d1 > d2) {
					return -1;
				} else {
					return 0;
				}
			}
		}
	
	}());

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	(function() {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbStatusService', [
				'$http',
				'$q',
				'smbContentTypeAcls',
				'pxUriPathService',
				StatusService
			]);
	
		function StatusService($http, $q, smbContentTypeAcls, pxUriPathService) {
	
			return {
				getStatuses: getStatuses,
	
				getDocumentStatus: getDocumentStatus,
	
				getUsers: getUsers,
	
				setDocumentStatus: setDocumentStatus
			};
	
			function getStatuses(folderId) {
				if (!(typeof folderId === 'string' || typeof folderId === 'number')) {
					return $q.reject(new Error('Missing required document type id'));
				}
	
				var uri = pxUriPathService.resolvePath('/f/' + folderId + '/tagtypes');
				return $http.get(uri)
					.then(function(res) {
						return res.data;
					});
			}
	
			function getDocumentStatus(documentId) {
				var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/status');
				return $http.get(uri)
					.then(function(res) { 
						return res.data.TypedTags; 
					});
			}
	
			function getUsers(documentId) {
				var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/users?acl=' + smbContentTypeAcls.MODIFY_DOCUMENTS);
				return $http.get(uri)
					.then(function(res) {
						return res;
					});
			}
	
			function setDocumentStatus(status, documentId) {
				var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/status');
				return $http.put(uri, status)
					.then(function (response) {
						return response;
					});
			}
		}
	}());

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbToDoListService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ToDoListService]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbContentTypesService
		 * 
		 * @description
		 * Exposes methods for retrieving content types that belong to a content
		 * type group.
		 */
		function ToDoListService($http, $q, gettextCatalog, pxUriPathService) {
			
			return {
				/**
				 * @ngdoc method
				 * @name smbContentTypesService.getContentTypes
				 * @methodOf smb-app.smbContentTypesService
				 * @kind function
				 * 
				 * @description
				 * Gets all content types the belong to a content type group
				 * 
				 * @param {Number} groupId Id of the content type group
				 * 
				 * @returns {Deferred} A promise that will resolve to a collection of content types
				 */
				getDocuments: getDocuments,
	
				getCount: getCount
			};
	
			function getDocuments() {
				var uri = pxUriPathService.resolvePath('/todolist');
				return $http.get(uri)
					.then(function (response) {
						return response.data;
					});
			}
	
			function getCount() {
				var tagValues = [];
				var uri = pxUriPathService.resolvePath('/todolist/count');
				return $http.get(uri)
					.then(function (response) {
						return response.data;
					});
			}
		}
	}());

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
		angular.module('smb-app')
			.factory('smbToolbarService',
			[
				'pxAuthService',
				ToolbarService
			]);
		/**
	    * @ngdoc service
	    * @name  smb-app.smbToolbarService
	    * 
	    * @description 
	    * A service used to retrieve and interact with ShareBase app 
	    * content toolbar
	    * 
	    **/
		function ToolbarService(pxAuthService) {
			var _title = null;
			var _backArrowState = 'content.home';
			var _showLogo = false;
			var _showContextMenu = false;
			var _contextMenuActions = [];
			var _backArrowStateParams = null;
	
			return {
				/**
	            * @ngdoc property
	            * @name smbToolbarService#title
	            * @propertyOf smb-app.smbToolbarService
	            * @kind property
	            *
	            * @description
	            * Title assigned to content toolbar
	            *
	            * @returns {string} value of title 
	            * 
	            */
				get title() { return _title; },
				
				/**
	            * @ngdoc property
	            * @name smbToolbarService#title
	            * @propertyOf smb-app.smbToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the title for content toolbar
	            *
	            * @returns {string} value of title 
	            * @param {string} val Title to assign to content toolbar 
	            */
				set title(val) { _title = val; },
	
				/**
	            * @ngdoc property
	            * @name smbToolbarService#backArrowState
	            * @propertyOf smb-app.smbToolbarService
	            * @kind property
	            *
	            * @description
	            * Get the state assigned to back arrow on the toolbar
	            *
	            * @returns {string} value of title 
	            * 
	            */
				get backArrowState() { return _backArrowState; },
	
				/**
	            * @ngdoc property
	            * @name smbToolbarService#backArrowState
	            * @propertyOf smb-app.smbToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the state to back arrow on the toolbar
	            *
	            * @returns {string} value of backArrowState 
	            * @param {string} val Back Arrow State to assign to content toolbar 
	            */
				set backArrowState(val) { _backArrowState = val; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#backArrowState
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Get the state params object for the toolbar's back button.
				 * 
				 * @returns {Object} State parameters for back button
				 */
				get backArrowStateParams() { return _backArrowStateParams; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#backArrowStateParams
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Optionally set stat parameters for the back arrow state.
				 * 
				 * @param {Object} val An object of state parameters
				 */
				set backArrowStateParams(val) { _backArrowStateParams = val; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#hasUserAdminRights
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Returns true if the current user has user administration rights
				 * 
				 * @returns {Boolean} Returns true if user is a user admin and false otherwise
				 */
				get hasUserAdminRights() { return pxAuthService.isUserAdmin || pxAuthService.isSiteAdmin; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#hasContentAdminRights
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Returns true if the current user has content administration rights
				 * 
				 * @returns {Boolean} Returns true if user has correct rights for content administration
				 * and false if they do not.
				 */
				get hasContentAdminRights() { return pxAuthService.isSiteAdmin; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#showLogo
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Returns true if the app logo should be displayed.
				 * 
				 * @returns {Boolean} True if the toolbar should display and false if
				 * it should hide the logo.
				 */
				get showLogo() { return _showLogo; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#showLogo
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Set the flag to show or hide the application logo
				 * 
				 * @param {Boolean} val Value to set the flag to
				 */
				set showLogo(val) { _showLogo = val; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#showBackButton
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Flag that determines if the toolbar will display the back button.
				 * If true, the back button will be displayed.
				 * 
				 * @returns {Boolean} True if the back button should be displayed and false
				 * if it should be hidden.
				 */
				get showBackButton() { return !_showLogo; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#showContextMenu
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Flag that returns true if the context menu is displayed and false if it
				 * is not. Defaults to false to hide the context menu.
				 * 
				 * @returns {Boolean} True if the context menu is displayed and false if
				 * it is hidden.
				 */
				get showContextMenu() { return _showContextMenu; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#showContextMenu
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Set the flag that determine whether to display or hide the context 
				 * menu
				 * 
				 * @param {Boolean} val Value to set the flag to.
				 */
				set showContextMenu(val) { _showContextMenu = val; },
	
				/**
				 * @ngdoc property
				 * @name smbToolbarService#contextMenuActions
				 * @propertyOf smb-app.smbToolbarService
				 * @kind property
				 * 
				 * @description
				 * Get the list of action objects for the context menu.
				 * 
				 * @returns {Object[]} Collection of context menu actions
				 */
				get contextMenuActions() { return _contextMenuActions; },
	
				/**
				 * @ngdoc method
				 * @name smbToolbarService#reset
				 * @methodOf smb-app.smbToolbarService
				 * @kind function
				 * 
				 * @description
				 * Reset the state of the toolbar service to all default values.
				 */
				reset: reset,
	
				/**
				 * @ngdoc method
				 * @name smbToolbarService#addContextMenuAction
				 * @methodOf smb-app.smbToolbarService
				 * @kind function
				 * 
				 * @description
				 * Add a new context menu action to the existing list of context menu actions.
				 * 
				 * @param {Object} action The content menu action to add
				 */
				addContextMenuAction: addContextMenuAction,
	
				/**
				 * @ngdoc method
				 * @name smbToolbarService#set
				 * @methodOf smb-app.smbToolbarService
				 * @kind function
				 * 
				 * @description
				 * Set the state of the toolbar service properties.
				 * 
				 * @param {String} title Title to display in toolbar
				 * @param {String} backArrow Target state for the back arrow
				 * @param {Boolean} showLogo Flag that indicates if the logo should be shown
				 * @param {Boolean} showContextMenu Flag that indicates if the context menu should be shown
				 */
				set: set,
	
				/**
				 * @ngdoc method
				 * @name smbToolbarService#setContextMenuActions
				 * @methodOf smb-app.smbToolbarService
				 * @kind function
				 * 
				 * @description
				 * Replace the current set of context menu actions with a new
				 * collection of actions
				 * 
				 * @param {Object[]} actions An array of context menu action objects
				 */
				setContextMenuActions: setContextMenuActions
			};
	
			function addContextMenuAction(action) {
				_contextMenuActions = _contextMenuActions.concat(action);
			}
	
			function setContextMenuActions(actions) {
				if (actions) {
					_contextMenuActions = actions;
				} else {
					_contextMenuActions = [];
				}
			}
	
			function reset() {
				set('', 'content.home', true, false);
			}
	
			function set(title, backArrow, showLogo, showContextMenu) {
				if (typeof title === 'string') {
					_title = title;
				}
	
				if (backArrow) {
					_backArrowState = backArrow;
				}
	
				_showLogo = showLogo;
				_showContextMenu = showContextMenu;
			}
		}
	
	}());

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	(function () {
		'use strict';
	
		angular.module('smb-app')
			.factory('smbUserGroupFilterService',
			[
				'smbSortService',
				'smbContentTypeAcls',
				UserGroupFilterService
			]);
	
		/**
		 * @ngdoc service
		 * @name smb-app.smbUserGroupFilterService
		 * 
		 * @description
		 * A service that exposes methods for extracting content type group assignment details.
		 */
		function UserGroupFilterService(smbSortService, smbContentTypeAcls) {
			var _userGroupsWithViewRights = [];
			var _userGroupsWithFullRights = [];
			var _userGroupsWithEditRights = [];
	
			return {
				/**
				 * @ngdoc method
				 * @name smbUserGroupFilterService#filterUserGroups
				 * @methodOf smb-app.smbUserGroupFilterService
				 * @kind function
				 * 
				 * @description
				 * Filters and separates User Groups into two lists, one with View rights and Full rights
				 * 
				 * @param {Object} details, The details object from wchich the details have to be extracted
				 */
				filterUserGroups: filterUserGroups,
	
				getUserGroupsWithViewRights: getUserGroupsWithViewRights,
	
				getUserGroupsWithFullRights: getUserGroupsWithFullRights,
	
				getUserGroupsWithEditRights: getUserGroupsWithEditRights,
			};
	
			function filterUserGroups(details) {
				_userGroupsWithViewRights = [];
				_userGroupsWithFullRights = [];
				_userGroupsWithEditRights = [];
	
				details.forEach(function (permission) {
					if (permission.UserGroupId > 0)
					{
						switch (permission.Privileges) {
							case smbContentTypeAcls.VIEW_RIGHTS:
								_userGroupsWithViewRights.push(permission);
								break;
							case smbContentTypeAcls.EDIT_RIGHTS:
								_userGroupsWithEditRights.push(permission);
								break;
							case smbContentTypeAcls.FULL_RIGHTS:
								_userGroupsWithFullRights.push(permission);
								break;
						}
					}
				});
	
				_userGroupsWithViewRights.sort(smbSortService.sortObjectByStringProperty('UserGroupName'));
				_userGroupsWithFullRights.sort(smbSortService.sortObjectByStringProperty('UserGroupName'));
				_userGroupsWithEditRights.sort(smbSortService.sortObjectByStringProperty('UserGroupName'));
			}
	
			function getUserGroupsWithEditRights() {
				return _userGroupsWithEditRights;
			}
	
			function getUserGroupsWithViewRights() {
				return _userGroupsWithViewRights;
			}
	
			function getUserGroupsWithFullRights() {
				return _userGroupsWithFullRights;
			}
		}
	}());

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var path = 'components/_app/app.template.html';
	var html = " <md-sidenav class=\"md-sidenav-right smb-app__nav-panel smb-app-mobile-menu\" md-component-id=menu-left-panel md-is-open=vm.mobileNavOpen> <nav layout-fill layout=column md-swipe-right=\"vm.mobileNavOpen = false;\"> <md-list flex hide show-xs show-sm role=navigation layout=column layout-align=\"start stretch\"> <md-list-item layout=row layout-align=\"center center\"> <md-button layout=column layout-align=\"center center\" class=home-button ui-sref=content.home> <img height=26 src=" + __webpack_require__(2) + " /> </md-button> </md-list-item> <md-list-item ui-sref=content.home ng-hide=vm.smbToolbarService.showLogo> <md-icon class=material-icons>home</md-icon> <p translate>Home</p> </md-list-item> <md-list-item ui-sref=todo.list ng-hide=vm.smbToolbarService.showLogo> <md-icon class=material-icons>assignment</md-icon> <div class=\"inbox-count inbox-count---nav smb-app--background-red\">{{vm.todoListDS.count}}</div> <p translate>My To-Do List</p> </md-list-item> <md-list-item ui-sref=useradmin.home ng-if=vm.isUserAdmin()> <md-icon class=material-icons>people</md-icon> <p translate>User Administration</p> </md-list-item> <md-list-item ng-if=vm.isContentAdmin() ui-sref=contentConfig.groups> <md-icon class=material-icons>settings</md-icon> <p translate>Document Groups Config</p> </md-list-item> <md-list-item ng-if=\"vm.isSiteAdmin && vm.privileges.core.trash.manageTrash\" ui-sref=documentTrash.home> <md-icon class=material-icons>delete</md-icon> <p translate>Deleted Items</p> </md-list-item> <md-list-item ng-click=vm.logout()> <md-icon class=material-icons>input</md-icon> <p translate>Logout</p> </md-list-item> <span flex></span> <md-divider></md-divider> <md-list-item ng-click=\"vm.openLink('./help/desktop/index.htm')\"> <md-icon class=material-icons>help_outline</md-icon> <p translate>Help</p> </md-list-item> <md-list-item ng-click=\"vm.openLink(vm.pxEnvironmentService.legalLanguage === 'en' ?  './acceptable-use-policy' : './'+vm.pxEnvironmentService.legalLanguage+'/acceptable-use-policy')\"> <md-icon class=material-icons>import_export</md-icon> <p translate>Acceptable Use Policy</p> </md-list-item> <md-list-item ng-click=\"vm.openLink(vm.pxEnvironmentService.legalLanguage === 'en' ?  './privacy-policy' : './'+vm.pxEnvironmentService.legalLanguage+'/privacy-policy')\"> <md-icon class=material-icons>vpn_key</md-icon> <p translate>Privacy Policy</p> </md-list-item> <md-list-item ng-click=\"vm.openLink(vm.pxEnvironmentService.legalLanguage === 'en' ?  './terms-of-use-and-subscription' : './'+vm.pxEnvironmentService.legalLanguage+'/terms-of-use-and-subscription')\"> <md-icon class=material-icons>gavel</md-icon> <p translate>Terms of Use</p> </md-list-item> </md-list> </nav> </md-sidenav> <div class=smb-app> <md-toolbar class=smb-app__header> <div class=\"md-toolbar-tools smb-app__header__toolbar\" hide-xs hide-sm layout=row> <md-button layout=column layout-align=\"center center\" class=home-button ui-sref=content.home ng-if=vm.smbToolbarService.showLogo> <img height=38 src=" + __webpack_require__(2) + " /> </md-button> <md-button class=md-icon-button ng-click=vm.onClickBackArrow() ng-if=vm.smbToolbarService.showBackButton> <md-icon class=material-icons>arrow_back</md-icon> </md-button> <h2 flex class=ellipsis>{{vm.smbToolbarService.title}}</h2> <div layout=row layout-align=\"end center\" class=smb-toolbar-actions> <md-button class=\"md-icon-button smb-toolbar-action\" ui-sref=useradmin.home ng-if=vm.isUserAdmin()> <md-icon class=material-icons>people</md-icon> <md-tooltip md-delay=800 show-gt-sm hide> <translate>User Administration</translate> </md-tooltip> </md-button> <md-button class=\"md-icon-button smb-toolbar-action\" ng-if=vm.isContentAdmin() ui-sref=contentConfig.groups> <md-icon class=material-icons>settings</md-icon> <md-tooltip md-delay=800 show-gt-sm hide> <translate>Document Groups Configuration</translate> </md-tooltip> </md-button> <md-button class=\"md-icon-button smb-toolbar-action\" ui-sref=documentTrash.home ng-if=\"vm.isSiteAdmin && vm.privileges.core.trash.manageTrash\"> <md-icon class=material-icons>delete</md-icon> <md-tooltip md-delay=800 show-gt-sm hide><translate>Deleted Items</translate></md-tooltip> </md-button> <md-button class=\"md-icon-button smb-toolbar-action\" ui-sref=content.home ng-hide=vm.smbToolbarService.showLogo> <md-icon class=material-icons>home</md-icon> <md-tooltip md-delay=800 show-gt-sm hide> <translate>Home</translate> </md-tooltip> </md-button> <md-button class=\"md-icon-button smb-toolbar-action\" ui-sref=todo.list ng-hide=vm.smbToolbarService.showLogo> <md-icon class=material-icons>assignment</md-icon> <div class=\"inbox-count smb-app--background-red\">{{vm.todoListDS.count}}</div> <md-tooltip md-delay=800 show-gt-sm hide> <translate>My To-Do List</translate> </md-tooltip> </md-button> <md-button class=\"md-icon-button smb-toolbar-action\" ng-click=vm.logout()> <md-icon class=material-icons>input</md-icon> <md-tooltip md-delay=800 show-gt-sm hide> <translate>Logout</translate> </md-tooltip> </md-button> <label>{{vm.userName}}</label> <md-menu md-position-mode=\"target-right target\"> <md-button class=md-icon-button ng-click=$mdOpenMenu($event)> <md-icon class=material-icons>info_outline</md-icon> </md-button> <md-menu-content> <md-menu-item> <md-button target=_blank ng-href=./help/desktop/index.htm> <translate>Help</translate> </md-button> </md-menu-item> <md-menu-item> <md-button target=_blank ng-href=\"{{vm.pxEnvironmentService.legalLanguage === 'en' ?  './acceptable-use-policy' : './'+vm.pxEnvironmentService.legalLanguage+'/acceptable-use-policy'}}\"> <translate>Acceptable Use Policy</translate> </md-button> </md-menu-item> <md-menu-item> <md-button target=_blank ng-href=\"{{vm.pxEnvironmentService.legalLanguage === 'en' ?  './privacy-policy' : './'+vm.pxEnvironmentService.legalLanguage+'/privacy-policy'}}\"> <translate>Privacy Policy</translate> </md-button> </md-menu-item> <md-menu-item> <md-button target=_blank ng-href=\"{{vm.pxEnvironmentService.legalLanguage === 'en' ?  './terms-of-use-and-subscription' : './'+vm.pxEnvironmentService.legalLanguage+'/terms-of-use-and-subscription'}}\"> <translate>Terms of Use</translate> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </div> <div class=\"md-toolbar-tools smb-app__header__toolbar smb-app__header__toolbar--mobile\" hide show-xs show-sm> <md-button layout=column layout-align=\"center center\" class=home-button ui-sref=content.home ng-if=vm.smbToolbarService.showLogo> <img height=38 src=" + __webpack_require__(2) + " /> </md-button> <md-button class=md-icon-button ng-click=vm.onClickBackArrow() ng-show=vm.smbToolbarService.showBackButton> <md-icon class=material-icons>arrow_back</md-icon> </md-button> <h3 flex class=ellipsis>{{vm.smbToolbarService.title}}</h3> <md-button class=md-icon-button aria-label=\"Show menu\" ng-click=\"vm.mobileNavOpen = !vm.mobileNavOpen;\"> <md-icon class=material-icons>menu</md-icon> </md-button> </div> </md-toolbar> <div class=smb-app__main> <div class=\"smb-app__main__content smb-app__main__content--smooth-scroll\" ng-class=\"{'smb-app__main__content--header-open': vm.smbToolbarService.showContextMenu}\"> <main ui-view=app class=smb-app-animate--fade-in></main> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	var path = 'components/assignedUsers/assignedUsers.template.html';
	var html = "<md-subheader class=\"md-no-sticky md-accent\"> <translate>Assigned User</translate> </md-subheader> <div class=md-padding> <md-input-container class=md-block md-no-float style=width:100%;margin-top:0;margin-bottom:0> <md-select ng-model=vm.selectedUser placeholder=\"{{::'Select User' | translate}}\" ng-disabled=vm.isContentStatusSelected md-on-close=vm.onChange()> <md-option value={{null}}> <em><translate>None</translate></em> </md-option> <md-option ng-repeat=\"user in vm.assignedUsers\" value={{user}}>{{user.UserName}}</md-option> </md-select> </md-input-container> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	var path = 'components/contentSearch/contentSearch.template.html';
	var html = "<form flex layout-fill class=smb-app--overflow-content name=indexForm layout-gt-sm=column layout-align-gt-sm=\"start stretch\"> <div flex-gt-sm layout=row layout-align=\"start start\"> <div flex-gt-sm=50 flex=100> <md-list> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Document Type</translate> </md-subheader> <md-list-item class=md-2-line> <smb-icon class=md-avatar icon-name={{vm.contentTypeDS.contentType.IconName}} icon-uri={{vm.contentTypeDS.contentType.Links.IconUri}} icon-type={{vm.defaultIconType}}></smb-icon> <div class=md-list-item-text> <h3>{{vm.contentTypeDS.contentType.FolderName}}</h3> <p>{{vm.contentTypeGroupDS.contentTypeGroup.LibraryName}}</p> </div> </md-list-item> </md-list> <smb-status content-statuses=vm.contentStatuses status=vm.status todo-statuses=vm.todoStatuses on-status-change=vm.onStatusChange()> </smb-status> <smb-assigned-users assigned-users=vm.usersDS.users selected-user=vm.selectedUser is-content-status-selected=vm.isContentStatusSelected> </smb-assigned-users> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Index Types</translate> </md-subheader> <smb-indexes indextypes=vm.indextypes></smb-indexes> </div> </div> <div layout=row class=md-padding layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button class=md-raised ng-click=vm.search()> <translate>Search</translate> </md-button> </div> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	var path = 'components/contentSearchResults/contentSearchResults.template.html';
	var html = "<smb-document-hit-list documents=vm.contentSearchDS.documents view-on-select=true></smb-document-hit-list>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeConfig/contentTypeConfig.template.html';
	var html = "<md-content class=smb-app__content-type-config layout-fill layout=column layout-align=\"start stretch\"> <form flex name=contentTypeConfigForm novalidate ng-submit=vm.onSubmit() layout=column layout-align=\"start stretch\"> <md-tabs class=smb-app__tabs flex> <md-tab class=smb-app__tabs--tab> <md-tab-label> <span class=smb-app__tabs--tab__label ng-class=\"{'is-dirty': vm.typeIsDirty}\" translate>Type Configuration</span> </md-tab-label> <md-tab-body> <md-content layout-fill> <smb-content-type-config-form content-type=vm.contentType on-change=vm.onContentTypeChange(contentType)></smb-content-type-config-form> </md-content> </md-tab-body> </md-tab> <md-tab class=smb-app__tabs--tab> <md-tab-label> <span class=smb-app__tabs--tab__label ng-class=\"{'is-dirty': vm.indexTypesAreDirty}\" translate>Field Configuration</span> </md-tab-label> <md-tab-body> <smb-index-type-config current-index-types=vm.contentTypeIndexes index-types-pool=vm.contentTypeGroupIndexes current-index-types-title=\"{{::'Document Type Fields' | translate}}\" on-new-item=vm.onAddIndexType(item) index-types-pool-title=\"{{::'Document Group Fields' | translate}}\" index-types-pool-add-label=\"{{::'Add field to document type' | translate}}\" allow-edit-name=false allow-edit-default-value=true allow-delete=true on-delete=vm.onDeleteIndexType(item) enable-sequencing=true on-sequence=\"vm.onSequence(index1, index2)\" on-edit-item=vm.onEditIndexType(item)> </smb-index-type-config> </md-tab-body> </md-tab> <md-tab class=smb-app__tabs--tab> <md-tab-label> <span class=smb-app__tabs--tab__label ng-class=\"{'is-dirty': vm.statusIsDirty}\" translate>Status Configuration</span> </md-tab-label> <md-tab-body> <smb-status-config content-statuses=vm.contentStatuses on-status-change=vm.onStatusChange() todo-statuses=vm.todoStatuses></smb-status-config> </md-tab-body> </md-tab> </md-tabs> <div class=md-padding layout=row layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button ui-sref=\"contentConfig.types({groupId: vm.contentTypeGroupId})\"> <translate>Cancel</translate> </md-button> <md-button type=submit flex-order-xs=-1 class=md-raised> <translate ng-if=vm.contentTypeId>Update</translate> <translate ng-if=!vm.contentTypeId>Create</translate> </md-button> </div> </form> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeConfigForm/contentTypeConfigForm.template.html';
	var html = "<div flex layout-fill ng-if=vm.contentType> <div class=content-type-config-form layout=column layout-align=\"start stretch\"> <div class=md-padding> <md-input-container class=\"md-block smb-input-container\"> <label for=contentTypeIcon> <translate>Document Type Name</translate> </label> <input id=contentTypeName name=contentTypeName type=text required max-length=50 ng-model=vm.contentType.FolderName ng-blur=vm.onNameChange()> </md-input-container> </div> <md-subheader class=\"md-accent md-no-sticky\"> <translate>Icon</translate> </md-subheader> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=vm.setIcon($event)> <md-icon class=material-icons>{{!vm.contentTypeIcon ? 'add':'edit'}}</md-icon> </md-grid-tile> <md-grid-tile class=\"{{0 | colorFilter}}\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-if=vm.contentTypeIcon> <smb-icon class=smb-app__tile--icon icon-name={{vm.contentTypeIcon.IconName}} icon-uri={{vm.contentTypeIcon.IconUri}} icon-type=SVG></smb-icon> <md-grid-tile-footer> <h3>{{vm.contentTypeIcon.IconUserFriendlyName}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroupConfig/contentTypeGroupConfig.template.html';
	var html = "<md-content class=smb-app__content-type-group-config layout-fill layout=column layout-align=\"start stretch\"> <form name=contentTypeGroupConfigForm ng-submit=vm.onSubmit() novalidate flex-gt-xs layout=column layout-align=\"start stretch\"> <md-tabs class=smb-app__tabs flex-gt-xs> <md-tab class=smb-app__tabs--tab> <md-tab-label><span class=smb-app__tabs--tab__label ng-class=\"{'is-dirty': vm.groupIsDirty}\" translate>Group Configuration</span></md-tab-label> <md-tab-body> <md-content> <smb-content-type-group-config-form on-change=\"vm.onGroupChange(group, viewUserGroups, fullUserGroups)\" group=vm.group view-rights-user-groups=vm.viewRightsUserGroups full-rights-user-groups=vm.fullRightsUserGroups edit-rights-user-groups=vm.editRightsUserGroups> </smb-content-type-group-config-form> </md-content> </md-tab-body> </md-tab> <md-tab class=smb-app__tabs--tab> <md-tab-label><span class=smb-app__tabs--tab__label ng-class=\"{'is-dirty': vm.indexTypesAreDirty}\" translate>Field Configuration</span></md-tab-label> <md-tab-body> <md-content> <smb-index-type-config allow-edit-name=true allow-edit-default-value=true allow-delete=false index-types-pool=vm.indexPool current-index-types=vm.indexTypes current-index-types-title=\"Document Group Fields\" on-new-item=vm.newIndexType(item) on-edit-item=vm.editIndexType(item)> </smb-index-type-config> </md-content> </md-tab-body> </md-tab> </md-tabs> <div layout=row class=md-padding layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button ui-sref=contentConfig.groups translate> <translate>Cancel</translate> </md-button> <md-button type=submit flex-order-xs=-1 class=md-raised> <translate ng-if=vm.groupId>Update</translate> <translate ng-if=!vm.groupId>Create</translate> </md-button> </div> </form> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroupConfigForm/contentTypeGroupConfigForm.template.html';
	var html = "<div flex layout-fill ng-if=vm.group> <div class=content-type-config-form> <div class=\"smb-app-form-section md-padding\"> <md-input-container class=\"md-block smb-input-container\"> <label translate>Document Group Name</label> <input type=text ng-model=vm.group.LibraryName required maxlength=50 ng-blur=vm.onNameBlur() /> </md-input-container> </div> <md-subheader class=\"md-accent md-no-sticky\"> <translate>Icon</translate> </md-subheader> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=vm.setIcon($event)> <md-icon class=material-icons>{{!vm.group.IconId ? 'add' : 'edit'}}</md-icon> </md-grid-tile> <md-grid-tile class=\"{{0 | colorFilter}}\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-if=vm.group.IconId> <smb-icon class=smb-app__tile--icon icon-name={{vm.group.IconName}} icon-uri={{vm.group.Links.IconUri}} icon-type=SVG></smb-icon> <md-grid-tile-footer> <h3>{{vm.group.IconName}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> <md-subheader class=\"md-accent md-no-sticky\"> <translate>User Groups (View Rights)</translate> </md-subheader> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=\"vm.addUserGroups($event, vm.viewRightsUserGroups, [vm.fullRightsUserGroups, vm.editRightsUserGroups])\"> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"group in vm.viewRightsUserGroups\" md-rowspan=1 md-colspan=1 md-colspan-sm=1> <md-button class=\"md-icon-button config-button\" ng-click=\"vm.removeUserGroup(group, vm.viewRightsUserGroups)\"> <md-icon class=material-icons>clear</md-icon> </md-button> <md-icon class=material-icons>supervisor_account</md-icon> <md-grid-tile-footer> <h3 class=ellipsis>{{group.UserGroupName}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> <md-subheader class=\"md-accent md-no-stick\"> <translate>User Groups (Edit Rights)</translate> </md-subheader> <div class=grid-list-container flex=\"\" layout-fill=\"\"> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile class=title-add-holder md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-click=\"vm.addUserGroups($event, vm.editRightsUserGroups, [vm.fullRightsUserGroups, vm.viewRightsUserGroups])\"> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"group in vm.editRightsUserGroups\" md-rowspan=1 md-colspan=1 md-colspan-sm=1> <md-button class=\"md-icon-button config-button\" ng-click=\"vm.removeUserGroup(group, vm.editRightsUserGroups)\"> <md-icon class=material-icons>clear</md-icon> </md-button> <md-icon class=material-icons>supervisor_account</md-icon> <md-grid-tile-footer class=ellipsis> <h3 class=ellipsis>{{group.UserGroupName}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> <md-subheader class=\"md-accent md-no-sticky\"> <translate>User Groups (Full Rights)</translate> </md-subheader> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=\"vm.addUserGroups($event, vm.fullRightsUserGroups, [vm.viewRightsUserGroups, vm.editRightsUserGroups])\"> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"group in vm.fullRightsUserGroups\" md-rowspan=1 md-colspan=1 md-colspan-sm=1> <md-button class=\"md-icon-button config-button\" ng-click=\"vm.removeUserGroup(group, vm.fullRightsUserGroups)\"> <md-icon class=material-icons>clear</md-icon> </md-button> <md-icon class=material-icons>supervisor_account</md-icon> <md-grid-tile-footer> <h3 class=ellipsis>{{group.UserGroupName}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroupSearch/contentTypeGroupSearch.template.html';
	var html = "<form flex layout-fill class=smb-app--overflow-content name=indexForm layout-gt-sm=column layout-align-gt-sm=\"start stretch\"> <div flex> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Document Type Group</translate> </md-subheader> <md-list flex-gt-sm=50 flex=100> <md-list-item> <smb-icon class=md-avatar icon-name={{vm.contentTypeGroupDS.contentTypeGroup.IconName}} icon-uri={{vm.contentTypeGroupDS.contentTypeGroup.Links.IconUri}} icon-type={{vm.defaultIconType}}></smb-icon> <p>{{vm.contentTypeGroupDS.contentTypeGroup.LibraryName}}</p> </md-list-item> </md-list> <md-divider></md-divider> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Index Types</translate> </md-subheader> <smb-indexes flex-gt-sm=50 flex=100 indextypes=vm.indextypes></smb-indexes> </div> <div layout=row class=md-padding layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button class=md-raised ng-click=vm.search()> <translate>Search</translate> </md-button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroupSearchResults/contentTypeGroupSearchResults.template.html';
	var html = "<smb-document-hit-list documents=vm.contentSearchDS.documents view-on-select=true></smb-document-hit-list>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroups/contentTypeGroups.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\" ng-if=\"vm.contentTypeGroupsDataStore.fullAccessGroups.length > 0\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"item in vm.contentTypeGroupsDataStore.fullAccessGroups\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ui-sref=\"import.contentTypeGroups.contentTypes({ groupId: item.id })\"> <smb-icon class=smb-app__tile--icon icon-name={{item.icon}} icon-uri={{item.links.icon}} icon-type={{vm.defaultIconType}}></smb-icon> <md-grid-tile-footer> <h3>{{item.name}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </md-content> <md-content ng-if=\"vm.contentTypeGroupsDataStore.fullAccessGroups.length === 0\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">warning</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>No document groups available</translate></h2> <p class=smb-app__empty-state-description><translate>Groups you have access to will be listed here.</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroupsConfig/contentTypeGroupsConfig.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ui-sref=contentConfig.groups.details> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-repeat=\"item in vm.contentTypeGroupsDataStore.groups\" class=\"{{$index | colorFilter}}\"> <md-menu md-position-mode=\"target-right target\"> <md-button class=\"md-icon-button config-button\" ng-click=$mdOpenMenu($event)> <md-icon md-menu-origin class=material-icons>settings</md-icon> </md-button> <md-menu-content> <md-menu-item> <md-button ui-sref=\"contentConfig.groups.details({groupId: item.id})\"> <md-icon class=material-icons>edit</md-icon> <translate>Edit Group</translate> </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=\"vm.deleteContentTypeGroup($event, item)\"> <md-icon class=material-icons>delete</md-icon> <translate>Delete Group</translate> </md-button> </md-menu-item> </md-menu-content> </md-menu> <div class=tile-content-container ui-sref=\"contentConfig.types({groupId: item.id})\" layout=row layout-align=\"center center\"> <smb-icon class=smb-app__tile--icon icon-name={{item.icon}} icon-uri={{item.links.icon}} icon-type={{vm.iconType}}></smb-icon> <md-grid-tile-footer> <h3>{{item.name}}</h3> </md-grid-tile-footer> </div> </md-grid-tile> </md-grid-list> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	var path = 'components/contentTypeGroupsSearch/contentTypeGroupsSearch.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\" ng-if=\"vm.contentTypeGroupsSearchDataStore.allGroups.length > 0\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"item in vm.contentTypeGroupsSearchDataStore.allGroups\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ui-sref=\"search.contentTypeGroups.contentTypes({ groupId: item.id })\"> <div layout=row layout-align=\"center center\"> <smb-icon class=smb-app__tile--icon icon-name={{item.icon}} icon-uri={{item.links.icon}} icon-type={{vm.defaultIconType}}></smb-icon> <md-grid-tile-footer> <h3>{{item.name}}</h3> </md-grid-tile-footer> </div> </md-grid-tile> </md-grid-list> </div> </md-content> <md-content ng-if=\"vm.contentTypeGroupsSearchDataStore.allGroups.length === 0\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">warning</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>No document groups available</translate></h2> <p class=smb-app__empty-state-description><translate>Groups you have access to will be listed here.</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	var path = 'components/contentTypes/contentTypes.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\" ng-if=\"vm.contentTypesDataStore.contentTypes.length > 0\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"item in vm.contentTypesDataStore.contentTypes\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ui-sref=\"import.contentTypeGroups.contentTypes.content({typeId: item.FolderId})\"> <smb-icon class=smb-app__tile--icon icon-name={{item.IconName}} icon-uri={{item.Links.IconUri}} icon-type={{vm.defaultIconType}}></smb-icon> <md-grid-tile-footer> <h3>{{item.FolderName}}</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </md-content> <md-content ng-if=\"vm.contentTypesDataStore.contentTypes.length === 0\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">warning</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>No document types available</translate></h2> <p class=smb-app__empty-state-description><translate>Types you have access to will be listed here.</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	var path = 'components/contentTypesConfig/contentTypesConfig.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ui-sref=contentConfig.types.details> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-repeat=\"item in vm.contentTypesDS.contentTypes\" class=\"{{$index | colorFilter}}\"> <md-button class=\"md-icon-button config-button\" ng-click=vm.deleteDocumentType($event,item)> <md-icon class=material-icons>delete</md-icon> </md-button> <div class=tile-content-container ui-sref=\"contentConfig.types.details({typeId: item.FolderId})\" layout=row layout-align=\"center center\"> <smb-icon class=smb-app__tile--icon icon-name={{item.IconName}} icon-uri={{item.Links.IconUri}} icon-type={{vm.defaultIconType}} ng-if=item.IconName></smb-icon> <md-grid-tile-footer> <h3>{{item.FolderName}}</h3> </md-grid-tile-footer> </div> </md-grid-tile> </md-grid-list> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	var path = 'components/contentTypesSearch/contentTypesSearch.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\" ng-if=\"vm.contentTypesSearchDS.contentTypes.length > 0\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"item in vm.contentTypesSearchDS.contentTypes\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ui-sref=\"search.contentTypeGroups.contentTypes.search({ typeId: item.FolderId })\"> <div layout=row layout-align=\"center center\"> <smb-icon class=smb-app__tile--icon icon-name={{item.IconName}} icon-uri={{item.Links.IconUri}} icon-type={{vm.defaultIconType}} ng-if=item.IconName></smb-icon> <md-grid-tile-footer> <h3>{{item.FolderName}}</h3> </md-grid-tile-footer> </div> </md-grid-tile> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ui-sref=search.contentTypeGroups.contentTypes.groupSearch> <md-icon class=material-icons>search</md-icon> <div layout=row layout-align=\"center center\"> <md-grid-tile-footer> <h3>All Document Types</h3> </md-grid-tile-footer> </div> </md-grid-tile> </md-grid-list> </div> </md-content> <md-content ng-if=\"vm.contentTypesSearchDS.contentTypes.length === 0\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">warning</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>No document types available</translate></h2> <p class=smb-app__empty-state-description><translate>Types you have access to will be listed here.</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	var path = 'components/contentUpload/contentUpload.template.html';
	var html = "<form class=\"has-bottom-buttons1 smb-app__content-upload\" layout-fill name=indexForm layout-gt-sm=column layout-align-gt-sm=\"start stretch\"> <div flex-gt-sm layout=row layout-align=\"start start\"> <div flex-gt-xs=50 flex layout=column layout-align=\"start stretch\"> <md-list> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Document Type</translate> </md-subheader> <md-list-item class=md-2-line> <smb-icon class=md-avatar icon-name={{vm.contentTypeDS.contentType.IconName}} icon-uri={{vm.contentTypeDS.contentType.Links.IconUri}} icon-type={{vm.defaultIconType}}></smb-icon> <div class=md-list-item-text> <h3>{{vm.contentTypeDS.contentType.FolderName}}</h3> <p>{{vm.contentTypeGroupDS.contentTypeGroup.LibraryName}}</p> </div> </md-list-item> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Document</translate> </md-subheader> <md-list-item layout=row layout-align=\"start center\"> <p ng-if=vm.filename flex class=ellipsis>{{vm.filename}}</p> <p ng-if=!vm.filename flex class=ellipsis><translate>No file selected</translate></p> <md-button class=\"md-secondary md-raised\" ng-click=vm.onFileInputClick($event)> <translate>Browse</translate> <input style=position:absolute;top:0;left:0;min-height:100%;min-width:100%;opacity:0;cursor:pointer type=file name=indexFile onchange=angular.element(this).scope().vm.indexFileChanged(this) /> </md-button> </md-list-item> </md-list> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Index Types</translate> </md-subheader> <smb-indexes indextypes=vm.indexTypesDS.indexTypes></smb-indexes> </div> </div> <div layout=row class=md-padding layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button ui-sref=\"import.contentTypeGroups.contentTypes({groupId: vm.contentTypeGroupId})\"> <translate>Cancel</translate> </md-button> <md-button flex-order-xs=-1 class=md-raised ng-click=vm.upload()> <translate>Upload</translate> </md-button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	var path = 'components/documentContextMenu/documentContextMenu.template.html';
	var html = "<div class=smb-app__document-view-header layout-fill layout=row layout-align=\"end center\"> <div class=smb-app__document-view-header__edit-info hide-xs hide-sm ng-if=!vm.documentDS.canEditStatus> <md-tooltip> <translate>You do not have the required permissions to edit the status.</translate> </md-tooltip> <md-icon class=material-icons>info_outline</md-icon> </div> <div class=\"smb-app__document-view-header-wrap smb-app-animate--fade-in\" ng-if=\"vm.documentDS.canEditStatus && !vm.loading\" layout=row layout-align=\"center end\"> <div class=\"smb-app__document-view-header-detail md-grid-tile {{0 | colorFilter}}\" ng-click=vm.changeStatus($event)> <div layout=row layout-align=\"start center\"> <md-icon class=material-icons>{{vm.status.StatusType === 'Content Status' ? 'archive' : 'assignment'}}</md-icon> <h3 flex>{{vm.status.Label}}</h3> </div> </div> <div class=\"smb-app__document-view-header-detail md-grid-tile {{1 | colorFilter}} smb-app-animate--scale-in\" ng-if=\"vm.status.StatusType === 'ToDo Status'\" ng-click=vm.changeAssingedUser($event)> <div layout=row layout-align=\"start center\"> <md-icon class=material-icons>account_circle</md-icon> <h3 ng-if=!vm.assignedUser flex translate>Unassigned</h3> <h3 ng-if=vm.assignedUser flex>{{vm.assignedUser.UserName}}</h3> </div> </div> </div> <span flex></span> <div layout=row layout-align=\"start center\" hide-xs hide-sm> <span flex hide-xs hide-sm></span> <md-button class=md-icon-button ng-if=vm.documentDS.hasFullRights ng-click=vm.deleteDocument($event)> <md-tooltip md-delay=800> <translate>Delete</translate> </md-tooltip> <md-icon class=material-icons>delete</md-icon> </md-button> <md-button class=md-icon-button ng-if=vm.documentDS.canEditStatus ng-href={{vm.documentDS.document.Embedded.Document.Embedded.LatestFile.Links.Content}}> <md-tooltip md-delay=800> <translate>Download</translate> </md-tooltip> <md-icon class=material-icons>get_app</md-icon> </md-button> <md-button class=md-icon-button ng-click=vm.detailsPanelDS.toggle(vm.detailsPanelDS.fieldPanel)> <md-tooltip md-delay=800> <translate>View Fields</translate> </md-tooltip> <md-icon class=material-icons>vpn_key</md-icon> </md-button> <md-button class=md-icon-button ng-click=vm.detailsPanelDS.toggle(vm.detailsPanelDS.historyPanel)> <md-tooltip md-delay=800> <translate>View History</translate> </md-tooltip> <md-icon class=material-icons>info</md-icon> </md-button> <md-button class=md-icon-button ng-click=vm.detailsPanelDS.toggle(vm.detailsPanelDS.commentsPanel)> <md-tooltip md-delay=800> <translate>View Comments</translate> </md-tooltip> <md-icon class=material-icons>chat_bubble</md-icon> </md-button> </div> <div hide show-xs show-sm> <md-menu class=smb-app__document-details-menu md-position-mode=\"target-right target\"> <md-button class=md-icon-button md-menu-origin aria-label=\"{{::'Open document info menu' | translate}}\" ng-click=$mdOpenMenu($event)> <md-icon class=material-icons>more_vertical</md-icon> </md-button> <md-menu-content> <md-menu-item ng-show=vm.documentDS.hasFullRights> <md-button ng-click=vm.deleteDocument($event) aria-label=\"{{::'Delete Document' | translate}}\"> <md-icon class=material-icons>delete</md-icon> <translate>Delete</translate> </md-button> </md-menu-item> <md-menu-item class=mobile-download ng-show=vm.documentDS.canEditStatus> <md-button ng-href={{vm.documentDS.document.Embedded.Document.Embedded.LatestFile.Links.Content}} aria-label=\"{{::'Download Document' | translate}}\"> <md-icon class=material-icons>get_app</md-icon> <translate>Download</translate> </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=vm.detailsPanelDS.toggle(vm.detailsPanelDS.fieldPanel) aria-label=\"{{::'View Fields' | translate}}\"> <md-icon class=material-icons>vpn_key</md-icon> <translate>Fields</translate> </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=vm.detailsPanelDS.toggle(vm.detailsPanelDS.historyPanel) aria-label=\"{{::'View History' | translate}}\"> <md-icon class=material-icons>info</md-icon> <translate>History</translate> </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=vm.detailsPanelDS.toggle(vm.detailsPanelDS.commentsPanel) aria-label=\"{{::'View Comments' | translate}}\"> <md-icon class=material-icons>chat_bubble</md-icon> <translate>Comments</translate> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	var path = 'components/documentDetails/documentDetails.template.html';
	var html = "<div layout-fill> <smb-document-indexes ng-if=vm.detailsDS.showFieldPanel document-group-id={{vm.documentGroupId}} document-type-id={{vm.documentTypeId}} document-id={{vm.documentId}}></smb-document-indexes> <smb-document-indexes-edit ng-if=vm.detailsDS.showFieldEdit document-group-id={{vm.documentGroupId}} document-type-id={{vm.documentTypeId}} document-id={{vm.documentId}}></smb-document-indexes-edit> <smb-document-history ng-if=vm.detailsDS.showHistory document-type-id={{vm.documentTypeId}} document-id={{vm.documentId}}></smb-document-history> <smb-document-notes ng-if=vm.detailsDS.showComments document-id={{vm.documentId}}></smb-document-notes> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	var path = 'components/documentHistory/documentHistory.template.html';
	var html = "<section class=\"smb-app__document-history-list smb-app__document-side-panel\" layout=column layout-align=\"start stretch\"> <header> <h1><translate>Document Details</translate></h1> </header> <md-tabs flex md-selected=vm.activeTab> <md-tab label=\"{{::'History' | translate}}\"> <md-content layout-fill> <md-list class=md-dense layout-fill layout=column layout-align=\"start strecth\"> <md-virtual-repeat-container flex> <md-list-item class=\"md-3-line md-long-text\" md-virtual-repeat=\"item in vm.documentHistoryDS.history\"> <div class=md-list-item-text layout=column> <p> <span class=history-username>{{item.UserName}}</span> {{item.Message}} <i>{{item.ActivityDate}}</i> </p> </div> <md-divider></md-divider> </md-list-item> </md-virtual-repeat-container> </md-list> </md-content> </md-tab> <md-tab label=\"{{::'Revisions'|translate}}\"> <md-content layout-fill layout=column layout-align=\"start strecth\"> <md-list layout=column layout-align=\"start strecth\" flex> <md-virtual-repeat-container flex> <md-list-item class=md-3-line md-virtual-repeat=\"revision in vm.docRevisions | orderBy:'DateCreated':true \"> <div class=md-list-item-text> <h3> <translate translate-comment=\"{{revision.VersionNumber}} expands to a numeric value representing the version. {{revision.CreatedBy}} expands to a user name or 'You' if it is the current user.\"> Revision {{revision.VersionNumber}} uploaded by <strong>{{revision.CreatedBy}}</strong> </translate> </h3> <h4> <translate>Added on {{revision.DateCreated | date }}</translate> </h4> <p layout=row layout-align=start> <a ng-if=vm.documentDS.canEditStatus ng-href={{revision.Links.ContentUri}} class=smb-app__document-revision-action translate>Download</a> <a ng-if=\"vm.documentDS.canEditStatus && !vm.isLatest(revision)\" href=# class=smb-app__document-revision-action ng-click=\"vm.promoteRevision($event, revision)\" translate>Make Current</a> <span ng-if=vm.isLatest(revision) class=smb-app__document-current-revision translate>Current Revision</span> </p> </div> <md-divider></md-divider> </md-list-item> </md-virtual-repeat-container> </md-list> <div layout=row layout-align=\"end end\" ng-hide=!vm.documentDS.canEditStatus> <button id=revisionUpload class=\"md-button md-primary md-raised new-revision-button\" translate> Add Revision <input id=revisionInput accept={{vm.extension}} type=file onchange=angular.element(this).scope().vm.uploadRevision(this)> </button> </div> </md-content> </md-tab> </md-tabs> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	var path = 'components/documentHitList/documentHitList.template.html';
	var html = "<md-content layout-fill ng-if=\"vm.documents.length > 0\"> <md-list class=app--list-no-padding layout-fill layout=column layout-align=\"start stretch\"> <md-virtual-repeat-container md-top-index=vm.documentIndex flex> <div md-virtual-repeat=\"doc in vm.documents\"> <md-list-item class=md-3-line layout=row layout-align=\"center center\" ng-click=vm.onClick(doc)> <smb-icon class=md-avatar icon-uri={{doc.Links.FolderIconUri}} icon-type=SVG></smb-icon> <div class=md-list-item-text layout=column> <h3 class=ellipsis>{{doc.LibraryName}} / {{doc.FolderName}}</h3> <h4>{{doc.DocumentAutoName}}</h4> <p>{{doc.Status}}</p> </div> </md-list-item> <md-divider></md-divider> </div> </md-virtual-repeat-container> </md-list> </md-content> <md-content ng-if=\"vm.documents.length < 1\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">search</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>No documents found!</translate></h2> <p class=smb-app__empty-state-description><translate>Try widening your search or using different criteria.</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	var path = 'components/documentIndexes/documentIndexes.template.html';
	var html = "<section class=\"smb-app__document-indexes-list smb-app__document-side-panel\"> <header> <h1 translate>Fields</h1> </header> <md-list> <md-list-item class=\"panel-item--padding md-2-line\" ng-repeat=\"tag in vm.indexDS.indexValues\"> <div class=md-list-item-text layout=column> <h3>{{tag.TagTypeName}}:</h3> <h4 ng-if=!tag.isDate>{{tag.Tags[0]}}</h4> <h4 ng-if=tag.isDate>{{tag.Tags[0] | date: 'MMM dd, yyyy'}}</h4> </div> <md-divider></md-divider> </md-list-item> </md-list> <div layout=row layout-align=\"end end\" ng-if=vm.documentDS.canEditFields> <md-button class=md-raised ng-click=vm.documentDetailsDS.toggle(vm.documentDetailsDS.fieldEditPanel)> <translate>Edit</translate> </md-button> </div> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	var path = 'components/documentIndexesEdit/documentIndexesEdit.template.html';
	var html = "<section class=\"smb-app__document-indexes--edit smb-app__document-side-panel\"> <header> <h1 translate>Edit Fields</h1> </header> <smb-indexes indextypes=vm.indexes status=vm.fieldsStatus></smb-indexes> <div layout=row layout-align=\"end end\"> <md-button ng-click=vm.documentDetailsDS.toggle(vm.documentDetailsDS.fieldPanel)> <translate>Cancel</translate> </md-button> <md-button class=md-raised ng-disabled=!vm.fieldsStatus.isValid ng-click=vm.saveIndexes()> <translate>Update</translate> </md-button> </div> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	var path = 'components/documentNotes/documentNotes.template.html';
	var html = "<section class=\"smb-app__document-side-panel smb-app-doc-comments\" layout=column layout-align=\"start stretch\" ng-show=vm.loaded> <header> <h1 class=smb-app-doc-comments__header translate>Comments</h1> </header> <div class=smb-app-doc-comments__comment-list flex layout=column layout-align=\"start stretch\" style=\"overflow-y:auto;padding:0 10px\"> <span flex></span> <div class=smb-app-doc-comments__comment-wrap flex=none ng-repeat=\"note in vm.notesDS.notes | orderBy: 'date'\" layout=column layout-align=\"start stretch\"> <div class=\"smb-app-doc-comments__comment smb-app-doc-comments__comment--my-comment\" ng-if=\"note.userName === vm.authService.displayName\"> <div class=smb-app-doc-comments__comment-date> {{note.date | sbSimpleDateTimeString}} </div> <div class=\"smb-app-doc-comments__comment-text md-whiteframe-1dp\"> <p ng-bind-html=\"note.text | lineBreak | trustHTML\"></p> </div> </div> <div class=smb-app-doc-comments__comment ng-if=\"note.userName !== vm.authService.displayName\"> <div class=smb-app-doc-comments__comment-date> {{note.date | sbSimpleDateTimeString}} </div> <div layout=row> <md-icon class=\"material-icons smb-app-doc-comment__comment-avatar\">account_circle</md-icon> <div flex class=\"smb-app-doc-comments__comment-text md-whiteframe-1dp\"> <h3 class=smb-app-doc-comments__comment-author>{{note.userName}}</h3> <p ng-bind-html=\"note.text | lineBreak | trustHTML\"></p> </div> </div> </div> </div> </div> <div class=\"smb-app-doc-add-comment md-padding\"> <div class=smb-app-doc-add-comment__wrap layout-fill> <textarea div class=smb-app-doc-add-comment__input ng-model=vm.newCommentText layout-fill spellcheck=true rows=1 placeholder=\"Add comment\" md-autofocus></textarea> <md-button aria-label=\"Add Comment\" class=\"md-icon-button smb-app-doc-add-comment__add-button app-animate--scale-in\" ng-click=vm.postComment() ng-if=\"vm.newCommentText !== ''\"> <md-icon class=material-icons>add</md-icon> </md-button> </div> </div> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	var path = 'components/documentView/documentView.template.html';
	var html = "<div class=smb-app-document-view layout-fill layout=column layout-align=\"start stretch\"> <smb-document-context-menu document-group-id={{vm.documentGroupId}} document-type-id={{vm.documentTypeId}} document-id={{vm.documentId}}></smb-document-context-menu> <px-scroll-viewer class=smb-app__viewer ng-class=\"{'smb-app__viewer--details-open': vm.panelDetailsDS.isOpenInline}\" flex layout=column layout-align=\"start stretch\" pages=vm.docPages fit-size=height></px-scroll-viewer> <md-sidenav class=\"md-sidenav-right smb-app-details-panel\" ng-class=\"{'smb-app-details-panel--inline-open': vm.panelDetailsDS.isOpenInline}\" md-component-id=item-details-panel md-is-open=vm.panelDetailsDS.isOpen md-swipe-right=\"vm.panelDetailsDS.isOpen = false\"> <div class=smb-app-details-panel__main> <md-button aria-label=\"Close Details\" show-gt-sm hide class=\"md-icon-button smb-app-details-panel__close\" ng-click=vm.panelDetailsDS.reset()> <md-icon class=material-icons>close</md-icon> </md-button> <smb-document-details document-group-id={{vm.documentGroupId}} document-type-id={{vm.documentTypeId}} document-id={{vm.documentId}}></smb-document-details> </div> </md-sidenav> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	var path = 'components/errorMessages.html';
	var html = "<div ng-message=required translate>This field is required.</div> <div ng-message=minlength translate>Your field is too short</div> <div ng-message=maxlength translate>Your field is too long</div> <div ng-message=email translate>You must supply a valid email address.</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	var path = 'components/home/home.template.html';
	var html = "<div flex layout-fill class=smb-app-main ng-class=\"{'small-screen':vm.media('xs')}\"> <md-grid-list layout-fill md-cols=2 md-cols-gt-xs=3 md-row-height=1:1 md-gutter=24px md-gutter-xs=8> <md-grid-tile class=\"{{$index | colorFilter}} smb-tile\" ng-repeat=\"item in vm.items\" ui-sref={{item.state}} md-rowspan=1 md-colspan=1 md-colspan-sm=1> <md-icon class=material-icons>{{item.icon}}</md-icon> <h3 class=\"smb-tile__title ellipsis\">{{vm.media('gt-xs') ? item.label : item.shortLabel}}</h3> <div ng-if=item.isTodoList class=\"smb-app-animate--scale-in smb-app--background-red smb-app-inbox-count\">{{vm.todoListDS.count}}</div> </md-grid-tile> </md-grid-list> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	var path = 'components/icon/icon.template.html';
	var html = "<span class=smb-app__icon ng-show=\"vm.iconData && !vm.iconData.isBinary\" ng-bind-html=vm.iconData.data></span>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	var path = 'components/indexTypeConfig/indexTypeConfig.template.html';
	var html = "<md-content class=smb-app__index-type-config layout=column layout-align=\"start stretch\" layout-fill> <section flex=none layout=row layout-align=\"start start\"> <div flex-gt-md=50 flex layout=column layou-align=\"start stretch\"> <md-subheader class=\"md-no-sticky md-accent\"><translate>Add New Field</translate></md-subheader> <div layout=column layout-gt-xs=row layout-align=start layout-margin> <md-input-container flex> <label> <translate>Field Type</translate> </label> <md-select ng-model=vm.newIndexType.dataType> <md-option ng-value=dt ng-repeat=\"dt in vm.dataTypes\">{{dt.label}}</md-option> </md-select> </md-input-container> <md-input-container flex> <label> <translate>Name</translate> </label> <input type=text ng-model=vm.newIndexType.name> </md-input-container> <md-input-container flex ng-if=\"vm.newIndexType.dataType.val < 0 || vm.newIndexTypeDataType.val > 2\"> <label> <translate>Default Value</translate> </label> <input type=text disabled=disabled> </md-input-container> <md-input-container flex ng-if=\"vm.newIndexType.dataType.val == vm.smbIndexTypeDataTypes.NUMERIC\"> <label> <translate>Default Value</translate> </label> <input type=number step=0.1 ng-model=vm.newIndexType.defaultValue> </md-input-container> <md-input-container flex ng-if=\"vm.newIndexType.dataType.val == vm.smbIndexTypeDataTypes.STRING\"> <label> <translate>Default Value</translate> </label> <input type=text ng-model=vm.newIndexType.defaultValue md-maxlength=vm.smbIndexTypeDataTypes.STRING_MAX_LENGTH maxlength={{vm.smbIndexTypeDataTypes.STRING_MAX_LENGTH}}> </md-input-container> <md-input-container flex ng-if=\"vm.newIndexType.dataType.val == vm.smbIndexTypeDataTypes.DATE\"> <label> <translate>Default Value</translate> </label> <input type=text value=\"Not supported for dates\" disabled=disabled> </md-input-container> <div layout=row layout-align=\"start start\" layout-align-xs=\"end start\"> <md-button class=\"smb-app__index-type-config--add-form__button md-icon-button\" ng-click=vm.addIndexType()> <md-icon class=material-icons>add</md-icon> </md-button> <div> </div> </div> </div></div></section> <md-divider ng-if=\"vm.indexTypesPool && vm.indexTypesPool.length\"></md-divider> <section flex=none layout=row layout-align=\"start start\" ng-if=\"vm.indexTypesPool && vm.indexTypesPool.length\"> <div flex-gt-md=50 flex layout=column layou-align=\"start stretch\"> <md-subheader class=\"md-no-sticky md-accent\">{{vm.indexTypesPoolTitle}}</md-subheader> <div layout=column layout-align=start> <div flex class=smb-app__index-type-config--edit-form__row ng-class=\"{'edit-form__row--first': $index === 0}\" ng-repeat=\"item in vm.indexTypesPool\" layout-margin layout=row> <md-input-container flex class=md-input-has-placeholder> <label ng-if=\"$index === 0\"> <translate>Field Type</translate> </label> <input value={{vm.smbIndexTypeDataTypes[item.DataType]}} disabled=disabled> </md-input-container> <md-input-container flex class=md-input-has-placeholder> <label ng-if=\"$index === 0\"> <translate>Name</translate> </label> <input ng-model=item.TagTypeName disabled=disabled> </md-input-container> <md-input-container flex class=md-input-has-placeholder> <label ng-if=\"$index === 0\"> <translate>Default Value</translate> </label> <input ng-model=item.Constraints.DefaultValue disabled=disabled> </md-input-container> <md-button class=\"smb-app__index-type-config--inline-form__button md-icon-button\" ng-click=vm.addFromPool($index)> <md-icon class=material-icons>add</md-icon> <md-tooltip md-direction=left md-delay=800>{{vm.indexTypesPoolAddLabel}}</md-tooltip> </md-button> </div> </div> </div> </section> <md-divider></md-divider> <section flex=none layout=row layout-align=\"start start\"> <div flex-gt-md=50 flex layout=column layou-align=\"start stretch\"> <md-subheader class=\"md-accent md-no-sticky\">{{vm.currentIndexTypesTitle}}</md-subheader> <div md-top-index=vm.itemIndex md-auto-shrink=false flex=1> <div class=smb-app__index-type-config--edit-form__row ng-class=\"{'edit-form__row--first': $index === 0}\" ng-repeat=\"item in vm.currentIndexTypes\" layout-margin layout=column layout-gt-xs=row layout-align=start> <md-input-container flex class=md-input-has-placeholder> <label ng-if=\"$index === 0\"> <translate>Field Type</translate> </label> <input value={{vm.smbIndexTypeDataTypes[item.DataType]}} disabled=disabled> </md-input-container> <md-input-container flex class=md-input-has-placeholder> <label ng-if=\"$index === 0\"> <translate>Name</translate> </label> <input ng-model=item.TagTypeName ng-disabled=\"vm.active !== $index || !vm.allowEditName\"> </md-input-container> <md-input-container flex class=md-input-has-placeholder ng-class=\"{'inactive': vm.active !== $index}\" ng-if=\"item.DataType === vm.smbIndexTypeDataTypes.STRING\"> <label ng-if=\"$index === 0\"> <translate>Default Value</translate> </label> <input type=text ng-model=item.Constraints.DefaultValue ng-disabled=\"vm.active !== $index || !vm.allowEditDefaultValue\" md-maxlength=vm.smbIndexTypeDataTypes.STRING_MAX_LENGTH maxlength={{vm.smbIndexTypeDataTypes.STRING_MAX_LENGTH}}> </md-input-container> <md-input-container flex class=md-input-has-placeholder ng-class=\"{'inactive': vm.active !== $index}\" ng-if=\"item.DataType === vm.smbIndexTypeDataTypes.NUMERIC\"> <label ng-if=\"$index === 0\"> <translate>Default Value</translate> </label> <input type=number step=0.1 ng-model=item.Constraints.DefaultValue ng-disabled=\"vm.active !== $index || !vm.allowEditDefaultValue\"> </md-input-container> <md-input-container flex class=md-input-has-placeholder ng-class=\"{'inactive': vm.active !== $index}\" ng-if=\"item.DataType === vm.smbIndexTypeDataTypes.DATE\"> <label ng-if=\"$index === 0\"> <translate>Default Value</translate> </label> <input type=text value=\"Not supported for dates\" disabled=disabled> </md-input-container> <div layout=row layout-align=\"start start\" layout-align-xs=\"end start\"> <md-button class=\"smb-app__index-type-config--inline-form__button activate-edit md-icon-button\" ng-hide=\"vm.active === $index\" ng-click=vm.setActive($index) ng-if=vm.allowEdit ng-disabled=\"item.DataType === vm.smbIndexTypeDataTypes.DATE && !vm.allowEditName\"> <md-icon class=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"smb-app__index-type-config--inline-form__button edit md-icon-button\" ng-hide=\"vm.active !== $index\" ng-click=vm.saveEdit() ng-if=vm.allowEdit> <md-icon class=material-icons>check</md-icon> </md-button> <md-button class=\"smb-app__index-type-config--inline-form__button edit md-icon-button\" ng-hide=\"vm.active !== $index\" ng-click=vm.cancelEdit() ng-if=vm.allowEdit> <md-icon class=material-icons>clear</md-icon> </md-button> <md-button class=\"smb-app__index-type-config--inline-form__button activate-edit md-icon-button\" ng-hide=\"vm.active === $index\" ng-click=vm.remove($index) ng-if=vm.allowDelete> <md-icon class=material-icons>delete</md-icon> </md-button> <div ng-if=vm.enableSequencing> <md-button class=md-icon-button ng-if=\"$index > 0\" ng-click=\"vm.swapIndexTypesOrder($index, $index-1)\"> <md-icon class=material-icons>arrow_upward</md-icon> <md-tooltip md-direction=left md-delay=800> <translate>Move up in sequence</translate> </md-tooltip> </md-button> <md-button class=md-icon-button ng-if=\"$index < vm.currentIndexTypes.length - 1\" ng-click=\"vm.swapIndexTypesOrder($index, $index+1)\"> <md-icon class=material-icons>arrow_downward</md-icon> <md-tooltip md-direction=left md-delay=800> <translate>Move down in sequence</translate> </md-tooltip> </md-button> </div> </div> </div> </div> </div> </section> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	var path = 'components/indexTypesPanel/indexTypesPanel.template.html';
	var html = "<form name=vm.fieldsForm> <md-list> <div ng-repeat=\"index in vm.indextypes\"> <md-subheader class=md-no-sticky>{{index.TagTypeName}}</md-subheader> <md-list-item> <md-input-container ng-if=\"index.DataType == vm.dataTypes.STRING\" class=md-block md-no-float style=width:100%;margin-top:0;margin-bottom:0> <input name=field-{{index.TagTypeName}} ng-model=index.indexValue ng-init=\"index.indexValue = index.defaultValue\" type=text placeholder=\"{{::'Enter Value' | translate}}\" ng-pattern=vm.stringFieldRegex md-maxlength=vm.dataTypes.STRING_MAX_LENGTH maxlength={{vm.dataTypes.STRING_MAX_LENGTH}}> <div ng-messages=\"vm.fieldsForm['field-' + index.TagTypeName].$error\"> <div ng-message=pattern> <span> <translate>Please remove invalid characters.</translate><br/> ( &quot;&lt;&gt;|^*:! ) </span> </div> </div> </md-input-container> <md-input-container ng-if=\"index.DataType == vm.dataTypes.NUMERIC\" class=md-block md-no-float style=width:100%;margin-top:0;margin-bottom:0> <input name=field-{{index.TagTypeName}} ng-model=index.indexValue ng-init=\"index.indexValue = index.defaultValue\" type=number placeholder=\"{{::'Enter Value' | translate}}\" step=0.1> <div ng-messages=\"vm.fieldsForm['field-' + index.TagTypeName].$error\"> <div ng-message=valid>Please enter a valid number.</div> </div> </md-input-container> <div ng-if=\"index.DataType == vm.dataTypes.DATE\" style=width:100%;margin-top:0;margin-bottom:0> <md-datepicker name=field-{{index.TagTypeName}} ng-model=index.indexValue ng-init=\"index.indexValue = index.defaultValue\" md-placeholder=\"{{:: 'Enter Date' | translate}}\"></md-datepicker> <div class=md-error ng-messages=\"vm.fieldsForm['field-' + index.TagTypeName].$error\"> <div ng-message=valid>Please enter a valid date.</div> </div> </div> </md-list-item> </div> </md-list> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	var path = 'components/itemSelector/itemSelector.template.html';
	var html = "<div ng-if=\"vm.items.length=== 0\" layout-fill layout=column layout-align=\"center center\" class=smb-item-selector__empty> <md-icon class=\"material-icons smb-item-selector__empty-icon\">error</md-icon> <p translate>No available items</p> </div> <md-content ng-if=\"vm.items.length> 0\" class=main-selector layout=row> <smb-grid-list flex latyout=column layout-align=\"start stretch\"> <md-virtual-repeat-container md-orient-horizontal flex layout-fill ng-if=vm.items[0].IconId> <div class=smb-scroll-item-wrapper md-virtual-repeat=\"item in vm.items\"> <smb-grid-tile class=\"{{$index | colorFilter}} smb-scroll-item\" layout=column layout-align=\"start stretch\" ng-class=\"{'selected':item.selected}\" ng-click=vm.toggleSelection(item)> <div flex layout=column layout-align=\"center center\"> <smb-icon class=smb-app__tile--icon icon-name={{item.IconUserFriendlyName}} icon-uri={{item.IconUri}} icon-type={{item.IconExtension}}></smb-icon> <div class=smb-item-selector__indicator layout=column layout-align=\"center center\"> <md-icon class=material-icons>done</md-icon> </div> </div> <smb-grid-tile-footer> <h3>{{item.IconUserFriendlyName}}</h3> </smb-grid-tile-footer> </smb-grid-tile> </div> </md-virtual-repeat-container> <md-virtual-repeat-container md-orient-horizontal flex layout-fill ng-if=vm.items[0].StatusType> <div class=smb-scroll-item-wrapper md-virtual-repeat=\"item in vm.items\"> <smb-grid-tile class=\"{{$index | colorFilter}} smb-scroll-item\" layout=column layout-align=\"start stretch\" ng-class=\"{'selected':item.selected}\" ng-click=vm.toggleSelection(item)> <div flex layout=column layout-align=\"center center\"> <md-icon class=\"smb-app__tile--icon material-icons\" ng-if=\"item.StatusType === 'clear'\">clear</md-icon> <md-icon class=\"smb-app__tile--icon material-icons\" ng-if=\"item.StatusType === 'ToDo Status'\">assignment</md-icon> <md-icon class=\"smb-app__tile--icon material-icons\" ng-if=\"item.StatusType === 'Content Status'\">archive</md-icon> <div class=smb-item-selector__indicator> <md-icon class=material-icons>done</md-icon> </div> </div> <smb-grid-tile-footer> <h3>{{item.Label}}</h3> </smb-grid-tile-footer> </smb-grid-tile> </div> </md-virtual-repeat-container> <md-virtual-repeat-container md-orient-horizontal flex layout-fill ng-if=\"vm.items[0].UserGroupId || vm.items[0].UserName\"> <div class=smb-scroll-item-wrapper md-virtual-repeat=\"item in vm.items\"> <smb-grid-tile class=\"{{$index | colorFilter}} smb-scroll-item\" layout=column layout-align=\"start stretch\" ng-class=\"{'smb-user-tile':item.UserName, 'selected':item.selected}\" ng-click=vm.toggleSelection(item)> <div flex layout=column layout-align=\"center center\"> <md-icon ng-if=item.UserName class=\"material-icons smb-app__tile--icon\">account_circle</md-icon> <md-icon ng-if=item.UserGroupName class=\"material-icons smb-app__tile--icon\">supervisor_account</md-icon> <div class=smb-item-selector__indicator> <md-icon class=material-icons>done</md-icon> </div> </div> <smb-grid-tile-footer layout=column layout-align=\"center stretch\"> <div class=smb-scroll-item__footer-content> <h3 class=ellipsis>{{item.UserName ? item.UserName : item.UserGroupName}}</h3> <span ng-if=item.UserName class=ellipsis>{{item.EmailAddress}}</span> <div> </div></div></smb-grid-tile-footer> </smb-grid-tile> </div> </md-virtual-repeat-container> </smb-grid-list> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	var path = 'components/login/login.template.html';
	var html = "<px-login title=AirBase> <header-icon><div class=smb-login-icon></div></header-icon> </px-login> <footer class=smb-app-footer layout=column layout-gt-xs=row layout-align=\"start center\"> <md-button target=_blank href=./acceptable-use-policy> <translate>Acceptable Use Policy</translate> </md-button> <md-button target=_blank href=./privacy-policy> <translate>Privacy Policy</translate> </md-button> <md-button target=_blank href=./terms-of-use-and-subscription> <translate>Terms of Use</translate> </md-button> </footer> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	var path = 'components/register/register.template.html';
	var html = "<md-content class=smb-app--background layout-fill layout=row layout-align-gt-xs=\"center center\" layout-align=\"start stretch\"> <md-card class=smb-registration layout=column layout-align=\"start stretch\"> <md-card-content class=smb-registration__content flex=80> <iframe ng-src=\"{{vm.pxEnvironmentService.legalLanguage === 'en' ?  './terms-of-use-and-subscription/index.html' : './'+vm.pxEnvironmentService.legalLanguage+'/terms-of-use-and-subscription/index.html'}}\"></iframe> </md-card-content> <md-card-actions layout=column layout-gt-sm=row layout-align=\"center stretch\" layout-align-gt-sm=\"space-between center\" flex=20> <md-checkbox ng-model=vm.agreeToTerms aria-label=\"{{::'Enable the checkbox to agree to the AirBase terms of use' | translate}}\"> {{::'I agree to the terms and conditions on behalf of my ogranization' | translate}} </md-checkbox> <md-button class=md-raised ng-disabled=!vm.agreeToTerms ui-sref=\"loginRegister({ deploymentId: vm.deploymentId, auth: vm.authToken })\"> <translate>Next</translate> </md-button> </md-card-actions> </md-card> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	var path = 'components/status/status.template.html';
	var html = "<md-subheader class=\"md-no-sticky md-accent\"> <translate>Document Status</translate> </md-subheader> <div class=md-padding> <md-input-container class=md-block md-no-float style=width:100%;margin-top:0;margin-bottom:0> <md-select ng-model=vm.status placeholder=\"{{::'Select Status' | translate}}\" md-on-close=vm.onStatusSelected()> <md-option value={{null}}> <em translate>None</em> </md-option> <md-divider></md-divider> <md-option ng-repeat=\"status in vm.todoStatuses\" value={{status}}>{{status.indexValue}}</md-option> <md-divider></md-divider> <md-subheader ng-if=\"vm.contentStatuses && vm.contentStatuses.length\"> <translate>Archival Status</translate> </md-subheader> <md-option ng-repeat=\"status in vm.contentStatuses\" value={{status}}>{{status.indexValue}}</md-option> </md-select> </md-input-container> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	var path = 'components/statusConfig/statusConfig.template.html';
	var html = "<md-content class=smb-app__status-config layout=column layout-align=\"start stretch\" layout-fill> <md-subheader class=\"md-no-sticky md-accent\"> <translate>To-Do Status</translate> </md-subheader> <div flex=none class=md-padding layout=column layout-align=\"start stretch\"> <md-chips ng-model=vm.todoStatuses md-transform-chip=vm.checkExistingStatuses($chip) placeholder=\"{{::'Enter To-Do Status' | translate }}\" md-enable-chip-edit=true readonly=vm.readonly md-on-add=vm.onAddToDoStatus($chip) md-on-remove=vm.onDeleteToDoStatus($chip) secondary-placeholder=\"{{::'+To-Do Status' | translate}}\"> </md-chips> </div> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Archival Status</translate> </md-subheader> <div flex=none class=md-padding layout=column layout-align=\"start stretch\"> <md-chips ng-model=vm.contentStatuses md-transform-chip=vm.checkExistingStatuses($chip) placeholder=\"{{::'Enter Archival Status' | translate}}\" md-enable-chip-edit=true readonly=vm.readonly md-on-add=vm.onAddContentStatus($chip) md-on-remove=vm.onDeleteContentStatus($chip) secondary-placeholder=\"{{::'+Archival Status' | translate}}\"> </md-chips> </div> <section class=md-padding> <strong translate>Note: deleted statuses will not be removed from existing documents.</strong> </section> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	var path = 'components/todolist/todolist.template.html';
	var html = "<div ng-if=\"vm.toDoListDS.documents.length > 0\" layout-fill> <smb-to-do-list-context-menu></smb-to-do-list-context-menu> <smb-document-hit-list documents=vm.toDoListDS.documents view-on-select=true></smb-document-hit-list> </div> <md-content ng-if=\"vm.toDoListDS.documents.length === 0\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">assignment_turned_in</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>You're all caught up!</translate></h2> <p class=smb-app__empty-state-description><translate>Items assigned to you will appear here.</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	var path = 'components/todolistContextMenu/todolistContextMenu.template.html';
	var html = "<div class=smb-app__document-view-header layout-fill layout=row layout-align=\"center center\"> <span flex hide-xs hide-sm></span> <div layout=row layout-align=\"end center\"> <md-button class=md-raised ng-click=vm.sortByDate()> <translate>Date</translate> <md-icon class=\"material-icons ng-scope\" ng-show=\"vm.dateAscending && vm.dateActive\">arrow_drop_up</md-icon> <md-icon class=\"material-icons ng-scope\" ng-show=\"vm.dateDescending && vm.dateActive\">arrow_drop_down</md-icon> </md-button> <md-button class=md-raised ng-click=vm.sortByType()> <translate>Group / Type</translate> <md-icon class=\"material-icons ng-scope\" ng-show=\"vm.typeAscending && vm.typeActive\">arrow_drop_up</md-icon> <md-icon class=\"material-icons ng-scope\" ng-show=\"vm.typeDescending && vm.typeActive\">arrow_drop_down</md-icon> </md-button> <md-button class=md-raised ng-click=vm.sortByStatus()> <translate>Status</translate> <md-icon class=\"material-icons ng-scope\" ng-show=\"vm.statusAscending && vm.statusActive\">arrow_drop_up</md-icon> <md-icon class=\"material-icons ng-scope\" ng-show=\"vm.statusDescending && vm.statusActive\">arrow_drop_down</md-icon> </md-button> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	var path = 'components/trash/trash.template.html';
	var html = "<md-content ng-if=\"vm.deletedItemsDS.adminTrash.length > 0\" layout-fill layout=column layout-align=\"start stretch\"> <div class=trash-header layout=row layout-align=\"end center\"> <md-button ng-click=vm.purgeAll($event)> <translate>Empty Trash</translate> </md-button> </div> <md-list layout=column layou-align=\"start stretch\" flex> <md-virtual-repeat-container flex> <div md-virtual-repeat=\"trashPiece in vm.deletedItemsDS.adminTrash\"> <md-divider></md-divider> <md-list-item class=md-3-line> <smb-icon class=md-avatar ng-if=trashPiece.icon.uri icon-name={{trashPiece.icon.name}} icon-uri={{trashPiece.icon.uri}} icon-type=SVG></smb-icon> <div class=md-list-item-text> <h3 class=ellipsis>{{trashPiece.name}}</h3> <p class=ellipsis translate-params-date=\"trashPiece.deleted | date : 'mediumDate'\" translate-comment=\"Values between double braces will become a date and name, respectively.\" translate>Deleted {{date}} by {{trashPiece.deletedBy}}</p> </div> <md-button class=\"md-icon-button md-secondary\" ng-click=vm.restore(trashPiece)> <md-icon class=material-icons>restore_page</md-icon> </md-button> <md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.purge($event, trashPiece)\"> <md-icon class=material-icons>delete_forever</md-icon> </md-button> </md-list-item> </div> </md-virtual-repeat-container> </md-list> </md-content> <md-content ng-if=\"vm.deletedItemsDS.adminTrash.length === 0\" layout-fill layout=column layout-align=\"center stretch\"> <div class=smb-app__empty-state-wrap flex layout=column layout-align=\"center center\"> <div class=smb-app__empty-state layout=column layout-align=\"center center\"> <div class=smb-app__empty-state-bg> <md-icon class=\"material-icons smb-app__empty-state-bg-icon\">delete</md-icon> </div> <h2 class=smb-app__empty-state-title><translate>Trash is empty</translate></h2> <p class=smb-app__empty-state-description><translate>When users delete items they'll appear here</translate></p> </div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	var path = 'components/user/user.template.html';
	var html = "<form name=f layout=column layout-align=\"start stretch\" ng-submit=vm.submitForm() ng-cloak layout-fill> <div role=alert class=\"app__background sba-form-errors\" ng-if=vm.errorMessage> <md-subheader class=\"md-warn app__background sba-form-errors__message\" ng-if=vm.errorMessage>{{vm.errorMessage}}</md-subheader> </div> <md-content class=sb-admin-user__content flex-gt-xs layout-gt-xs=column layout-align-gt-xs=\"start stretch\" ng-class=\"{'sb-admin-user---margin-bottom':vm.toastVisible}\"> <div class=md-padding> <md-input-container class=md-block> <label> <translate>Display Name</translate> </label> <input type=text required name=displayname ng-model=vm.smbUserDataStore.user.UserName> <div ng-messages=f.displayname.$error ng-if=f.displayname.$touched role=alert> <div ng-messages-include=errorMessages.html></div> </div> </md-input-container> <md-input-container class=md-block> <label> <translate>E-mail Address</translate> </label> <input type=email required name=emailAddress ng-model=vm.smbUserDataStore.user.EmailAddress> <div ng-messages=f.emailAddress.$error ng-if=f.emailAddress.$touched role=alert> <div ng-messages-include=errorMessages.html></div> </div> </md-input-container> <md-input-container class=md-block ng-if=!vm.userId> <label> <translate>Password</translate> </label> <input type=password required name=newpassword ng-model=vm.smbUserDataStore.user.Password> <div ng-messages=f.newpassword.$error ng-if=f.newpassword.$touched role=alert> <div ng-messages-include=errorMessages.html></div> </div> </md-input-container> <md-input-container class=md-block ng-if=!vm.userId> <label> <translate>Verify Password</translate> </label> <input type=password required name=newpasswordverify ng-model=vm.VerifyPassword> <div ng-messages=f.newpasswordverify.$error ng-if=f.newpasswordverify.$touched role=alert> <div ng-messages-include=errorMessages.html></div> </div> </md-input-container> </div> <md-list> <div ng-if=vm.userId> <md-divider></md-divider> <md-subheader class=\"md-accent md-no-sticky\"> <translate>User Settings</translate> </md-subheader> <md-list-item class=md-with-secondary> <md-icon class=\"md-avatar material-icons sba-list-avatar\">lock</md-icon> <p> <translate>Lock Account</translate> </p> <md-switch class=md-secondary ng-model=vm.smbUserDataStore.user.IsLocked ng-change=vm.updateUserLock()></md-switch> </md-list-item> </div> <md-divider></md-divider> <md-subheader class=\"md-accent md-no-sticky\"> <translate>User Roles</translate> </md-subheader> <md-list-item class=\"md-3-line md-with-secondary\"> <md-icon class=\"md-avatar material-icons sba-list-avatar\">settings</md-icon> <div class=\"md-list-item-text sb-admin-invite---list-with-action\"> <h3> <translate>Site Administrator</translate> </h3> <p> <translate>Allow users to control features of this deployment such as document groups.</translate> </p> </div> <md-switch class=md-secondary ng-model=vm.smbUserDataStore.isSiteAdmin></md-switch> </md-list-item> <md-divider hide show-xs class=sb-admin-user__role-divider></md-divider> <md-list-item class=\"md-3-line md-with-secondary\" ng-disabled=vm.smbUserDataStore.isSiteAdmin> <md-icon class=\"md-avatar material-icons sba-list-avatar\">people</md-icon> <div class=\"md-list-item-text sb-admin-invite---list-with-action\"> <h3> <translate>User Administrator</translate> </h3> <p> <translate>Allow users to add/edit/delete users and groups for this deployment.</translate> </p> </div> <md-switch class=md-secondary ng-model=vm.smbUserDataStore.isUserAdmin ng-disabled=vm.smbUserDataStore.isSiteAdmin></md-switch> </md-list-item> </md-list> <span flex-gt-xs></span> <div class=md-padding layout=row layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button flex-order-xs=1 ui-sref=^>{{::'Cancel' | translate}}</md-button> <md-button type=submit class=md-raised ng-if=vm.userId>{{::'Update' | translate}}</md-button> <md-button type=submit class=md-raised ng-if=!vm.userId>{{::'Create' | translate}}</md-button> </div> </md-content> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	var path = 'components/userAdmin/userAdmin.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\"> <div flex layout-fill style=position:relative;overflow-y:auto class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile class=\"{{0 | colorFilter}}\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ui-sref=useradmin.home.usergroups> <md-icon class=material-icons>people</md-icon> <md-grid-tile-footer> <h3 translate>User Groups</h3> </md-grid-tile-footer> </md-grid-tile> <md-grid-tile class=\"{{1 | colorFilter}}\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ui-sref=useradmin.home.users> <md-icon class=material-icons>person</md-icon> <md-grid-tile-footer> <h3 translate>Users</h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	var path = 'components/userGroup/userGroup.template.html';
	var html = "<form flex name=userGroupForm layout=column layout-align=\"start stretch\" ng-submit=vm.save()> <div role=alert class=\"app__background sba-form-errors\" ng-if=vm.errorMessage> <md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\">{{vm.errorMessage}}</md-subheader> </div> <md-content flex-gt-xs layout-gt-xs=column layout-align-gt-xs=\"start stretch\"> <div class=md-padding> <md-input-container class=md-block> <label translate>User Group Name</label> <input name=name ng-model=vm.userGroupDS.userGroup.UserGroupName required maxlength=50> <div ng-messages=userGroupForm.name.$error role=alert multiple=multiple> <div ng-message=required translate>You must supply a User Group name.</div> <div ng-message=md-maxlength class=my-message translate> Your name must be less than 50 characters. </div> </div> </md-input-container> </div> <md-subheader class=\"md-no-sticky md-accent\"> <translate>Assigned Users</translate> </md-subheader> <div flex class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=vm.addUsers($event)> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile class=\"{{$index | colorFilter}} smb-user-tile\" ng-repeat=\"user in vm.userGroupDS.userGroup.Embedded.Users\" md-rowspan=1 md-colspan=1 md-colspan-sm=1> <md-button class=\"md-icon-button config-button\" ng-click=vm.removeUser(user)> <md-icon class=material-icons>clear</md-icon> </md-button> <md-icon class=material-icons>account_circle</md-icon> <md-grid-tile-footer> <h3 class=ellipsis>{{user.UserName}}</h3> <span class=ellipsis>{{user.EmailAddress}}</span> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> <div class=md-padding layout=row layout-align=\"end center\" layout-xs=column layout-align-xs=\"start stretch\"> <md-button ui-sref=^> <translate>Cancel</translate> </md-button> <md-button type=submit flex-order-xs=-1 class=md-raised> <translate ng-if=vm.userGroupDS.userGroup.UserGroupId>Update</translate> <translate ng-if=!vm.userGroupDS.userGroup.UserGroupId>Create</translate> </md-button> </div> </md-content> </form> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	var path = 'components/userGroups/userGroups.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=vm.addUserGroup()> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile class=\"{{$index | colorFilter}}\" ng-repeat=\"group in vm.userGroupDS.userGroups\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-click=vm.editUserGroup(group)> <md-icon class=material-icons>supervisor_account</md-icon> <md-grid-tile-footer> <h3 layout=row layout-align=\"start center\">{{group.UserGroupName}}<span flex></span><span>{{group.UserCount}}</span></h3> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	var path = 'components/users/users.template.html';
	var html = "<md-content layout-fill ng-cloak layout=column layout-align=\"start start\"> <div flex layout-fill class=grid-list-container> <md-grid-list md-cols=2 md-cols-sm=4 md-cols-md=5 md-cols-gt-md=8 md-row-height-gt-md=1:1 md-row-height=4:3 md-gutter=8px> <md-grid-tile md-rowspan=1 md-colspan=1 md-colspan-sm=1 class=title-add-holder ng-click=vm.createUser()> <md-icon class=material-icons>add</md-icon> </md-grid-tile> <md-grid-tile class=\"{{$index | colorFilter}} smb-user-tile\" ng-repeat=\"user in vm.smbUsersDataStore.users\" md-rowspan=1 md-colspan=1 md-colspan-sm=1 ng-click=vm.editUser(user)> <md-icon class=material-icons ng-if=user.IsLocked>lock</md-icon> <md-icon class=material-icons ng-if=!user.IsLocked>account_circle</md-icon> <md-grid-tile-footer> <h3 class=ellipsis>{{user.UserName}}</h3> <span class=ellipsis>{{user.EmailAddress}}</span> </md-grid-tile-footer> </md-grid-tile> </md-grid-list> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ })
]);


// WEBPACK FOOTER //
// app.650bfc.min.js